import React from "react";

const Map = (props) => {
  return (
    <svg
      {...props}
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 555 284.5"
    >
      <path
        className="st0"
        fill="inherit"
        d="M0,142.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S0,140.7,0,142.2z"
      />
      <path
        className="st0"
        d="M6,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C7.3,135.9,6,137.2,6,138.7z"
      />
      <path
        className="st0"
        d="M12,142.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S12,140.7,12,142.2z"
      />
      <path
        className="st0"
        d="M12,135.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S12,133.7,12,135.3z"
      />
      <path
        className="st0"
        d="M12,128.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S12,126.7,12,128.3z"
      />
      <path
        className="st0"
        d="M18.1,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
	C19.3,135.9,18.1,137.2,18.1,138.7z"
      />
      <path
        className="st0"
        d="M6,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C7.3,129,6,130.2,6,131.8z"
      />
      <path
        className="st0"
        d="M6,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C7.3,142.9,6,144.2,6,145.7z"
      />
      <path
        className="st0"
        d="M24.1,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C25.4,132.5,24.1,133.7,24.1,135.3z"
      />
      <path
        className="st0"
        d="M24.1,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C25.4,139.4,24.1,140.7,24.1,142.2z"
      />
      <path
        className="st0"
        d="M30.2,138.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S30.2,137.2,30.2,138.7z"
      />
      <path
        className="st0"
        d="M36.2,142.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S36.2,140.7,36.2,142.2z"
      />
      <path
        className="st0"
        d="M42.2,138.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,137.2,42.2,138.7z"
      />
      <path
        className="st0"
        d="M30.2,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S30.2,144.2,30.2,145.7z"
      />
      <path
        className="st0"
        d="M42.2,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,144.2,42.2,145.7z"
      />
      <path
        className="st0"
        d="M12,149.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S12,147.6,12,149.2z"
      />
      <path
        className="st0"
        d="M36.2,149.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S36.2,147.6,36.2,149.2z"
      />
      <g>
        <path
          className="st0"
          d="M368.2,124.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,123.3,368.2,124.8z"
        />
        <path
          className="st0"
          d="M368.2,117.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,116.3,368.2,117.8z"
        />
        <path
          className="st0"
          d="M368.2,131.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,130.2,368.2,131.8z"
        />
        <path
          className="st0"
          d="M368.2,152.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,151.1,368.2,152.7z"
        />
        <path
          className="st0"
          d="M368.2,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,144.2,368.2,145.7z"
        />
        <path
          className="st0"
          d="M368.2,138.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,137.2,368.2,138.7z"
        />
        <path
          className="st0"
          d="M368.2,96.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,95.4,368.2,96.9z"
        />
        <path
          className="st0"
          d="M368.2,83c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,81.4,368.2,83z"
        />
        <path
          className="st0"
          d="M368.2,159.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,158.1,368.2,159.7z"
        />
        <path
          className="st0"
          d="M368.2,110.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,109.3,368.2,110.9z"
        />
        <path
          className="st0"
          d="M374.3,93.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,91.9,374.3,93.4z"
        />
        <path
          className="st0"
          d="M368.2,89.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,88.4,368.2,89.9z"
        />
        <path
          className="st0"
          d="M368.2,103.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,102.3,368.2,103.9z"
        />
        <path
          className="st0"
          d="M368.2,250.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,248.7,368.2,250.3z"
        />
        <path
          className="st0"
          d="M368.2,236.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,234.8,368.2,236.3z"
        />
        <path
          className="st0"
          d="M368.2,215.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S368.2,213.9,368.2,215.4z"
        />
        <path
          className="st0"
          d="M368.2,222.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,220.8,368.2,222.4z"
        />
        <path
          className="st0"
          d="M368.2,229.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,227.8,368.2,229.4z"
        />
        <path
          className="st0"
          d="M368.2,257.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,255.7,368.2,257.2z"
        />
        <path
          className="st0"
          d="M368.2,243.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S368.2,241.8,368.2,243.3z"
        />
        <path
          className="st0"
          d="M374.3,100.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,98.9,374.3,100.4z"
        />
        <path
          className="st0"
          d="M368.2,201.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,199.9,368.2,201.5z"
        />
        <path
          className="st0"
          d="M368.2,180.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,179,368.2,180.6z"
        />
        <path
          className="st0"
          d="M368.2,187.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,186,368.2,187.5z"
        />
        <path
          className="st0"
          d="M368.2,208.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S368.2,206.9,368.2,208.4z"
        />
        <path
          className="st0"
          d="M368.2,173.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,172,368.2,173.6z"
        />
        <path
          className="st0"
          d="M368.2,194.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,193,368.2,194.5z"
        />
        <path
          className="st0"
          d="M368.2,166.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S368.2,165.1,368.2,166.6z"
        />
        <path
          className="st0"
          d="M374.3,86.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,84.9,374.3,86.5z"
        />
        <path
          className="st0"
          d="M374.3,239.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,238.3,374.3,239.8z"
        />
        <path
          className="st0"
          d="M374.3,253.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,252.2,374.3,253.8z"
        />
        <path
          className="st0"
          d="M374.3,107.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,105.8,374.3,107.4z"
        />
        <path
          className="st0"
          d="M374.3,218.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,217.4,374.3,218.9z"
        />
        <path
          className="st0"
          d="M374.3,205c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S374.3,203.4,374.3,205z"
        />
        <path
          className="st0"
          d="M374.3,246.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,245.2,374.3,246.8z"
        />
        <path
          className="st0"
          d="M374.3,225.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S374.3,224.3,374.3,225.9z"
        />
        <path
          className="st0"
          d="M374.3,211.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,210.4,374.3,211.9z"
        />
        <path
          className="st0"
          d="M404.5,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C405.7,205.6,404.5,206.9,404.5,208.4z"
        />
        <path
          className="st0"
          d="M404.5,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,198.7,404.5,199.9,404.5,201.5z"
        />
        <path
          className="st0"
          d="M404.5,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C405.7,66.2,404.5,67.5,404.5,69
		z"
        />
        <path
          className="st0"
          d="M404.5,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,191.7,404.5,193,404.5,194.5z"
        />
        <path
          className="st0"
          d="M404.5,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,184.7,404.5,186,404.5,187.5z"
        />
        <path
          className="st0"
          d="M404.5,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,219.6,404.5,220.8,404.5,222.4z"
        />
        <path
          className="st0"
          d="M374.3,232.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,231.3,374.3,232.8z"
        />
        <path
          className="st0"
          d="M374.3,135.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,133.7,374.3,135.3z"
        />
        <path
          className="st0"
          d="M374.3,142.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S374.3,140.7,374.3,142.2z"
        />
        <path
          className="st0"
          d="M374.3,128.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,126.7,374.3,128.3z"
        />
        <path
          className="st0"
          d="M374.3,114.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,112.8,374.3,114.3z"
        />
        <path
          className="st0"
          d="M374.3,121.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,119.8,374.3,121.3z"
        />
        <path
          className="st0"
          d="M374.3,149.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,147.7,374.3,149.2z"
        />
        <path
          className="st0"
          d="M374.3,170.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S374.3,168.6,374.3,170.1z"
        />
        <path
          className="st0"
          d="M374.3,177.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S374.3,175.5,374.3,177.1z"
        />
        <path
          className="st0"
          d="M374.3,184.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S374.3,182.5,374.3,184.1z"
        />
        <path
          className="st0"
          d="M374.3,191c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S374.3,189.5,374.3,191z"
        />
        <path
          className="st0"
          d="M374.3,156.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S374.3,154.6,374.3,156.2z"
        />
        <path
          className="st0"
          d="M374.3,198c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S374.3,196.4,374.3,198z"
        />
        <path
          className="st0"
          d="M374.3,163.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S374.3,161.6,374.3,163.1z"
        />
        <path
          className="st0"
          d="M404.5,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C405.7,212.6,404.5,213.9,404.5,215.4z"
        />
        <path
          className="st0"
          d="M356.2,152.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,151.1,356.2,152.7z"
        />
        <path
          className="st0"
          d="M356.2,194.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,193,356.2,194.5z"
        />
        <path
          className="st0"
          d="M356.2,180.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,179,356.2,180.6z"
        />
        <path
          className="st0"
          d="M356.2,159.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,158.1,356.2,159.7z"
        />
        <path
          className="st0"
          d="M356.2,201.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,199.9,356.2,201.5z"
        />
        <path
          className="st0"
          d="M356.2,166.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,165.1,356.2,166.6z"
        />
        <path
          className="st0"
          d="M356.2,173.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,172,356.2,173.6z"
        />
        <path
          className="st0"
          d="M356.2,187.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,186,356.2,187.5z"
        />
        <path
          className="st0"
          d="M356.2,236.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,234.8,356.2,236.3z"
        />
        <path
          className="st0"
          d="M356.2,229.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,227.8,356.2,229.4z"
        />
        <path
          className="st0"
          d="M356.2,208.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S356.2,206.9,356.2,208.4z"
        />
        <path
          className="st0"
          d="M356.2,243.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S356.2,241.8,356.2,243.3z"
        />
        <path
          className="st0"
          d="M356.2,215.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S356.2,213.9,356.2,215.4z"
        />
        <path
          className="st0"
          d="M356.2,222.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,220.8,356.2,222.4z"
        />
        <path
          className="st0"
          d="M356.2,124.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,123.3,356.2,124.8z"
        />
        <path
          className="st0"
          d="M350.1,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,104.6,350.1,105.8,350.1,107.4z"
        />
        <path
          className="st0"
          d="M356.2,264.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,262.7,356.2,264.2z"
        />
        <path
          className="st0"
          d="M356.2,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,144.2,356.2,145.7z"
        />
        <path
          className="st0"
          d="M356.2,96.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,95.4,356.2,96.9z"
        />
        <path
          className="st0"
          d="M350.1,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,111.5,350.1,112.8,350.1,114.3z"
        />
        <path
          className="st0"
          d="M350.1,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,97.6,350.1,98.9,350.1,100.4z"
        />
        <path
          className="st0"
          d="M356.2,89.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,88.4,356.2,89.9z"
        />
        <path
          className="st0"
          d="M356.2,131.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,130.2,356.2,131.8z"
        />
        <path
          className="st0"
          d="M356.2,138.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,137.2,356.2,138.7z"
        />
        <path
          className="st0"
          d="M356.2,257.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,255.7,356.2,257.2z"
        />
        <path
          className="st0"
          d="M356.2,110.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,109.3,356.2,110.9z"
        />
        <path
          className="st0"
          d="M356.2,117.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,116.3,356.2,117.8z"
        />
        <path
          className="st0"
          d="M356.2,103.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,102.3,356.2,103.9z"
        />
        <path
          className="st0"
          d="M362.2,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,230,362.2,231.3,362.2,232.8z"
        />
        <path
          className="st0"
          d="M362.2,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,146.4,362.2,147.7,362.2,149.2z"
        />
        <path
          className="st0"
          d="M362.2,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C363.5,139.4,362.2,140.7,362.2,142.2z"
        />
        <path
          className="st0"
          d="M362.2,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C363.5,174.3,362.2,175.5,362.2,177.1z"
        />
        <path
          className="st0"
          d="M362.2,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C363.5,153.4,362.2,154.6,362.2,156.2z"
        />
        <path
          className="st0"
          d="M362.2,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C363.5,167.3,362.2,168.6,362.2,170.1z"
        />
        <path
          className="st0"
          d="M362.2,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C363.5,160.3,362.2,161.6,362.2,163.1z"
        />
        <path
          className="st0"
          d="M362.2,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,132.5,362.2,133.7,362.2,135.3z"
        />
        <path
          className="st0"
          d="M362.2,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,97.6,362.2,98.9,362.2,100.4z"
        />
        <path
          className="st0"
          d="M362.2,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,104.6,362.2,105.8,362.2,107.4z"
        />
        <path
          className="st0"
          d="M356.2,250.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S356.2,248.7,356.2,250.3z"
        />
        <path
          className="st0"
          d="M362.2,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,118.5,362.2,119.8,362.2,121.3z"
        />
        <path
          className="st0"
          d="M362.2,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,111.5,362.2,112.8,362.2,114.3z"
        />
        <path
          className="st0"
          d="M362.2,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,125.5,362.2,126.7,362.2,128.3z"
        />
        <path
          className="st0"
          d="M362.2,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,83.7,362.2,84.9,362.2,86.5z"
        />
        <path
          className="st0"
          d="M362.2,246.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,244,362.2,245.2,362.2,246.8z"
        />
        <path
          className="st0"
          d="M362.2,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,237,362.2,238.3,362.2,239.8z"
        />
        <path
          className="st0"
          d="M362.2,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,90.6,362.2,91.9,362.2,93.4z"
        />
        <path
          className="st0"
          d="M362.2,253.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,251,362.2,252.2,362.2,253.8z"
        />
        <path
          className="st0"
          d="M362.2,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C363.5,76.7,362.2,77.9,362.2,79.5z
		"
        />
        <path
          className="st0"
          d="M362.2,260.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,257.9,362.2,259.2,362.2,260.7z"
        />
        <path
          className="st0"
          d="M362.2,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,216.1,362.2,217.4,362.2,218.9z"
        />
        <path
          className="st0"
          d="M362.2,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C363.5,223.1,362.2,224.3,362.2,225.9z"
        />
        <path
          className="st0"
          d="M362.2,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C363.5,188.2,362.2,189.5,362.2,191z
		"
        />
        <path
          className="st0"
          d="M362.2,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C363.5,202.2,362.2,203.4,362.2,205z
		"
        />
        <path
          className="st0"
          d="M362.2,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,195.2,362.2,196.4,362.2,198z"
        />
        <path
          className="st0"
          d="M362.2,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C363.5,181.2,362.2,182.5,362.2,184.1z"
        />
        <path
          className="st0"
          d="M362.2,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C363.5,209.1,362.2,210.4,362.2,211.9z"
        />
        <path
          className="st0"
          d="M386.3,177.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S386.3,175.5,386.3,177.1z"
        />
        <path
          className="st0"
          d="M398.4,149.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S398.4,147.7,398.4,149.2z"
        />
        <path
          className="st0"
          d="M398.4,142.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S398.4,140.7,398.4,142.2z"
        />
        <path
          className="st0"
          d="M398.4,156.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S398.4,154.6,398.4,156.2z"
        />
        <path
          className="st0"
          d="M398.4,121.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S398.4,119.8,398.4,121.3z"
        />
        <path
          className="st0"
          d="M398.4,135.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S398.4,133.7,398.4,135.3z"
        />
        <path
          className="st0"
          d="M398.4,163.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S398.4,161.6,398.4,163.1z"
        />
        <path
          className="st0"
          d="M398.4,128.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S398.4,126.7,398.4,128.3z"
        />
        <path
          className="st0"
          d="M398.4,170.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S398.4,168.6,398.4,170.1z"
        />
        <path
          className="st0"
          d="M398.4,205c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S398.4,203.4,398.4,205z"
        />
        <path
          className="st0"
          d="M398.4,114.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S398.4,112.8,398.4,114.3z"
        />
        <path
          className="st0"
          d="M398.4,211.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S398.4,210.4,398.4,211.9z"
        />
        <path
          className="st0"
          d="M398.4,198c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S398.4,196.4,398.4,198z"
        />
        <path
          className="st0"
          d="M398.4,177.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S398.4,175.5,398.4,177.1z"
        />
        <path
          className="st0"
          d="M398.4,191c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S398.4,189.5,398.4,191z"
        />
        <path
          className="st0"
          d="M386.3,225.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S386.3,224.3,386.3,225.9z"
        />
        <path
          className="st0"
          d="M386.3,198c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,196.4,386.3,198z"
        />
        <path
          className="st0"
          d="M398.4,225.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S398.4,224.3,398.4,225.9z"
        />
        <path
          className="st0"
          d="M386.3,232.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,231.3,386.3,232.8z"
        />
        <path
          className="st0"
          d="M386.3,239.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,238.3,386.3,239.8z"
        />
        <path
          className="st0"
          d="M386.3,205c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S386.3,203.4,386.3,205z"
        />
        <path
          className="st0"
          d="M386.3,211.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,210.4,386.3,211.9z"
        />
        <path
          className="st0"
          d="M386.3,218.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,217.4,386.3,218.9z"
        />
        <path
          className="st0"
          d="M386.3,246.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,245.2,386.3,246.8z"
        />
        <path
          className="st0"
          d="M398.4,93.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S398.4,91.9,398.4,93.4z"
        />
        <path
          className="st0"
          d="M398.4,100.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S398.4,98.9,398.4,100.4z"
        />
        <path
          className="st0"
          d="M398.4,86.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S398.4,84.9,398.4,86.5z"
        />
        <path
          className="st0"
          d="M386.3,253.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,252.2,386.3,253.8z"
        />
        <path
          className="st0"
          d="M386.3,260.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,259.2,386.3,260.7z"
        />
        <path
          className="st0"
          d="M398.4,107.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S398.4,105.8,398.4,107.4z"
        />
        <path
          className="st0"
          d="M392.4,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,149.9,392.4,151.1,392.4,152.7z"
        />
        <path
          className="st0"
          d="M392.4,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,135.9,392.4,137.2,392.4,138.7z"
        />
        <path
          className="st0"
          d="M392.4,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,156.8,392.4,158.1,392.4,159.7z"
        />
        <path
          className="st0"
          d="M392.4,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,142.9,392.4,144.2,392.4,145.7z"
        />
        <path
          className="st0"
          d="M392.4,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,177.8,392.4,179,392.4,180.6z"
        />
        <path
          className="st0"
          d="M392.4,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,163.8,392.4,165.1,392.4,166.6z"
        />
        <path
          className="st0"
          d="M392.4,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,170.8,392.4,172,392.4,173.6z"
        />
        <path
          className="st0"
          d="M392.4,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,129,392.4,130.2,392.4,131.8z"
        />
        <path
          className="st0"
          d="M392.4,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,94.1,392.4,95.4,392.4,96.9z"
        />
        <path
          className="st0"
          d="M392.4,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,108.1,392.4,109.3,392.4,110.9z"
        />
        <path
          className="st0"
          d="M392.4,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,101.1,392.4,102.3,392.4,103.9z"
        />
        <path
          className="st0"
          d="M392.4,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,184.7,392.4,186,392.4,187.5z"
        />
        <path
          className="st0"
          d="M392.4,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,115,392.4,116.3,392.4,117.8z"
        />
        <path
          className="st0"
          d="M392.4,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,122,392.4,123.3,392.4,124.8z"
        />
        <path
          className="st0"
          d="M392.4,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,219.6,392.4,220.8,392.4,222.4z"
        />
        <path
          className="st0"
          d="M392.4,257.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,254.4,392.4,255.7,392.4,257.2z"
        />
        <path
          className="st0"
          d="M392.4,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,87.1,392.4,88.4,392.4,89.9z"
        />
        <path
          className="st0"
          d="M392.4,250.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,247.5,392.4,248.7,392.4,250.3z"
        />
        <path
          className="st0"
          d="M380.3,55.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C381.6,52.3,380.3,53.5,380.3,55.1z
		"
        />
        <path
          className="st0"
          d="M398.4,58.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S398.4,57,398.4,58.6z"
        />
        <path
          className="st0"
          d="M392.4,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,191.7,392.4,193,392.4,194.5z"
        />
        <path
          className="st0"
          d="M392.4,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C393.6,240.5,392.4,241.8,392.4,243.3z"
        />
        <path
          className="st0"
          d="M404.5,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,177.8,404.5,179,404.5,180.6z"
        />
        <path
          className="st0"
          d="M392.4,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C393.6,205.6,392.4,206.9,392.4,208.4z"
        />
        <path
          className="st0"
          d="M392.4,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,198.7,392.4,199.9,392.4,201.5z"
        />
        <path
          className="st0"
          d="M392.4,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C393.6,212.6,392.4,213.9,392.4,215.4z"
        />
        <path
          className="st0"
          d="M392.4,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,226.6,392.4,227.8,392.4,229.4z"
        />
        <path
          className="st0"
          d="M392.4,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C393.6,233.5,392.4,234.8,392.4,236.3z"
        />
        <path
          className="st0"
          d="M398.4,218.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S398.4,217.4,398.4,218.9z"
        />
        <path
          className="st0"
          d="M392.4,48.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C393.6,45.3,392.4,46.6,392.4,48.1z
		"
        />
        <path
          className="st0"
          d="M404.5,41.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C405.7,38.3,404.5,39.6,404.5,41.1z
		"
        />
        <path
          className="st0"
          d="M380.3,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C381.6,240.5,380.3,241.8,380.3,243.3z"
        />
        <path
          className="st0"
          d="M380.3,250.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,247.5,380.3,248.7,380.3,250.3z"
        />
        <path
          className="st0"
          d="M380.3,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,233.5,380.3,234.8,380.3,236.3z"
        />
        <path
          className="st0"
          d="M404.5,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C405.7,80.2,404.5,81.4,404.5,83
		z"
        />
        <path
          className="st0"
          d="M380.3,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,226.6,380.3,227.8,380.3,229.4z"
        />
        <path
          className="st0"
          d="M380.3,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,94.1,380.3,95.4,380.3,96.9z"
        />
        <path
          className="st0"
          d="M380.3,257.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,254.4,380.3,255.7,380.3,257.2z"
        />
        <path
          className="st0"
          d="M380.3,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C381.6,212.6,380.3,213.9,380.3,215.4z"
        />
        <path
          className="st0"
          d="M380.3,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,191.7,380.3,193,380.3,194.5z"
        />
        <path
          className="st0"
          d="M386.3,191c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S386.3,189.5,386.3,191z"
        />
        <path
          className="st0"
          d="M380.3,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,184.7,380.3,186,380.3,187.5z"
        />
        <path
          className="st0"
          d="M380.3,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C381.6,205.6,380.3,206.9,380.3,208.4z"
        />
        <path
          className="st0"
          d="M380.3,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,219.6,380.3,220.8,380.3,222.4z"
        />
        <path
          className="st0"
          d="M404.5,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C405.7,73.2,404.5,74.5,404.5,76
		z"
        />
        <path
          className="st0"
          d="M404.5,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,108.1,404.5,109.3,404.5,110.9z"
        />
        <path
          className="st0"
          d="M404.5,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,156.8,404.5,158.1,404.5,159.7z"
        />
        <path
          className="st0"
          d="M404.5,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,135.9,404.5,137.2,404.5,138.7z"
        />
        <path
          className="st0"
          d="M404.5,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,142.9,404.5,144.2,404.5,145.7z"
        />
        <path
          className="st0"
          d="M404.5,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,149.9,404.5,151.1,404.5,152.7z"
        />
        <path
          className="st0"
          d="M404.5,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,163.8,404.5,165.1,404.5,166.6z"
        />
        <path
          className="st0"
          d="M404.5,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,170.8,404.5,172,404.5,173.6z"
        />
        <path
          className="st0"
          d="M404.5,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,129,404.5,130.2,404.5,131.8z"
        />
        <path
          className="st0"
          d="M404.5,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,101.1,404.5,102.3,404.5,103.9z"
        />
        <path
          className="st0"
          d="M404.5,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,94.1,404.5,95.4,404.5,96.9z"
        />
        <path
          className="st0"
          d="M380.3,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,177.8,380.3,179,380.3,180.6z"
        />
        <path
          className="st0"
          d="M404.5,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,115,404.5,116.3,404.5,117.8z"
        />
        <path
          className="st0"
          d="M404.5,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,87.1,404.5,88.4,404.5,89.9z"
        />
        <path
          className="st0"
          d="M404.5,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C405.7,122,404.5,123.3,404.5,124.8z"
        />
        <path
          className="st0"
          d="M380.3,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,198.7,380.3,199.9,380.3,201.5z"
        />
        <path
          className="st0"
          d="M386.3,128.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,126.7,386.3,128.3z"
        />
        <path
          className="st0"
          d="M386.3,121.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,119.8,386.3,121.3z"
        />
        <path
          className="st0"
          d="M386.3,135.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,133.7,386.3,135.3z"
        />
        <path
          className="st0"
          d="M386.3,107.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,105.8,386.3,107.4z"
        />
        <path
          className="st0"
          d="M386.3,114.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,112.8,386.3,114.3z"
        />
        <path
          className="st0"
          d="M386.3,142.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S386.3,140.7,386.3,142.2z"
        />
        <path
          className="st0"
          d="M386.3,170.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S386.3,168.6,386.3,170.1z"
        />
        <path
          className="st0"
          d="M386.3,100.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,98.9,386.3,100.4z"
        />
        <path
          className="st0"
          d="M350.1,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,118.5,350.1,119.8,350.1,121.3z"
        />
        <path
          className="st0"
          d="M386.3,184.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S386.3,182.5,386.3,184.1z"
        />
        <path
          className="st0"
          d="M386.3,156.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S386.3,154.6,386.3,156.2z"
        />
        <path
          className="st0"
          d="M386.3,149.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,147.7,386.3,149.2z"
        />
        <path
          className="st0"
          d="M386.3,163.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S386.3,161.6,386.3,163.1z"
        />
        <path
          className="st0"
          d="M380.3,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,129,380.3,130.2,380.3,131.8z"
        />
        <path
          className="st0"
          d="M380.3,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,142.9,380.3,144.2,380.3,145.7z"
        />
        <path
          className="st0"
          d="M380.3,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,135.9,380.3,137.2,380.3,138.7z"
        />
        <path
          className="st0"
          d="M380.3,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,149.9,380.3,151.1,380.3,152.7z"
        />
        <path
          className="st0"
          d="M380.3,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,163.8,380.3,165.1,380.3,166.6z"
        />
        <path
          className="st0"
          d="M380.3,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,156.8,380.3,158.1,380.3,159.7z"
        />
        <path
          className="st0"
          d="M380.3,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,170.8,380.3,172,380.3,173.6z"
        />
        <path
          className="st0"
          d="M380.3,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,108.1,380.3,109.3,380.3,110.9z"
        />
        <path
          className="st0"
          d="M386.3,93.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S386.3,91.9,386.3,93.4z"
        />
        <path
          className="st0"
          d="M380.3,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,122,380.3,123.3,380.3,124.8z"
        />
        <path
          className="st0"
          d="M386.3,51.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S386.3,50.1,386.3,51.6z"
        />
        <path
          className="st0"
          d="M386.3,58.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S386.3,57,386.3,58.6z"
        />
        <path
          className="st0"
          d="M380.3,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,115,380.3,116.3,380.3,117.8z"
        />
        <path
          className="st0"
          d="M380.3,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C381.6,101.1,380.3,102.3,380.3,103.9z"
        />
        <path
          className="st0"
          d="M344.1,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,122,344.1,123.3,344.1,124.8z"
        />
        <path
          className="st0"
          d="M332,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C333.3,129,332,130.2,332,131.8
		z"
        />
        <path
          className="st0"
          d="M332,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C333.3,115,332,116.3,332,117.8
		z"
        />
        <path
          className="st0"
          d="M332,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C333.3,122,332,123.3,332,124.8
		z"
        />
        <path
          className="st0"
          d="M332,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C333.3,108.1,332,109.3,332,110.9z"
        />
        <path
          className="st0"
          d="M332,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C333.3,87.1,332,88.4,332,89.9z"
        />
        <path
          className="st0"
          d="M332,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C333.3,94.1,332,95.4,332,96.9z"
        />
        <path
          className="st0"
          d="M332,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C333.3,101.1,332,102.3,332,103.9z"
        />
        <path
          className="st0"
          d="M332,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C333.3,163.8,332,165.1,332,166.6z"
        />
        <path
          className="st0"
          d="M326,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C327.2,237,326,238.3,326,239.8
		z"
        />
        <path
          className="st0"
          d="M332,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C333.3,135.9,332,137.2,332,138.7z"
        />
        <path
          className="st0"
          d="M332,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C333.3,156.8,332,158.1,332,159.7z"
        />
        <path
          className="st0"
          d="M332,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C333.3,170.8,332,172,332,173.6
		z"
        />
        <path
          className="st0"
          d="M332,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C333.3,149.9,332,151.1,332,152.7z"
        />
        <path
          className="st0"
          d="M332,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C333.3,142.9,332,144.2,332,145.7z"
        />
        <path
          className="st0"
          d="M326,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C327.2,230,326,231.3,326,232.8
		z"
        />
        <path
          className="st0"
          d="M326,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C327.2,174.3,326,175.5,326,177.1z"
        />
        <path
          className="st0"
          d="M326,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C327.2,181.2,326,182.5,326,184.1z"
        />
        <path
          className="st0"
          d="M326,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C327.2,167.3,326,168.6,326,170.1z"
        />
        <path
          className="st0"
          d="M326,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C327.2,160.3,326,161.6,326,163.1z"
        />
        <path
          className="st0"
          d="M326,246.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C327.2,244,326,245.2,326,246.8
		z"
        />
        <path
          className="st0"
          d="M326,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C327.2,188.2,326,189.5,326,191z"
        />
        <path
          className="st0"
          d="M326,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C327.2,153.4,326,154.6,326,156.2z"
        />
        <path
          className="st0"
          d="M326,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C327.2,195.2,326,196.4,326,198z"
        />
        <path
          className="st0"
          d="M326,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C327.2,223.1,326,224.3,326,225.9z"
        />
        <path
          className="st0"
          d="M332,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C333.3,177.8,332,179,332,180.6
		z"
        />
        <path
          className="st0"
          d="M326,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C327.2,216.1,326,217.4,326,218.9z"
        />
        <path
          className="st0"
          d="M326,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C327.2,202.2,326,203.4,326,205z"
        />
        <path
          className="st0"
          d="M326,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C327.2,209.1,326,210.4,326,211.9z"
        />
        <path
          className="st0"
          d="M319.9,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,142.9,319.9,144.2,319.9,145.7z"
        />
        <path
          className="st0"
          d="M319.9,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,129,319.9,130.2,319.9,131.8z"
        />
        <path
          className="st0"
          d="M326,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C327.2,146.4,326,147.7,326,149.2z"
        />
        <path
          className="st0"
          d="M319.9,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,122,319.9,123.3,319.9,124.8z"
        />
        <path
          className="st0"
          d="M319.9,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,94.1,319.9,95.4,319.9,96.9z"
        />
        <path
          className="st0"
          d="M319.9,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,101.1,319.9,102.3,319.9,103.9z"
        />
        <path
          className="st0"
          d="M319.9,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,115,319.9,116.3,319.9,117.8z"
        />
        <path
          className="st0"
          d="M319.9,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,108.1,319.9,109.3,319.9,110.9z"
        />
        <path
          className="st0"
          d="M319.9,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,135.9,319.9,137.2,319.9,138.7z"
        />
        <path
          className="st0"
          d="M319.9,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,177.8,319.9,179,319.9,180.6z"
        />
        <path
          className="st0"
          d="M319.9,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,184.7,319.9,186,319.9,187.5z"
        />
        <path
          className="st0"
          d="M319.9,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,170.8,319.9,172,319.9,173.6z"
        />
        <path
          className="st0"
          d="M319.9,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,156.8,319.9,158.1,319.9,159.7z"
        />
        <path
          className="st0"
          d="M319.9,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,149.9,319.9,151.1,319.9,152.7z"
        />
        <path
          className="st0"
          d="M319.9,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,163.8,319.9,165.1,319.9,166.6z"
        />
        <path
          className="st0"
          d="M332,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C333.3,191.7,332,193,332,194.5
		z"
        />
        <path
          className="st0"
          d="M319.9,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C321.2,66.2,319.9,67.5,319.9,69
		z"
        />
        <path
          className="st0"
          d="M332,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C333.3,219.6,332,220.8,332,222.4z"
        />
        <path
          className="st0"
          d="M332,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C333.3,205.6,332,206.9,332,208.4z"
        />
        <path
          className="st0"
          d="M332,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C333.3,226.6,332,227.8,332,229.4z"
        />
        <path
          className="st0"
          d="M332,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C333.3,184.7,332,186,332,187.5
		z"
        />
        <path
          className="st0"
          d="M332,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C333.3,198.7,332,199.9,332,201.5z"
        />
        <path
          className="st0"
          d="M332,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C333.3,212.6,332,213.9,332,215.4z"
        />
        <path
          className="st0"
          d="M319.9,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,191.7,319.9,193,319.9,194.5z"
        />
        <path
          className="st0"
          d="M332,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C333.3,240.5,332,241.8,332,243.3z"
        />
        <path
          className="st0"
          d="M319.9,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C321.2,80.2,319.9,81.4,319.9,83
		z"
        />
        <path
          className="st0"
          d="M319.9,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C321.2,59.3,319.9,60.5,319.9,62.1z
		"
        />
        <path
          className="st0"
          d="M319.9,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,87.1,319.9,88.4,319.9,89.9z"
        />
        <path
          className="st0"
          d="M332,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C333.3,233.5,332,234.8,332,236.3z"
        />
        <path
          className="st0"
          d="M319.9,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C321.2,73.2,319.9,74.5,319.9,76
		z"
        />
        <path
          className="st0"
          d="M301.8,246.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,245.2,301.8,246.8z"
        />
        <path
          className="st0"
          d="M301.8,239.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,238.3,301.8,239.8z"
        />
        <path
          className="st0"
          d="M307.9,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C309.1,73.2,307.9,74.5,307.9,76
		z"
        />
        <path
          className="st0"
          d="M307.9,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C309.1,66.2,307.9,67.5,307.9,69
		z"
        />
        <path
          className="st0"
          d="M301.8,232.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,231.3,301.8,232.8z"
        />
        <path
          className="st0"
          d="M301.8,218.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,217.4,301.8,218.9z"
        />
        <path
          className="st0"
          d="M307.9,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,122,307.9,123.3,307.9,124.8z"
        />
        <path
          className="st0"
          d="M307.9,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,101.1,307.9,102.3,307.9,103.9z"
        />
        <path
          className="st0"
          d="M307.9,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,108.1,307.9,109.3,307.9,110.9z"
        />
        <path
          className="st0"
          d="M301.8,211.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,210.4,301.8,211.9z"
        />
        <path
          className="st0"
          d="M307.9,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C309.1,80.2,307.9,81.4,307.9,83
		z"
        />
        <path
          className="st0"
          d="M307.9,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,115,307.9,116.3,307.9,117.8z"
        />
        <path
          className="st0"
          d="M307.9,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,94.1,307.9,95.4,307.9,96.9z"
        />
        <path
          className="st0"
          d="M307.9,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,87.1,307.9,88.4,307.9,89.9z"
        />
        <path
          className="st0"
          d="M301.8,225.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S301.8,224.3,301.8,225.9z"
        />
        <path
          className="st0"
          d="M301.8,142.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S301.8,140.7,301.8,142.2z"
        />
        <path
          className="st0"
          d="M301.8,135.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,133.7,301.8,135.3z"
        />
        <path
          className="st0"
          d="M301.8,156.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S301.8,154.6,301.8,156.2z"
        />
        <path
          className="st0"
          d="M301.8,149.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,147.7,301.8,149.2z"
        />
        <path
          className="st0"
          d="M301.8,121.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,119.8,301.8,121.3z"
        />
        <path
          className="st0"
          d="M301.8,205c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S301.8,203.4,301.8,205z"
        />
        <path
          className="st0"
          d="M301.8,128.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,126.7,301.8,128.3z"
        />
        <path
          className="st0"
          d="M301.8,191c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S301.8,189.5,301.8,191z"
        />
        <path
          className="st0"
          d="M301.8,184.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S301.8,182.5,301.8,184.1z"
        />
        <path
          className="st0"
          d="M301.8,198c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,196.4,301.8,198z"
        />
        <path
          className="st0"
          d="M301.8,170.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S301.8,168.6,301.8,170.1z"
        />
        <path
          className="st0"
          d="M301.8,163.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S301.8,161.6,301.8,163.1z"
        />
        <path
          className="st0"
          d="M350.1,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,125.5,350.1,126.7,350.1,128.3z"
        />
        <path
          className="st0"
          d="M307.9,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,156.8,307.9,158.1,307.9,159.7z"
        />
        <path
          className="st0"
          d="M307.9,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,129,307.9,130.2,307.9,131.8z"
        />
        <path
          className="st0"
          d="M326,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C327.2,69.7,326,71,326,72.5z"
        />
        <path
          className="st0"
          d="M326,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C327.2,76.7,326,77.9,326,79.5z"
        />
        <path
          className="st0"
          d="M307.9,250.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,247.5,307.9,248.7,307.9,250.3z"
        />
        <path
          className="st0"
          d="M307.9,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C309.1,240.5,307.9,241.8,307.9,243.3z"
        />
        <path
          className="st0"
          d="M307.9,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,233.5,307.9,234.8,307.9,236.3z"
        />
        <path
          className="st0"
          d="M326,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C327.2,90.6,326,91.9,326,93.4z"
        />
        <path
          className="st0"
          d="M326,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C327.2,62.7,326,64,326,65.5z"
        />
        <path
          className="st0"
          d="M326,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C327.2,125.5,326,126.7,326,128.3z"
        />
        <path
          className="st0"
          d="M326,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C327.2,132.5,326,133.7,326,135.3z"
        />
        <path
          className="st0"
          d="M326,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C327.2,118.5,326,119.8,326,121.3z"
        />
        <path
          className="st0"
          d="M326,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C327.2,111.5,326,112.8,326,114.3z"
        />
        <path
          className="st0"
          d="M326,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C327.2,97.6,326,98.9,326,100.4
		z"
        />
        <path
          className="st0"
          d="M326,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C327.2,104.6,326,105.8,326,107.4z"
        />
        <path
          className="st0"
          d="M307.9,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,226.6,307.9,227.8,307.9,229.4z"
        />
        <path
          className="st0"
          d="M307.9,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,149.9,307.9,151.1,307.9,152.7z"
        />
        <path
          className="st0"
          d="M326,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C327.2,139.4,326,140.7,326,142.2z"
        />
        <path
          className="st0"
          d="M307.9,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,170.8,307.9,172,307.9,173.6z"
        />
        <path
          className="st0"
          d="M307.9,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,163.8,307.9,165.1,307.9,166.6z"
        />
        <path
          className="st0"
          d="M307.9,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,142.9,307.9,144.2,307.9,145.7z"
        />
        <path
          className="st0"
          d="M307.9,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,135.9,307.9,137.2,307.9,138.7z"
        />
        <path
          className="st0"
          d="M307.9,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C309.1,212.6,307.9,213.9,307.9,215.4z"
        />
        <path
          className="st0"
          d="M307.9,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,177.8,307.9,179,307.9,180.6z"
        />
        <path
          className="st0"
          d="M307.9,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C309.1,205.6,307.9,206.9,307.9,208.4z"
        />
        <path
          className="st0"
          d="M307.9,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,219.6,307.9,220.8,307.9,222.4z"
        />
        <path
          className="st0"
          d="M307.9,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,198.7,307.9,199.9,307.9,201.5z"
        />
        <path
          className="st0"
          d="M307.9,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,191.7,307.9,193,307.9,194.5z"
        />
        <path
          className="st0"
          d="M307.9,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C309.1,184.7,307.9,186,307.9,187.5z"
        />
        <path
          className="st0"
          d="M301.8,177.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S301.8,175.5,301.8,177.1z"
        />
        <path
          className="st0"
          d="M313.9,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C315.2,181.2,313.9,182.5,313.9,184.1z"
        />
        <path
          className="st0"
          d="M313.9,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C315.2,160.3,313.9,161.6,313.9,163.1z"
        />
        <path
          className="st0"
          d="M313.9,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C315.2,167.3,313.9,168.6,313.9,170.1z"
        />
        <path
          className="st0"
          d="M338.1,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,230,338.1,231.3,338.1,232.8z"
        />
        <path
          className="st0"
          d="M313.9,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C315.2,188.2,313.9,189.5,313.9,191z
		"
        />
        <path
          className="st0"
          d="M313.9,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C315.2,202.2,313.9,203.4,313.9,205z
		"
        />
        <path
          className="st0"
          d="M313.9,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,195.2,313.9,196.4,313.9,198z"
        />
        <path
          className="st0"
          d="M313.9,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,209.1,313.9,210.4,313.9,211.9z"
        />
        <path
          className="st0"
          d="M313.9,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,125.5,313.9,126.7,313.9,128.3z"
        />
        <path
          className="st0"
          d="M313.9,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,111.5,313.9,112.8,313.9,114.3z"
        />
        <path
          className="st0"
          d="M313.9,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,118.5,313.9,119.8,313.9,121.3z"
        />
        <path
          className="st0"
          d="M313.9,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,146.4,313.9,147.7,313.9,149.2z"
        />
        <path
          className="st0"
          d="M313.9,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C315.2,139.4,313.9,140.7,313.9,142.2z"
        />
        <path
          className="st0"
          d="M313.9,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C315.2,153.4,313.9,154.6,313.9,156.2z"
        />
        <path
          className="st0"
          d="M313.9,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,132.5,313.9,133.7,313.9,135.3z"
        />
        <path
          className="st0"
          d="M313.9,58.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C315.2,55.8,313.9,57,313.9,58.6z"
        />
        <path
          className="st0"
          d="M332,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C333.3,66.2,332,67.5,332,69z"
        />
        <path
          className="st0"
          d="M301.8,30.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,29.1,301.8,30.7z"
        />
        <path
          className="st0"
          d="M313.9,44.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C315.2,41.8,313.9,43.1,313.9,44.6z
		"
        />
        <path
          className="st0"
          d="M307.9,48.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C309.1,45.3,307.9,46.6,307.9,48.1z
		"
        />
        <path
          className="st0"
          d="M332,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C333.3,73.2,332,74.5,332,76z"
        />
        <path
          className="st0"
          d="M319.9,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,198.7,319.9,199.9,319.9,201.5z"
        />
        <path
          className="st0"
          d="M313.9,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,230,313.9,231.3,313.9,232.8z"
        />
        <path
          className="st0"
          d="M313.9,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,216.1,313.9,217.4,313.9,218.9z"
        />
        <path
          className="st0"
          d="M313.9,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C315.2,223.1,313.9,224.3,313.9,225.9z"
        />
        <path
          className="st0"
          d="M313.9,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,237,313.9,238.3,313.9,239.8z"
        />
        <path
          className="st0"
          d="M313.9,253.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,251,313.9,252.2,313.9,253.8z"
        />
        <path
          className="st0"
          d="M313.9,246.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,244,313.9,245.2,313.9,246.8z"
        />
        <path
          className="st0"
          d="M313.9,260.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,257.9,313.9,259.2,313.9,260.7z"
        />
        <path
          className="st0"
          d="M313.9,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C315.2,174.3,313.9,175.5,313.9,177.1z"
        />
        <path
          className="st0"
          d="M313.9,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,104.6,313.9,105.8,313.9,107.4z"
        />
        <path
          className="st0"
          d="M350.1,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C351.4,174.3,350.1,175.5,350.1,177.1z"
        />
        <path
          className="st0"
          d="M350.1,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C351.4,181.2,350.1,182.5,350.1,184.1z"
        />
        <path
          className="st0"
          d="M350.1,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C351.4,188.2,350.1,189.5,350.1,191z
		"
        />
        <path
          className="st0"
          d="M350.1,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,216.1,350.1,217.4,350.1,218.9z"
        />
        <path
          className="st0"
          d="M350.1,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,209.1,350.1,210.4,350.1,211.9z"
        />
        <path
          className="st0"
          d="M350.1,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C351.4,202.2,350.1,203.4,350.1,205z
		"
        />
        <path
          className="st0"
          d="M350.1,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,132.5,350.1,133.7,350.1,135.3z"
        />
        <path
          className="st0"
          d="M350.1,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C351.4,139.4,350.1,140.7,350.1,142.2z"
        />
        <path
          className="st0"
          d="M350.1,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,146.4,350.1,147.7,350.1,149.2z"
        />
        <path
          className="st0"
          d="M350.1,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C351.4,223.1,350.1,224.3,350.1,225.9z"
        />
        <path
          className="st0"
          d="M350.1,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C351.4,167.3,350.1,168.6,350.1,170.1z"
        />
        <path
          className="st0"
          d="M350.1,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C351.4,160.3,350.1,161.6,350.1,163.1z"
        />
        <path
          className="st0"
          d="M350.1,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C351.4,153.4,350.1,154.6,350.1,156.2z"
        />
        <path
          className="st0"
          d="M350.1,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,195.2,350.1,196.4,350.1,198z"
        />
        <path
          className="st0"
          d="M313.9,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C315.2,76.7,313.9,77.9,313.9,79.5z
		"
        />
        <path
          className="st0"
          d="M313.9,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,69.7,313.9,71,313.9,72.5z"
        />
        <path
          className="st0"
          d="M313.9,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,62.7,313.9,64,313.9,65.5z"
        />
        <path
          className="st0"
          d="M313.9,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,83.7,313.9,84.9,313.9,86.5z"
        />
        <path
          className="st0"
          d="M313.9,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,97.6,313.9,98.9,313.9,100.4z"
        />
        <path
          className="st0"
          d="M350.1,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,230,350.1,231.3,350.1,232.8z"
        />
        <path
          className="st0"
          d="M313.9,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C315.2,90.6,313.9,91.9,313.9,93.4z"
        />
        <path
          className="st0"
          d="M350.1,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,90.6,350.1,91.9,350.1,93.4z"
        />
        <path
          className="st0"
          d="M350.1,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,237,350.1,238.3,350.1,239.8z"
        />
        <path
          className="st0"
          d="M350.1,253.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,251,350.1,252.2,350.1,253.8z"
        />
        <path
          className="st0"
          d="M350.1,246.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,244,350.1,245.2,350.1,246.8z"
        />
        <path
          className="st0"
          d="M350.1,260.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C351.4,257.9,350.1,259.2,350.1,260.7z"
        />
        <path
          className="st0"
          d="M350.1,267.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C351.4,264.9,350.1,266.2,350.1,267.7z"
        />
        <path
          className="st0"
          d="M338.1,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C339.3,223.1,338.1,224.3,338.1,225.9z"
        />
        <path
          className="st0"
          d="M344.1,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C345.3,205.6,344.1,206.9,344.1,208.4z"
        />
        <path
          className="st0"
          d="M344.1,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C345.3,212.6,344.1,213.9,344.1,215.4z"
        />
        <path
          className="st0"
          d="M344.1,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,198.7,344.1,199.9,344.1,201.5z"
        />
        <path
          className="st0"
          d="M344.1,257.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,254.4,344.1,255.7,344.1,257.2z"
        />
        <path
          className="st0"
          d="M344.1,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,219.6,344.1,220.8,344.1,222.4z"
        />
        <path
          className="st0"
          d="M344.1,250.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,247.5,344.1,248.7,344.1,250.3z"
        />
        <path
          className="st0"
          d="M344.1,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,191.7,344.1,193,344.1,194.5z"
        />
        <path
          className="st0"
          d="M344.1,264.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,261.4,344.1,262.7,344.1,264.2z"
        />
        <path
          className="st0"
          d="M344.1,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,156.8,344.1,158.1,344.1,159.7z"
        />
        <path
          className="st0"
          d="M344.1,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,184.7,344.1,186,344.1,187.5z"
        />
        <path
          className="st0"
          d="M344.1,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,142.9,344.1,144.2,344.1,145.7z"
        />
        <path
          className="st0"
          d="M344.1,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,163.8,344.1,165.1,344.1,166.6z"
        />
        <path
          className="st0"
          d="M344.1,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,170.8,344.1,172,344.1,173.6z"
        />
        <path
          className="st0"
          d="M344.1,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,177.8,344.1,179,344.1,180.6z"
        />
        <path
          className="st0"
          d="M344.1,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,149.9,344.1,151.1,344.1,152.7z"
        />
        <path
          className="st0"
          d="M319.9,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,219.6,319.9,220.8,319.9,222.4z"
        />
        <path
          className="st0"
          d="M319.9,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,226.6,319.9,227.8,319.9,229.4z"
        />
        <path
          className="st0"
          d="M319.9,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C321.2,240.5,319.9,241.8,319.9,243.3z"
        />
        <path
          className="st0"
          d="M338.1,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,216.1,338.1,217.4,338.1,218.9z"
        />
        <path
          className="st0"
          d="M319.9,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C321.2,212.6,319.9,213.9,319.9,215.4z"
        />
        <path
          className="st0"
          d="M319.9,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C321.2,205.6,319.9,206.9,319.9,208.4z"
        />
        <path
          className="st0"
          d="M319.9,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,233.5,319.9,234.8,319.9,236.3z"
        />
        <path
          className="st0"
          d="M332,257.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C333.3,254.4,332,255.7,332,257.2z"
        />
        <path
          className="st0"
          d="M326,260.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C327.2,257.9,326,259.2,326,260.7z"
        />
        <path
          className="st0"
          d="M319.9,257.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,254.4,319.9,255.7,319.9,257.2z"
        />
        <path
          className="st0"
          d="M319.9,250.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,247.5,319.9,248.7,319.9,250.3z"
        />
        <path
          className="st0"
          d="M319.9,264.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C321.2,261.4,319.9,262.7,319.9,264.2z"
        />
        <path
          className="st0"
          d="M344.1,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C345.3,240.5,344.1,241.8,344.1,243.3z"
        />
        <path
          className="st0"
          d="M338.1,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C339.3,167.3,338.1,168.6,338.1,170.1z"
        />
        <path
          className="st0"
          d="M338.1,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C339.3,153.4,338.1,154.6,338.1,156.2z"
        />
        <circle className="st0" cx="340.9" cy="163.1" r="2.8" />
        <path
          className="st0"
          d="M338.1,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,146.4,338.1,147.7,338.1,149.2z"
        />
        <path
          className="st0"
          d="M338.1,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,132.5,338.1,133.7,338.1,135.3z"
        />
        <path
          className="st0"
          d="M338.1,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C339.3,139.4,338.1,140.7,338.1,142.2z"
        />
        <path
          className="st0"
          d="M338.1,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,195.2,338.1,196.4,338.1,198z"
        />
        <path
          className="st0"
          d="M338.1,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C339.3,202.2,338.1,203.4,338.1,205z
		"
        />
        <path
          className="st0"
          d="M338.1,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,125.5,338.1,126.7,338.1,128.3z"
        />
        <path
          className="st0"
          d="M338.1,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,209.1,338.1,210.4,338.1,211.9z"
        />
        <path
          className="st0"
          d="M338.1,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C339.3,181.2,338.1,182.5,338.1,184.1z"
        />
        <path
          className="st0"
          d="M338.1,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C339.3,188.2,338.1,189.5,338.1,191z
		"
        />
        <path
          className="st0"
          d="M338.1,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C339.3,174.3,338.1,175.5,338.1,177.1z"
        />
        <path
          className="st0"
          d="M338.1,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,104.6,338.1,105.8,338.1,107.4z"
        />
        <path
          className="st0"
          d="M344.1,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,87.1,344.1,88.4,344.1,89.9z"
        />
        <path
          className="st0"
          d="M338.1,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,118.5,338.1,119.8,338.1,121.3z"
        />
        <path
          className="st0"
          d="M344.1,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,101.1,344.1,102.3,344.1,103.9z"
        />
        <path
          className="st0"
          d="M344.1,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,115,344.1,116.3,344.1,117.8z"
        />
        <path
          className="st0"
          d="M344.1,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,129,344.1,130.2,344.1,131.8z"
        />
        <path
          className="st0"
          d="M410.5,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C411.8,223.1,410.5,224.3,410.5,225.9z"
        />
        <path
          className="st0"
          d="M344.1,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,108.1,344.1,109.3,344.1,110.9z"
        />
        <path
          className="st0"
          d="M344.1,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,135.9,344.1,137.2,344.1,138.7z"
        />
        <path
          className="st0"
          d="M338.1,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,97.6,338.1,98.9,338.1,100.4z"
        />
        <path
          className="st0"
          d="M338.1,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,111.5,338.1,112.8,338.1,114.3z"
        />
        <path
          className="st0"
          d="M344.1,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C345.3,94.1,344.1,95.4,344.1,96.9z"
        />
        <path
          className="st0"
          d="M338.1,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,90.6,338.1,91.9,338.1,93.4z"
        />
        <path
          className="st0"
          d="M458.8,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,104.6,458.8,105.8,458.8,107.4z"
        />
        <path
          className="st0"
          d="M470.9,198c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,196.4,470.9,198z"
        />
        <path
          className="st0"
          d="M476.9,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,129,476.9,130.2,476.9,131.8z"
        />
        <path
          className="st0"
          d="M470.9,211.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,210.4,470.9,211.9z"
        />
        <path
          className="st0"
          d="M470.9,58.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S470.9,57,470.9,58.6z"
        />
        <path
          className="st0"
          d="M470.9,51.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S470.9,50.1,470.9,51.6z"
        />
        <path
          className="st0"
          d="M470.9,30.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,29.1,470.9,30.7z"
        />
        <path
          className="st0"
          d="M470.9,218.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,217.4,470.9,218.9z"
        />
        <path
          className="st0"
          d="M470.9,225.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S470.9,224.3,470.9,225.9z"
        />
        <path
          className="st0"
          d="M476.9,27.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C478.2,24.4,476.9,25.7,476.9,27.2z
		"
        />
        <path
          className="st0"
          d="M470.9,65.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,64,470.9,65.5z"
        />
        <path
          className="st0"
          d="M476.9,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,135.9,476.9,137.2,476.9,138.7z"
        />
        <path
          className="st0"
          d="M464.8,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,142.9,464.8,144.2,464.8,145.7z"
        />
        <path
          className="st0"
          d="M470.9,232.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,231.3,470.9,232.8z"
        />
        <path
          className="st0"
          d="M470.9,239.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,238.3,470.9,239.8z"
        />
        <path
          className="st0"
          d="M470.9,205c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S470.9,203.4,470.9,205z"
        />
        <path
          className="st0"
          d="M470.9,142.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S470.9,140.7,470.9,142.2z"
        />
        <path
          className="st0"
          d="M470.9,121.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,119.8,470.9,121.3z"
        />
        <path
          className="st0"
          d="M470.9,128.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,126.7,470.9,128.3z"
        />
        <path
          className="st0"
          d="M470.9,135.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,133.7,470.9,135.3z"
        />
        <path
          className="st0"
          d="M464.8,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,135.9,464.8,137.2,464.8,138.7z"
        />
        <path
          className="st0"
          d="M470.9,44.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S470.9,43.1,470.9,44.6z"
        />
        <path
          className="st0"
          d="M470.9,100.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,98.9,470.9,100.4z"
        />
        <path
          className="st0"
          d="M470.9,86.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,84.9,470.9,86.5z"
        />
        <path
          className="st0"
          d="M470.9,93.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,91.9,470.9,93.4z"
        />
        <path
          className="st0"
          d="M470.9,79.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S470.9,77.9,470.9,79.5z"
        />
        <path
          className="st0"
          d="M470.9,107.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,105.8,470.9,107.4z"
        />
        <path
          className="st0"
          d="M410.5,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,62.7,410.5,64,410.5,65.5z"
        />
        <path
          className="st0"
          d="M470.9,114.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,112.8,470.9,114.3z"
        />
        <path
          className="st0"
          d="M470.9,9.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8S475.2,7,473.7,7S470.9,8.2,470.9,9.8z"
        />
        <path
          className="st0"
          d="M507.1,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C508.3,62.7,507.1,64,507.1,65.5z"
        />
        <path
          className="st0"
          d="M495,93.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S495,91.9,495,93.4z"
        />
        <path
          className="st0"
          d="M507.1,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C508.3,69.7,507.1,71,507.1,72.5z"
        />
        <path
          className="st0"
          d="M507.1,51.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C508.3,48.8,507.1,50.1,507.1,51.6z
		"
        />
        <path
          className="st0"
          d="M507.1,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C508.3,83.7,507.1,84.9,507.1,86.5z"
        />
        <path
          className="st0"
          d="M507.1,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C508.3,76.7,507.1,77.9,507.1,79.5z
		"
        />
        <path
          className="st0"
          d="M507.1,58.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C508.3,55.8,507.1,57,507.1,58.6z"
        />
        <path
          className="st0"
          d="M513.1,41.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C514.4,38.3,513.1,39.6,513.1,41.1z
		"
        />
        <path
          className="st0"
          d="M507.1,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C508.3,209.1,507.1,210.4,507.1,211.9z"
        />
        <path
          className="st0"
          d="M513.1,48.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C514.4,45.3,513.1,46.6,513.1,48.1z
		"
        />
        <path
          className="st0"
          d="M507.1,37.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C508.3,34.9,507.1,36.1,507.1,37.7z"
        />
        <path
          className="st0"
          d="M507.1,30.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C508.3,27.9,507.1,29.1,507.1,30.7z"
        />
        <path
          className="st0"
          d="M507.1,44.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C508.3,41.8,507.1,43.1,507.1,44.6z
		"
        />
        <path
          className="st0"
          d="M476.9,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,115,476.9,116.3,476.9,117.8z"
        />
        <path
          className="st0"
          d="M476.9,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,94.1,476.9,95.4,476.9,96.9z"
        />
        <path
          className="st0"
          d="M476.9,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,101.1,476.9,102.3,476.9,103.9z"
        />
        <path
          className="st0"
          d="M476.9,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,87.1,476.9,88.4,476.9,89.9z"
        />
        <path
          className="st0"
          d="M476.9,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,108.1,476.9,109.3,476.9,110.9z"
        />
        <path
          className="st0"
          d="M476.9,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,122,476.9,123.3,476.9,124.8z"
        />
        <path
          className="st0"
          d="M476.9,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C478.2,80.2,476.9,81.4,476.9,83
		z"
        />
        <path
          className="st0"
          d="M476.9,55.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C478.2,52.3,476.9,53.5,476.9,55.1z
		"
        />
        <path
          className="st0"
          d="M476.9,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C478.2,73.2,476.9,74.5,476.9,76
		z"
        />
        <path
          className="st0"
          d="M476.9,48.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C478.2,45.3,476.9,46.6,476.9,48.1z
		"
        />
        <path
          className="st0"
          d="M476.9,34.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C478.2,31.4,476.9,32.6,476.9,34.2z
		"
        />
        <path
          className="st0"
          d="M476.9,41.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C478.2,38.3,476.9,39.6,476.9,41.1z
		"
        />
        <path
          className="st0"
          d="M476.9,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C478.2,66.2,476.9,67.5,476.9,69
		z"
        />
        <path
          className="st0"
          d="M476.9,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C478.2,59.3,476.9,60.5,476.9,62.1z
		"
        />
        <path
          className="st0"
          d="M464.8,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C466.1,73.2,464.8,74.5,464.8,76
		z"
        />
        <path
          className="st0"
          d="M452.8,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,129,452.8,130.2,452.8,131.8z"
        />
        <path
          className="st0"
          d="M452.8,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,122,452.8,123.3,452.8,124.8z"
        />
        <path
          className="st0"
          d="M452.8,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,135.9,452.8,137.2,452.8,138.7z"
        />
        <path
          className="st0"
          d="M452.8,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,156.8,452.8,158.1,452.8,159.7z"
        />
        <path
          className="st0"
          d="M452.8,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,142.9,452.8,144.2,452.8,145.7z"
        />
        <path
          className="st0"
          d="M452.8,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,115,452.8,116.3,452.8,117.8z"
        />
        <path
          className="st0"
          d="M452.8,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,149.9,452.8,151.1,452.8,152.7z"
        />
        <path
          className="st0"
          d="M452.8,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C454,73.2,452.8,74.5,452.8,76z"
        />
        <path
          className="st0"
          d="M452.8,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C454,80.2,452.8,81.4,452.8,83z"
        />
        <path
          className="st0"
          d="M452.8,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,87.1,452.8,88.4,452.8,89.9z"
        />
        <path
          className="st0"
          d="M452.8,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C454,66.2,452.8,67.5,452.8,69z"
        />
        <path
          className="st0"
          d="M452.8,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,108.1,452.8,109.3,452.8,110.9z"
        />
        <path
          className="st0"
          d="M452.8,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,163.8,452.8,165.1,452.8,166.6z"
        />
        <path
          className="st0"
          d="M452.8,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,94.1,452.8,95.4,452.8,96.9z"
        />
        <path
          className="st0"
          d="M452.8,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,101.1,452.8,102.3,452.8,103.9z"
        />
        <path
          className="st0"
          d="M452.8,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,219.6,452.8,220.8,452.8,222.4z"
        />
        <path
          className="st0"
          d="M452.8,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C454,212.6,452.8,213.9,452.8,215.4z"
        />
        <path
          className="st0"
          d="M452.8,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,198.7,452.8,199.9,452.8,201.5z"
        />
        <path
          className="st0"
          d="M452.8,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,170.8,452.8,172,452.8,173.6z"
        />
        <path
          className="st0"
          d="M452.8,250.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,247.5,452.8,248.7,452.8,250.3z"
        />
        <path
          className="st0"
          d="M458.8,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,230,458.8,231.3,458.8,232.8z"
        />
        <path
          className="st0"
          d="M452.8,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C454,205.6,452.8,206.9,452.8,208.4z"
        />
        <path
          className="st0"
          d="M458.8,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C460.1,188.2,458.8,189.5,458.8,191z
		"
        />
        <path
          className="st0"
          d="M452.8,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C454,59.3,452.8,60.5,452.8,62.1z"
        />
        <path
          className="st0"
          d="M452.8,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,177.8,452.8,179,452.8,180.6z"
        />
        <path
          className="st0"
          d="M452.8,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C454,240.5,452.8,241.8,452.8,243.3z"
        />
        <path
          className="st0"
          d="M452.8,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,226.6,452.8,227.8,452.8,229.4z"
        />
        <path
          className="st0"
          d="M452.8,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C454,233.5,452.8,234.8,452.8,236.3z"
        />
        <path
          className="st0"
          d="M458.8,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,118.5,458.8,119.8,458.8,121.3z"
        />
        <path
          className="st0"
          d="M464.8,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C466.1,66.2,464.8,67.5,464.8,69
		z"
        />
        <path
          className="st0"
          d="M464.8,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C466.1,80.2,464.8,81.4,464.8,83
		z"
        />
        <path
          className="st0"
          d="M464.8,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C466.1,59.3,464.8,60.5,464.8,62.1z
		"
        />
        <path
          className="st0"
          d="M513.1,55.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C514.4,52.3,513.1,53.5,513.1,55.1z
		"
        />
        <path
          className="st0"
          d="M464.8,55.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C466.1,52.3,464.8,53.5,464.8,55.1z
		"
        />
        <path
          className="st0"
          d="M458.8,51.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C460.1,48.8,458.8,50.1,458.8,51.6z
		"
        />
        <path
          className="st0"
          d="M464.8,48.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C466.1,45.3,464.8,46.6,464.8,48.1z
		"
        />
        <path
          className="st0"
          d="M464.8,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,108.1,464.8,109.3,464.8,110.9z"
        />
        <path
          className="st0"
          d="M464.8,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,87.1,464.8,88.4,464.8,89.9z"
        />
        <path
          className="st0"
          d="M464.8,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,122,464.8,123.3,464.8,124.8z"
        />
        <path
          className="st0"
          d="M458.8,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,62.7,458.8,64,458.8,65.5z"
        />
        <path
          className="st0"
          d="M464.8,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,115,464.8,116.3,464.8,117.8z"
        />
        <path
          className="st0"
          d="M464.8,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,101.1,464.8,102.3,464.8,103.9z"
        />
        <path
          className="st0"
          d="M464.8,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,94.1,464.8,95.4,464.8,96.9z"
        />
        <path
          className="st0"
          d="M458.8,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,125.5,458.8,126.7,458.8,128.3z"
        />
        <path
          className="st0"
          d="M458.8,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,132.5,458.8,133.7,458.8,135.3z"
        />
        <path
          className="st0"
          d="M464.8,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,129,464.8,130.2,464.8,131.8z"
        />
        <path
          className="st0"
          d="M458.8,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,111.5,458.8,112.8,458.8,114.3z"
        />
        <path
          className="st0"
          d="M458.8,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C460.1,139.4,458.8,140.7,458.8,142.2z"
        />
        <path
          className="st0"
          d="M458.8,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,146.4,458.8,147.7,458.8,149.2z"
        />
        <path
          className="st0"
          d="M458.8,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,97.6,458.8,98.9,458.8,100.4z"
        />
        <path
          className="st0"
          d="M458.8,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C460.1,76.7,458.8,77.9,458.8,79.5z
		"
        />
        <path
          className="st0"
          d="M458.8,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,69.7,458.8,71,458.8,72.5z"
        />
        <path
          className="st0"
          d="M301.8,114.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,112.8,301.8,114.3z"
        />
        <path
          className="st0"
          d="M458.8,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,83.7,458.8,84.9,458.8,86.5z"
        />
        <path
          className="st0"
          d="M458.8,58.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C460.1,55.8,458.8,57,458.8,58.6z"
        />
        <path
          className="st0"
          d="M458.8,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,90.6,458.8,91.9,458.8,93.4z"
        />
        <path
          className="st0"
          d="M489,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C490.2,122,489,123.3,489,124.8
		z"
        />
        <path
          className="st0"
          d="M482.9,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,125.5,482.9,126.7,482.9,128.3z"
        />
        <path
          className="st0"
          d="M489,27.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C490.2,24.4,489,25.7,489,27.2z"
        />
        <path
          className="st0"
          d="M482.9,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,111.5,482.9,112.8,482.9,114.3z"
        />
        <path
          className="st0"
          d="M495,16.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S495,15.2,495,16.7z"
        />
        <path
          className="st0"
          d="M489,41.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C490.2,38.3,489,39.6,489,41.1z"
        />
        <path
          className="st0"
          d="M489,20.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C490.2,17.4,489,18.7,489,20.2z"
        />
        <path
          className="st0"
          d="M489,48.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C490.2,45.3,489,46.6,489,48.1z"
        />
        <path
          className="st0"
          d="M489,34.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C490.2,31.4,489,32.6,489,34.2z"
        />
        <path
          className="st0"
          d="M482.9,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,104.6,482.9,105.8,482.9,107.4z"
        />
        <path
          className="st0"
          d="M482.9,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,83.7,482.9,84.9,482.9,86.5z"
        />
        <path
          className="st0"
          d="M482.9,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,69.7,482.9,71,482.9,72.5z"
        />
        <path
          className="st0"
          d="M482.9,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C484.2,76.7,482.9,77.9,482.9,79.5z
		"
        />
        <path
          className="st0"
          d="M482.9,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,97.6,482.9,98.9,482.9,100.4z"
        />
        <path
          className="st0"
          d="M482.9,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,90.6,482.9,91.9,482.9,93.4z"
        />
        <path
          className="st0"
          d="M489,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C490.2,73.2,489,74.5,489,76z"
        />
        <path
          className="st0"
          d="M458.8,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,237,458.8,238.3,458.8,239.8z"
        />
        <path
          className="st0"
          d="M489,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C490.2,115,489,116.3,489,117.8
		z"
        />
        <path
          className="st0"
          d="M489,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C490.2,108.1,489,109.3,489,110.9z"
        />
        <path
          className="st0"
          d="M489,55.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C490.2,52.3,489,53.5,489,55.1z"
        />
        <path
          className="st0"
          d="M495,23.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S495,22.2,495,23.7z"
        />
        <path
          className="st0"
          d="M489,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C490.2,129,489,130.2,489,131.8
		z"
        />
        <path
          className="st0"
          d="M495,128.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S495,126.7,495,128.3z"
        />
        <path
          className="st0"
          d="M489,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C490.2,101.1,489,102.3,489,103.9z"
        />
        <path
          className="st0"
          d="M482.9,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,62.7,482.9,64,482.9,65.5z"
        />
        <path
          className="st0"
          d="M489,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C490.2,66.2,489,67.5,489,69z"
        />
        <path
          className="st0"
          d="M489,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C490.2,59.3,489,60.5,489,62.1z"
        />
        <path
          className="st0"
          d="M489,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C490.2,87.1,489,88.4,489,89.9z"
        />
        <path
          className="st0"
          d="M489,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C490.2,80.2,489,81.4,489,83z"
        />
        <path
          className="st0"
          d="M489,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C490.2,94.1,489,95.4,489,96.9z"
        />
        <path
          className="st0"
          d="M482.9,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,118.5,482.9,119.8,482.9,121.3z"
        />
        <path
          className="st0"
          d="M501.1,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C502.3,205.6,501.1,206.9,501.1,208.4z"
        />
        <path
          className="st0"
          d="M501.1,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C502.3,219.6,501.1,220.8,501.1,222.4z"
        />
        <path
          className="st0"
          d="M507.1,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C508.3,223.1,507.1,224.3,507.1,225.9z"
        />
        <path
          className="st0"
          d="M507.1,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C508.3,230,507.1,231.3,507.1,232.8z"
        />
        <path
          className="st0"
          d="M513.1,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C514.4,226.6,513.1,227.8,513.1,229.4z"
        />
        <path
          className="st0"
          d="M501.1,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C502.3,212.6,501.1,213.9,501.1,215.4z"
        />
        <path
          className="st0"
          d="M525.2,13.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C526.5,10.5,525.2,11.7,525.2,13.3z
		"
        />
        <path
          className="st0"
          d="M482.9,58.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C484.2,55.8,482.9,57,482.9,58.6z"
        />
        <path
          className="st0"
          d="M525.2,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C526.5,142.9,525.2,144.2,525.2,145.7z"
        />
        <path
          className="st0"
          d="M525.2,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C526.5,135.9,525.2,137.2,525.2,138.7z"
        />
        <path
          className="st0"
          d="M537.3,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C538.5,135.9,537.3,137.2,537.3,138.7z"
        />
        <path
          className="st0"
          d="M537.3,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C538.5,149.9,537.3,151.1,537.3,152.7z"
        />
        <path
          className="st0"
          d="M525.2,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C526.5,122,525.2,123.3,525.2,124.8z"
        />
        <path
          className="st0"
          d="M537.3,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C538.5,142.9,537.3,144.2,537.3,145.7z"
        />
        <path
          className="st0"
          d="M543.3,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C544.6,153.4,543.3,154.6,543.3,156.2z"
        />
        <path
          className="st0"
          d="M543.3,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C544.6,167.3,543.3,168.6,543.3,170.1z"
        />
        <path
          className="st0"
          d="M543.3,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C544.6,223.1,543.3,224.3,543.3,225.9z"
        />
        <path
          className="st0"
          d="M543.3,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C544.6,209.1,543.3,210.4,543.3,211.9z"
        />
        <path
          className="st0"
          d="M537.3,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C538.5,240.5,537.3,241.8,537.3,243.3z"
        />
        <path
          className="st0"
          d="M537.3,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C538.5,129,537.3,130.2,537.3,131.8z"
        />
        <path
          className="st0"
          d="M525.2,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C526.5,129,525.2,130.2,525.2,131.8z"
        />
        <path
          className="st0"
          d="M482.9,23.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C484.2,20.9,482.9,22.2,482.9,23.7z
		"
        />
        <path
          className="st0"
          d="M482.9,16.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C484.2,13.9,482.9,15.2,482.9,16.7z
		"
        />
        <path
          className="st0"
          d="M489,13.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C490.2,10.5,489,11.7,489,13.3z"
        />
        <path
          className="st0"
          d="M482.9,37.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,34.9,482.9,36.1,482.9,37.7z"
        />
        <path
          className="st0"
          d="M482.9,30.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,27.9,482.9,29.1,482.9,30.7z"
        />
        <path
          className="st0"
          d="M519.2,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C520.4,104.6,519.2,105.8,519.2,107.4z"
        />
        <path
          className="st0"
          d="M519.2,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C520.4,97.6,519.2,98.8,519.2,100.4z"
        />
        <path
          className="st0"
          d="M519.2,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C520.4,90.6,519.2,91.9,519.2,93.4z"
        />
        <path
          className="st0"
          d="M482.9,44.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C484.2,41.8,482.9,43.1,482.9,44.6z
		"
        />
        <path
          className="st0"
          d="M482.9,51.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C484.2,48.8,482.9,50.1,482.9,51.6z
		"
        />
        <path
          className="st0"
          d="M525.2,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C526.5,115,525.2,116.3,525.2,117.8z"
        />
        <path
          className="st0"
          d="M519.2,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C520.4,132.5,519.2,133.7,519.2,135.3z"
        />
        <path
          className="st0"
          d="M525.2,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C526.5,108.1,525.2,109.3,525.2,110.9z"
        />
        <path
          className="st0"
          d="M531.2,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C532.5,111.5,531.2,112.8,531.2,114.3z"
        />
        <path
          className="st0"
          d="M549.4,110.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S549.4,109.3,549.4,110.9z"
        />
        <path
          className="st0"
          d="M519.2,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C520.4,139.4,519.2,140.7,519.2,142.2z"
        />
        <path
          className="st0"
          d="M519.2,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C520.4,125.5,519.2,126.7,519.2,128.3z"
        />
        <path
          className="st0"
          d="M519.2,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C520.4,118.5,519.2,119.8,519.2,121.3z"
        />
        <path
          className="st0"
          d="M519.2,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C520.4,111.5,519.2,112.8,519.2,114.3z"
        />
        <path
          className="st0"
          d="M513.1,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C514.4,129,513.1,130.2,513.1,131.8z"
        />
        <path
          className="st0"
          d="M519.2,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C520.4,62.7,519.2,64,519.2,65.5z"
        />
        <path
          className="st0"
          d="M519.2,58.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C520.4,55.8,519.2,57,519.2,58.6z"
        />
        <path
          className="st0"
          d="M519.2,44.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C520.4,41.8,519.2,43.1,519.2,44.6z
		"
        />
        <path
          className="st0"
          d="M519.2,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C520.4,69.7,519.2,71,519.2,72.5z"
        />
        <path
          className="st0"
          d="M519.2,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C520.4,83.7,519.2,84.9,519.2,86.5z"
        />
        <path
          className="st0"
          d="M519.2,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C520.4,76.7,519.2,77.9,519.2,79.5z
		"
        />
        <path
          className="st0"
          d="M519.2,37.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C520.4,34.9,519.2,36.1,519.2,37.7z"
        />
        <path
          className="st0"
          d="M519.2,51.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C520.4,48.8,519.2,50.1,519.2,51.6z
		"
        />
        <path
          className="st0"
          d="M525.2,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C526.5,73.2,525.2,74.5,525.2,76
		z"
        />
        <path
          className="st0"
          d="M525.2,41.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C526.5,38.3,525.2,39.6,525.2,41.1z
		"
        />
        <path
          className="st0"
          d="M525.2,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C526.5,66.2,525.2,67.5,525.2,69
		z"
        />
        <path
          className="st0"
          d="M525.2,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C526.5,59.3,525.2,60.5,525.2,62.1z
		"
        />
        <path
          className="st0"
          d="M525.2,48.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C526.5,45.3,525.2,46.6,525.2,48.1z
		"
        />
        <path
          className="st0"
          d="M525.2,55.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C526.5,52.3,525.2,53.5,525.2,55.1z
		"
        />
        <path
          className="st0"
          d="M513.1,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C514.4,73.2,513.1,74.5,513.1,76
		z"
        />
        <path
          className="st0"
          d="M513.1,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C514.4,101.1,513.1,102.3,513.1,103.9z"
        />
        <path
          className="st0"
          d="M513.1,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C514.4,94.1,513.1,95.4,513.1,96.9z"
        />
        <circle className="st0" cx="515.9" cy="83" r="2.8" />
        <path
          className="st0"
          d="M519.2,9.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8S523.5,7,522,7C520.4,7,519.2,8.2,519.2,9.8z"
        />
        <path
          className="st0"
          d="M513.1,20.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C514.4,17.4,513.1,18.7,513.1,20.2z
		"
        />
        <path
          className="st0"
          d="M513.1,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C514.4,66.2,513.1,67.5,513.1,69
		z"
        />
        <path
          className="st0"
          d="M513.1,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C514.4,87.1,513.1,88.4,513.1,89.9z"
        />
        <circle className="st0" cx="515.9" cy="110.9" r="2.8" />
        <path
          className="st0"
          d="M519.2,16.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C520.4,13.9,519.2,15.2,519.2,16.7z
		"
        />
        <path
          className="st0"
          d="M513.1,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C514.4,122,513.1,123.3,513.1,124.8z"
        />
        <path
          className="st0"
          d="M519.2,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8S523.5,0,522,0C520.4,0,519.2,1.3,519.2,2.8z"
        />
        <path
          className="st0"
          d="M513.1,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C514.4,115,513.1,116.3,513.1,117.8z"
        />
        <path
          className="st0"
          d="M513.1,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C514.4,59.3,513.1,60.5,513.1,62.1z
		"
        />
        <path
          className="st0"
          d="M513.1,13.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C514.4,10.5,513.1,11.7,513.1,13.3z
		"
        />
        <path
          className="st0"
          d="M495,79.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S495,77.9,495,79.5z"
        />
        <path
          className="st0"
          d="M489,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C490.2,198.7,489,199.9,489,201.5z"
        />
        <path
          className="st0"
          d="M495,86.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S495,84.9,495,86.5z"
        />
        <path
          className="st0"
          d="M489,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C490.2,191.7,489,193,489,194.5
		z"
        />
        <path
          className="st0"
          d="M501.1,20.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C502.3,17.4,501.1,18.7,501.1,20.2z
		"
        />
        <path
          className="st0"
          d="M482.9,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C484.2,188.2,482.9,189.5,482.9,191z
		"
        />
        <path
          className="st0"
          d="M495,65.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S495,64,495,65.5z"
        />
        <path
          className="st0"
          d="M495,44.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S495,43.1,495,44.6z"
        />
        <path
          className="st0"
          d="M495,37.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S495,36.1,495,37.7z"
        />
        <path
          className="st0"
          d="M495,51.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S495,50.1,495,51.6z"
        />
        <path
          className="st0"
          d="M495,72.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S495,71,495,72.5z"
        />
        <path
          className="st0"
          d="M501.1,13.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C502.3,10.5,501.1,11.7,501.1,13.3z
		"
        />
        <path
          className="st0"
          d="M495,58.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S495,57,495,58.6z"
        />
        <path
          className="st0"
          d="M507.1,16.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C508.3,13.9,507.1,15.2,507.1,16.7z
		"
        />
        <path
          className="st0"
          d="M501.1,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C502.3,94.1,501.1,95.4,501.1,96.9z"
        />
        <circle className="st0" cx="515.9" cy="6.3" r="2.8" />
        <path
          className="st0"
          d="M501.1,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C502.3,73.2,501.1,74.5,501.1,76
		z"
        />
        <path
          className="st0"
          d="M507.1,9.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8S511.4,7,509.9,7C508.3,7,507.1,8.2,507.1,9.8z"
        />
        <path
          className="st0"
          d="M495,30.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S495,29.1,495,30.7z"
        />
        <path
          className="st0"
          d="M501.1,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C502.3,66.2,501.1,67.5,501.1,69
		z"
        />
        <path
          className="st0"
          d="M501.1,41.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C502.3,38.3,501.1,39.6,501.1,41.1z
		"
        />
        <path
          className="st0"
          d="M501.1,48.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C502.3,45.3,501.1,46.6,501.1,48.1z
		"
        />
        <path
          className="st0"
          d="M501.1,27.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C502.3,24.4,501.1,25.7,501.1,27.2z
		"
        />
        <path
          className="st0"
          d="M501.1,34.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C502.3,31.4,501.1,32.6,501.1,34.2z
		"
        />
        <path
          className="st0"
          d="M501.1,55.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C502.3,52.3,501.1,53.5,501.1,55.1z
		"
        />
        <path
          className="st0"
          d="M501.1,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C502.3,59.3,501.1,60.5,501.1,62.1z
		"
        />
        <path
          className="st0"
          d="M470.9,72.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,71,470.9,72.5z"
        />
        <path
          className="st0"
          d="M428.6,103.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,102.3,428.6,103.9z"
        />
        <path
          className="st0"
          d="M428.6,110.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,109.3,428.6,110.9z"
        />
        <path
          className="st0"
          d="M428.6,117.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,116.3,428.6,117.8z"
        />
        <path
          className="st0"
          d="M428.6,83c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,81.4,428.6,83z"
        />
        <path
          className="st0"
          d="M428.6,124.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,123.3,428.6,124.8z"
        />
        <path
          className="st0"
          d="M428.6,96.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,95.4,428.6,96.9z"
        />
        <path
          className="st0"
          d="M428.6,89.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,88.4,428.6,89.9z"
        />
        <path
          className="st0"
          d="M428.6,166.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,165.1,428.6,166.6z"
        />
        <path
          className="st0"
          d="M428.6,131.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,130.2,428.6,131.8z"
        />
        <path
          className="st0"
          d="M428.6,159.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,158.1,428.6,159.7z"
        />
        <path
          className="st0"
          d="M428.6,76c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,74.5,428.6,76z"
        />
        <path
          className="st0"
          d="M428.6,152.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,151.1,428.6,152.7z"
        />
        <path
          className="st0"
          d="M428.6,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,144.2,428.6,145.7z"
        />
        <path
          className="st0"
          d="M428.6,138.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,137.2,428.6,138.7z"
        />
        <path
          className="st0"
          d="M422.6,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C423.8,153.4,422.6,154.6,422.6,156.2z"
        />
        <path
          className="st0"
          d="M422.6,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C423.8,160.3,422.6,161.6,422.6,163.1z"
        />
        <path
          className="st0"
          d="M428.6,69c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,67.5,428.6,69z"
        />
        <path
          className="st0"
          d="M422.6,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C423.8,167.3,422.6,168.6,422.6,170.1z"
        />
        <path
          className="st0"
          d="M422.6,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,146.4,422.6,147.7,422.6,149.2z"
        />
        <path
          className="st0"
          d="M422.6,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C423.8,139.4,422.6,140.7,422.6,142.2z"
        />
        <path
          className="st0"
          d="M422.6,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C423.8,174.3,422.6,175.5,422.6,177.1z"
        />
        <path
          className="st0"
          d="M428.6,173.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,172,428.6,173.6z"
        />
        <path
          className="st0"
          d="M422.6,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C423.8,181.2,422.6,182.5,422.6,184.1z"
        />
        <path
          className="st0"
          d="M422.6,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C423.8,202.2,422.6,203.4,422.6,205z
		"
        />
        <path
          className="st0"
          d="M422.6,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,209.1,422.6,210.4,422.6,211.9z"
        />
        <path
          className="st0"
          d="M422.6,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,216.1,422.6,217.4,422.6,218.9z"
        />
        <path
          className="st0"
          d="M422.6,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,195.2,422.6,196.4,422.6,198z"
        />
        <path
          className="st0"
          d="M422.6,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C423.8,188.2,422.6,189.5,422.6,191z
		"
        />
        <path
          className="st0"
          d="M428.6,222.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,220.8,428.6,222.4z"
        />
        <path
          className="st0"
          d="M434.6,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C435.9,188.2,434.6,189.5,434.6,191z
		"
        />
        <path
          className="st0"
          d="M434.6,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,118.5,434.6,119.8,434.6,121.3z"
        />
        <path
          className="st0"
          d="M434.6,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,132.5,434.6,133.7,434.6,135.3z"
        />
        <path
          className="st0"
          d="M434.6,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C435.9,139.4,434.6,140.7,434.6,142.2z"
        />
        <path
          className="st0"
          d="M434.6,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,97.6,434.6,98.9,434.6,100.4z"
        />
        <path
          className="st0"
          d="M434.6,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,104.6,434.6,105.8,434.6,107.4z"
        />
        <path
          className="st0"
          d="M434.6,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,111.5,434.6,112.8,434.6,114.3z"
        />
        <path
          className="st0"
          d="M434.6,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,90.6,434.6,91.9,434.6,93.4z"
        />
        <path
          className="st0"
          d="M434.6,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,146.4,434.6,147.7,434.6,149.2z"
        />
        <path
          className="st0"
          d="M434.6,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C435.9,167.3,434.6,168.6,434.6,170.1z"
        />
        <path
          className="st0"
          d="M434.6,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C435.9,181.2,434.6,182.5,434.6,184.1z"
        />
        <path
          className="st0"
          d="M434.6,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C435.9,174.3,434.6,175.5,434.6,177.1z"
        />
        <path
          className="st0"
          d="M434.6,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C435.9,153.4,434.6,154.6,434.6,156.2z"
        />
        <path
          className="st0"
          d="M434.6,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C435.9,160.3,434.6,161.6,434.6,163.1z"
        />
        <path
          className="st0"
          d="M428.6,187.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,186,428.6,187.5z"
        />
        <path
          className="st0"
          d="M428.6,201.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,199.9,428.6,201.5z"
        />
        <path
          className="st0"
          d="M422.6,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,132.5,422.6,133.7,422.6,135.3z"
        />
        <path
          className="st0"
          d="M428.6,215.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S428.6,213.9,428.6,215.4z"
        />
        <path
          className="st0"
          d="M428.6,208.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S428.6,206.9,428.6,208.4z"
        />
        <path
          className="st0"
          d="M428.6,180.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,179,428.6,180.6z"
        />
        <path
          className="st0"
          d="M428.6,194.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,193,428.6,194.5z"
        />
        <path
          className="st0"
          d="M434.6,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,62.7,434.6,64,434.6,65.5z"
        />
        <path
          className="st0"
          d="M428.6,236.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,234.8,428.6,236.3z"
        />
        <path
          className="st0"
          d="M434.6,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,83.7,434.6,84.9,434.6,86.5z"
        />
        <path
          className="st0"
          d="M434.6,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C435.9,76.7,434.6,77.9,434.6,79.5z
		"
        />
        <path
          className="st0"
          d="M434.6,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,69.7,434.6,71,434.6,72.5z"
        />
        <path
          className="st0"
          d="M428.6,229.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S428.6,227.8,428.6,229.4z"
        />
        <path
          className="st0"
          d="M434.6,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,237,434.6,238.3,434.6,239.8z"
        />
        <path
          className="st0"
          d="M434.6,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,125.5,434.6,126.7,434.6,128.3z"
        />
        <path
          className="st0"
          d="M410.5,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,216.1,410.5,217.4,410.5,218.9z"
        />
        <path
          className="st0"
          d="M410.5,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C411.8,202.2,410.5,203.4,410.5,205z
		"
        />
        <path
          className="st0"
          d="M410.5,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C411.8,188.2,410.5,189.5,410.5,191z
		"
        />
        <path
          className="st0"
          d="M410.5,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C411.8,160.3,410.5,161.6,410.5,163.1z"
        />
        <path
          className="st0"
          d="M410.5,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C411.8,167.3,410.5,168.6,410.5,170.1z"
        />
        <path
          className="st0"
          d="M410.5,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C411.8,174.3,410.5,175.5,410.5,177.1z"
        />
        <path
          className="st0"
          d="M410.5,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C411.8,181.2,410.5,182.5,410.5,184.1z"
        />
        <path
          className="st0"
          d="M410.5,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,195.2,410.5,196.4,410.5,198z"
        />
        <path
          className="st0"
          d="M416.5,83c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,81.4,416.5,83z"
        />
        <path
          className="st0"
          d="M416.5,76c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,74.5,416.5,76z"
        />
        <path
          className="st0"
          d="M416.5,89.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,88.4,416.5,89.9z"
        />
        <path
          className="st0"
          d="M410.5,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,209.1,410.5,210.4,410.5,211.9z"
        />
        <path
          className="st0"
          d="M416.5,222.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,220.8,416.5,222.4z"
        />
        <path
          className="st0"
          d="M416.5,69c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,67.5,416.5,69z"
        />
        <path
          className="st0"
          d="M410.5,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C411.8,76.7,410.5,77.9,410.5,79.5z
		"
        />
        <path
          className="st0"
          d="M410.5,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,90.6,410.5,91.9,410.5,93.4z"
        />
        <path
          className="st0"
          d="M410.5,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,83.7,410.5,84.9,410.5,86.5z"
        />
        <path
          className="st0"
          d="M410.5,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,97.6,410.5,98.9,410.5,100.4z"
        />
        <path
          className="st0"
          d="M410.5,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,69.7,410.5,71,410.5,72.5z"
        />
        <path
          className="st0"
          d="M410.5,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,104.6,410.5,105.8,410.5,107.4z"
        />
        <path
          className="st0"
          d="M416.5,96.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,95.4,416.5,96.9z"
        />
        <path
          className="st0"
          d="M410.5,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C411.8,139.4,410.5,140.7,410.5,142.2z"
        />
        <path
          className="st0"
          d="M410.5,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,132.5,410.5,133.7,410.5,135.3z"
        />
        <path
          className="st0"
          d="M410.5,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,111.5,410.5,112.8,410.5,114.3z"
        />
        <path
          className="st0"
          d="M410.5,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,146.4,410.5,147.7,410.5,149.2z"
        />
        <path
          className="st0"
          d="M410.5,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C411.8,153.4,410.5,154.6,410.5,156.2z"
        />
        <path
          className="st0"
          d="M410.5,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,125.5,410.5,126.7,410.5,128.3z"
        />
        <path
          className="st0"
          d="M410.5,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C411.8,118.5,410.5,119.8,410.5,121.3z"
        />
        <path
          className="st0"
          d="M416.5,201.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,199.9,416.5,201.5z"
        />
        <path
          className="st0"
          d="M422.6,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,125.5,422.6,126.7,422.6,128.3z"
        />
        <path
          className="st0"
          d="M422.6,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,69.7,422.6,71,422.6,72.5z"
        />
        <path
          className="st0"
          d="M422.6,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C423.8,223.1,422.6,224.3,422.6,225.9z"
        />
        <path
          className="st0"
          d="M422.6,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C423.8,76.7,422.6,77.9,422.6,79.5z
		"
        />
        <path
          className="st0"
          d="M416.5,215.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S416.5,213.9,416.5,215.4z"
        />
        <path
          className="st0"
          d="M416.5,208.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S416.5,206.9,416.5,208.4z"
        />
        <path
          className="st0"
          d="M422.6,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,62.7,422.6,64,422.6,65.5z"
        />
        <path
          className="st0"
          d="M422.6,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,83.7,422.6,84.9,422.6,86.5z"
        />
        <path
          className="st0"
          d="M422.6,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,118.5,422.6,119.8,422.6,121.3z"
        />
        <path
          className="st0"
          d="M422.6,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,104.6,422.6,105.8,422.6,107.4z"
        />
        <path
          className="st0"
          d="M422.6,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,111.5,422.6,112.8,422.6,114.3z"
        />
        <path
          className="st0"
          d="M422.6,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,97.6,422.6,98.9,422.6,100.4z"
        />
        <path
          className="st0"
          d="M422.6,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C423.8,90.6,422.6,91.9,422.6,93.4z"
        />
        <path
          className="st0"
          d="M416.5,124.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,123.3,416.5,124.8z"
        />
        <path
          className="st0"
          d="M416.5,131.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,130.2,416.5,131.8z"
        />
        <path
          className="st0"
          d="M458.8,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C460.1,223.1,458.8,224.3,458.8,225.9z"
        />
        <path
          className="st0"
          d="M416.5,194.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,193,416.5,194.5z"
        />
        <path
          className="st0"
          d="M416.5,138.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,137.2,416.5,138.7z"
        />
        <path
          className="st0"
          d="M416.5,110.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,109.3,416.5,110.9z"
        />
        <path
          className="st0"
          d="M416.5,117.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,116.3,416.5,117.8z"
        />
        <path
          className="st0"
          d="M416.5,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,144.2,416.5,145.7z"
        />
        <path
          className="st0"
          d="M416.5,180.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,179,416.5,180.6z"
        />
        <path
          className="st0"
          d="M416.5,173.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,172,416.5,173.6z"
        />
        <path
          className="st0"
          d="M416.5,187.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,186,416.5,187.5z"
        />
        <path
          className="st0"
          d="M416.5,159.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,158.1,416.5,159.7z"
        />
        <path
          className="st0"
          d="M416.5,152.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,151.1,416.5,152.7z"
        />
        <path
          className="st0"
          d="M416.5,166.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,165.1,416.5,166.6z"
        />
        <path
          className="st0"
          d="M416.5,103.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S416.5,102.3,416.5,103.9z"
        />
        <path
          className="st0"
          d="M482.9,281.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C484.2,278.8,482.9,280.1,482.9,281.6z"
        />
        <path
          className="st0"
          d="M489,257.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C490.2,254.4,489,255.7,489,257.2z"
        />
        <path
          className="st0"
          d="M489,250.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C490.2,247.5,489,248.7,489,250.3z"
        />
        <path
          className="st0"
          d="M489,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C490.2,240.5,489,241.8,489,243.3z"
        />
        <path
          className="st0"
          d="M489,264.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C490.2,261.4,489,262.7,489,264.2z"
        />
        <path
          className="st0"
          d="M434.6,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,195.2,434.6,196.4,434.6,198z"
        />
        <path
          className="st0"
          d="M482.9,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,209.1,482.9,210.4,482.9,211.9z"
        />
        <path
          className="st0"
          d="M482.9,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,237,482.9,238.3,482.9,239.8z"
        />
        <path
          className="st0"
          d="M482.9,246.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,244,482.9,245.2,482.9,246.8z"
        />
        <path
          className="st0"
          d="M482.9,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,216.1,482.9,217.4,482.9,218.9z"
        />
        <path
          className="st0"
          d="M482.9,253.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,251,482.9,252.2,482.9,253.8z"
        />
        <path
          className="st0"
          d="M482.9,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C484.2,223.1,482.9,224.3,482.9,225.9z"
        />
        <path
          className="st0"
          d="M482.9,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,230,482.9,231.3,482.9,232.8z"
        />
        <path
          className="st0"
          d="M489,271.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C490.2,268.4,489,269.6,489,271.2z"
        />
        <path
          className="st0"
          d="M446.7,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C448,223.1,446.7,224.3,446.7,225.9z"
        />
        <path
          className="st0"
          d="M531.2,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C532.5,146.4,531.2,147.7,531.2,149.2z"
        />
        <path
          className="st0"
          d="M531.2,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C532.5,125.5,531.2,126.7,531.2,128.3z"
        />
        <path
          className="st0"
          d="M531.2,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C532.5,118.5,531.2,119.8,531.2,121.3z"
        />
        <path
          className="st0"
          d="M446.7,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,216.1,446.7,217.4,446.7,218.9z"
        />
        <path
          className="st0"
          d="M489,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C490.2,226.6,489,227.8,489,229.4z"
        />
        <path
          className="st0"
          d="M446.7,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,230,446.7,231.3,446.7,232.8z"
        />
        <path
          className="st0"
          d="M531.2,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C532.5,139.4,531.2,140.7,531.2,142.2z"
        />
        <path
          className="st0"
          d="M489,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C490.2,219.6,489,220.8,489,222.4z"
        />
        <path
          className="st0"
          d="M495,205c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S495,203.4,495,205z"
        />
        <path
          className="st0"
          d="M482.9,260.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,257.9,482.9,259.2,482.9,260.7z"
        />
        <path
          className="st0"
          d="M531.2,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C532.5,132.5,531.2,133.7,531.2,135.3z"
        />
        <path
          className="st0"
          d="M495,211.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S495,210.4,495,211.9z"
        />
        <path
          className="st0"
          d="M464.8,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C466.1,205.6,464.8,206.9,464.8,208.4z"
        />
        <path
          className="st0"
          d="M446.7,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,209.1,446.7,210.4,446.7,211.9z"
        />
        <path
          className="st0"
          d="M464.8,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,219.6,464.8,220.8,464.8,222.4z"
        />
        <path
          className="st0"
          d="M464.8,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,198.7,464.8,199.9,464.8,201.5z"
        />
        <path
          className="st0"
          d="M464.8,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C466.1,212.6,464.8,213.9,464.8,215.4z"
        />
        <path
          className="st0"
          d="M470.9,281.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S470.9,280.1,470.9,281.6z"
        />
        <path
          className="st0"
          d="M482.9,274.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C484.2,271.9,482.9,273.1,482.9,274.7z"
        />
        <path
          className="st0"
          d="M470.9,274.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S470.9,273.1,470.9,274.7z"
        />
        <path
          className="st0"
          d="M464.8,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,226.6,464.8,227.8,464.8,229.4z"
        />
        <path
          className="st0"
          d="M464.8,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C466.1,233.5,464.8,234.8,464.8,236.3z"
        />
        <path
          className="st0"
          d="M458.8,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C460.1,202.2,458.8,203.4,458.8,205z
		"
        />
        <path
          className="st0"
          d="M458.8,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,216.1,458.8,217.4,458.8,218.9z"
        />
        <path
          className="st0"
          d="M458.8,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,209.1,458.8,210.4,458.8,211.9z"
        />
        <path
          className="st0"
          d="M476.9,264.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,261.4,476.9,262.7,476.9,264.2z"
        />
        <path
          className="st0"
          d="M458.8,246.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C460.1,244,458.8,245.2,458.8,246.8z"
        />
        <path
          className="st0"
          d="M464.8,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C466.1,240.5,464.8,241.8,464.8,243.3z"
        />
        <path
          className="st0"
          d="M476.9,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,198.7,476.9,199.9,476.9,201.5z"
        />
        <path
          className="st0"
          d="M476.9,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C478.2,212.6,476.9,213.9,476.9,215.4z"
        />
        <path
          className="st0"
          d="M476.9,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C478.2,205.6,476.9,206.9,476.9,208.4z"
        />
        <path
          className="st0"
          d="M476.9,278.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,275.4,476.9,276.6,476.9,278.2z"
        />
        <path
          className="st0"
          d="M482.9,267.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C484.2,264.9,482.9,266.2,482.9,267.7z"
        />
        <path
          className="st0"
          d="M476.9,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,233.5,476.9,234.8,476.9,236.3z"
        />
        <path
          className="st0"
          d="M476.9,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,219.6,476.9,220.8,476.9,222.4z"
        />
        <path
          className="st0"
          d="M476.9,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C478.2,240.5,476.9,241.8,476.9,243.3z"
        />
        <path
          className="st0"
          d="M476.9,257.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,254.4,476.9,255.7,476.9,257.2z"
        />
        <path
          className="st0"
          d="M476.9,250.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,247.5,476.9,248.7,476.9,250.3z"
        />
        <path
          className="st0"
          d="M476.9,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,226.6,476.9,227.8,476.9,229.4z"
        />
        <path
          className="st0"
          d="M476.9,271.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C478.2,268.4,476.9,269.6,476.9,271.2z"
        />
        <path
          className="st0"
          d="M489,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C490.2,233.5,489,234.8,489,236.3z"
        />
        <path
          className="st0"
          d="M440.7,131.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,130.2,440.7,131.8z"
        />
        <path
          className="st0"
          d="M440.7,138.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,137.2,440.7,138.7z"
        />
        <path
          className="st0"
          d="M440.7,152.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,151.1,440.7,152.7z"
        />
        <path
          className="st0"
          d="M440.7,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,144.2,440.7,145.7z"
        />
        <path
          className="st0"
          d="M440.7,103.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,102.3,440.7,103.9z"
        />
        <path
          className="st0"
          d="M440.7,124.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,123.3,440.7,124.8z"
        />
        <path
          className="st0"
          d="M440.7,117.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,116.3,440.7,117.8z"
        />
        <path
          className="st0"
          d="M440.7,110.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,109.3,440.7,110.9z"
        />
        <path
          className="st0"
          d="M440.7,180.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,179,440.7,180.6z"
        />
        <path
          className="st0"
          d="M440.7,159.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,158.1,440.7,159.7z"
        />
        <path
          className="st0"
          d="M440.7,194.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,193,440.7,194.5z"
        />
        <path
          className="st0"
          d="M440.7,187.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,186,440.7,187.5z"
        />
        <path
          className="st0"
          d="M440.7,166.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,165.1,440.7,166.6z"
        />
        <path
          className="st0"
          d="M440.7,201.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,199.9,440.7,201.5z"
        />
        <path
          className="st0"
          d="M440.7,173.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,172,440.7,173.6z"
        />
        <path
          className="st0"
          d="M434.6,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,230,434.6,231.3,434.6,232.8z"
        />
        <path
          className="st0"
          d="M434.6,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,216.1,434.6,217.4,434.6,218.9z"
        />
        <path
          className="st0"
          d="M434.6,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C435.9,223.1,434.6,224.3,434.6,225.9z"
        />
        <path
          className="st0"
          d="M440.7,96.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,95.4,440.7,96.9z"
        />
        <path
          className="st0"
          d="M440.7,243.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S440.7,241.8,440.7,243.3z"
        />
        <path
          className="st0"
          d="M434.6,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C435.9,209.1,434.6,210.4,434.6,211.9z"
        />
        <path
          className="st0"
          d="M434.6,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C435.9,202.2,434.6,203.4,434.6,205z
		"
        />
        <path
          className="st0"
          d="M440.7,83c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,81.4,440.7,83z"
        />
        <path
          className="st0"
          d="M446.7,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C448,202.2,446.7,203.4,446.7,205z"
        />
        <path
          className="st0"
          d="M440.7,89.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,88.4,440.7,89.9z"
        />
        <path
          className="st0"
          d="M440.7,76c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,74.5,440.7,76z"
        />
        <path
          className="st0"
          d="M440.7,62.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S440.7,60.5,440.7,62.1z"
        />
        <path
          className="st0"
          d="M440.7,69c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,67.5,440.7,69z"
        />
        <path
          className="st0"
          d="M440.7,55.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S440.7,53.5,440.7,55.1z"
        />
        <path
          className="st0"
          d="M434.6,58.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C435.9,55.8,434.6,57,434.6,58.6z"
        />
        <path
          className="st0"
          d="M446.7,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,132.5,446.7,133.7,446.7,135.3z"
        />
        <path
          className="st0"
          d="M446.7,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C448,153.4,446.7,154.6,446.7,156.2z"
        />
        <path
          className="st0"
          d="M446.7,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,146.4,446.7,147.7,446.7,149.2z"
        />
        <path
          className="st0"
          d="M446.7,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C448,139.4,446.7,140.7,446.7,142.2z"
        />
        <path
          className="st0"
          d="M446.7,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,118.5,446.7,119.8,446.7,121.3z"
        />
        <path
          className="st0"
          d="M446.7,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,125.5,446.7,126.7,446.7,128.3z"
        />
        <path
          className="st0"
          d="M446.7,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C448,188.2,446.7,189.5,446.7,191z"
        />
        <path
          className="st0"
          d="M446.7,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C448,181.2,446.7,182.5,446.7,184.1z"
        />
        <path
          className="st0"
          d="M446.7,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,111.5,446.7,112.8,446.7,114.3z"
        />
        <path
          className="st0"
          d="M446.7,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C448,160.3,446.7,161.6,446.7,163.1z"
        />
        <path
          className="st0"
          d="M446.7,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,195.2,446.7,196.4,446.7,198z"
        />
        <path
          className="st0"
          d="M446.7,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C448,167.3,446.7,168.6,446.7,170.1z"
        />
        <path
          className="st0"
          d="M446.7,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C448,174.3,446.7,175.5,446.7,177.1z"
        />
        <path
          className="st0"
          d="M446.7,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,97.6,446.7,98.9,446.7,100.4z"
        />
        <path
          className="st0"
          d="M440.7,229.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,227.8,440.7,229.4z"
        />
        <path
          className="st0"
          d="M446.7,58.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C448,55.8,446.7,57,446.7,58.6z"
        />
        <path
          className="st0"
          d="M446.7,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,237,446.7,238.3,446.7,239.8z"
        />
        <path
          className="st0"
          d="M440.7,236.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,234.8,440.7,236.3z"
        />
        <path
          className="st0"
          d="M446.7,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,104.6,446.7,105.8,446.7,107.4z"
        />
        <path
          className="st0"
          d="M440.7,222.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S440.7,220.8,440.7,222.4z"
        />
        <path
          className="st0"
          d="M440.7,215.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S440.7,213.9,440.7,215.4z"
        />
        <path
          className="st0"
          d="M446.7,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,83.7,446.7,84.9,446.7,86.5z"
        />
        <path
          className="st0"
          d="M446.7,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C448,90.6,446.7,91.9,446.7,93.4z"
        />
        <path
          className="st0"
          d="M440.7,208.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S440.7,206.9,440.7,208.4z"
        />
        <path
          className="st0"
          d="M446.7,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C448,62.7,446.7,64,446.7,65.5
		z"
        />
        <path
          className="st0"
          d="M446.7,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C448,69.7,446.7,71,446.7,72.5
		z"
        />
        <path
          className="st0"
          d="M446.7,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C448,76.7,446.7,77.9,446.7,79.5z"
        />
        <path
          className="st0"
          d="M398.4,184.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S398.4,182.5,398.4,184.1z"
        />
        <path
          className="st0"
          d="M126.7,110.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,109.3,126.7,110.9z"
        />
        <path
          className="st0"
          d="M126.7,117.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,116.3,126.7,117.8z"
        />
        <path
          className="st0"
          d="M126.7,124.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,123.3,126.7,124.8z"
        />
        <path
          className="st0"
          d="M126.7,96.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,95.4,126.7,96.9z"
        />
        <path
          className="st0"
          d="M126.7,89.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,88.4,126.7,89.9z"
        />
        <path
          className="st0"
          d="M126.7,103.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,102.3,126.7,103.9z"
        />
        <path
          className="st0"
          d="M126.7,131.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,130.2,126.7,131.8z"
        />
        <path
          className="st0"
          d="M126.7,173.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,172,126.7,173.6z"
        />
        <path
          className="st0"
          d="M126.7,166.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,165.1,126.7,166.6z"
        />
        <path
          className="st0"
          d="M126.7,83c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,81.4,126.7,83z"
        />
        <path
          className="st0"
          d="M126.7,138.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,137.2,126.7,138.7z"
        />
        <path
          className="st0"
          d="M126.7,159.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,158.1,126.7,159.7z"
        />
        <path
          className="st0"
          d="M126.7,152.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,151.1,126.7,152.7z"
        />
        <path
          className="st0"
          d="M126.7,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,144.2,126.7,145.7z"
        />
        <path
          className="st0"
          d="M138.8,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C140.1,80.2,138.8,81.4,138.8,83
		z"
        />
        <path
          className="st0"
          d="M138.8,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,108.1,138.8,109.3,138.8,110.9z"
        />
        <path
          className="st0"
          d="M138.8,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,122,138.8,123.3,138.8,124.8z"
        />
        <path
          className="st0"
          d="M138.8,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,115,138.8,116.3,138.8,117.8z"
        />
        <path
          className="st0"
          d="M138.8,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,129,138.8,130.2,138.8,131.8z"
        />
        <path
          className="st0"
          d="M138.8,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,142.9,138.8,144.2,138.8,145.7z"
        />
        <path
          className="st0"
          d="M138.8,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,135.9,138.8,137.2,138.8,138.7z"
        />
        <path
          className="st0"
          d="M126.7,180.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,179,126.7,180.6z"
        />
        <path
          className="st0"
          d="M138.8,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,87.1,138.8,88.4,138.8,89.9z"
        />
        <path
          className="st0"
          d="M126.7,201.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,199.9,126.7,201.5z"
        />
        <path
          className="st0"
          d="M138.8,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,101.1,138.8,102.3,138.8,103.9z"
        />
        <path
          className="st0"
          d="M138.8,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,94.1,138.8,95.4,138.8,96.9z"
        />
        <path
          className="st0"
          d="M126.7,76c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,74.5,126.7,76z"
        />
        <path
          className="st0"
          d="M132.8,156.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S132.8,154.6,132.8,156.2z"
        />
        <path
          className="st0"
          d="M132.8,163.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S132.8,161.6,132.8,163.1z"
        />
        <path
          className="st0"
          d="M132.8,170.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S132.8,168.6,132.8,170.1z"
        />
        <path
          className="st0"
          d="M132.8,191c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S132.8,189.5,132.8,191z"
        />
        <path
          className="st0"
          d="M132.8,177.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S132.8,175.5,132.8,177.1z"
        />
        <path
          className="st0"
          d="M126.7,194.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,193,126.7,194.5z"
        />
        <path
          className="st0"
          d="M132.8,149.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S132.8,147.7,132.8,149.2z"
        />
        <path
          className="st0"
          d="M138.8,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,149.9,138.8,151.1,138.8,152.7z"
        />
        <path
          className="st0"
          d="M138.8,34.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C140.1,31.4,138.8,32.6,138.8,34.2z
		"
        />
        <path
          className="st0"
          d="M138.8,41.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C140.1,38.3,138.8,39.6,138.8,41.1z
		"
        />
        <path
          className="st0"
          d="M144.9,30.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,27.9,144.9,29.1,144.9,30.7z"
        />
        <path
          className="st0"
          d="M132.8,135.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S132.8,133.7,132.8,135.3z"
        />
        <path
          className="st0"
          d="M138.8,48.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C140.1,45.3,138.8,46.6,138.8,48.1z
		"
        />
        <path
          className="st0"
          d="M132.8,184.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S132.8,182.5,132.8,184.1z"
        />
        <path
          className="st0"
          d="M138.8,55.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C140.1,52.3,138.8,53.5,138.8,55.1z
		"
        />
        <path
          className="st0"
          d="M132.8,142.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S132.8,140.7,132.8,142.2z"
        />
        <path
          className="st0"
          d="M132.8,128.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S132.8,126.7,132.8,128.3z"
        />
        <path
          className="st0"
          d="M132.8,37.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S132.8,36.1,132.8,37.7z"
        />
        <path
          className="st0"
          d="M132.8,79.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S132.8,77.9,132.8,79.5z"
        />
        <path
          className="st0"
          d="M132.8,72.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S132.8,71,132.8,72.5z"
        />
        <path
          className="st0"
          d="M126.7,187.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S126.7,186,126.7,187.5z"
        />
        <path
          className="st0"
          d="M132.8,44.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S132.8,43.1,132.8,44.6z"
        />
        <path
          className="st0"
          d="M132.8,107.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S132.8,105.8,132.8,107.4z"
        />
        <path
          className="st0"
          d="M132.8,114.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S132.8,112.8,132.8,114.3z"
        />
        <path
          className="st0"
          d="M132.8,86.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S132.8,84.9,132.8,86.5z"
        />
        <path
          className="st0"
          d="M132.8,121.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S132.8,119.8,132.8,121.3z"
        />
        <path
          className="st0"
          d="M132.8,93.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S132.8,91.9,132.8,93.4z"
        />
        <path
          className="st0"
          d="M132.8,100.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S132.8,98.9,132.8,100.4z"
        />
        <path
          className="st0"
          d="M120.7,58.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C122,55.8,120.7,57,120.7,58.6z"
        />
        <path
          className="st0"
          d="M120.7,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C122,97.6,120.7,98.9,120.7,100.4z"
        />
        <path
          className="st0"
          d="M120.7,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C122,111.5,120.7,112.8,120.7,114.3z"
        />
        <path
          className="st0"
          d="M187.1,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C188.4,205.6,187.1,206.9,187.1,208.4z"
        />
        <path
          className="st0"
          d="M120.7,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C122,90.6,120.7,91.9,120.7,93.4z"
        />
        <path
          className="st0"
          d="M120.7,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C122,83.7,120.7,84.9,120.7,86.5z"
        />
        <path
          className="st0"
          d="M120.7,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C122,69.7,120.7,71,120.7,72.5
		z"
        />
        <path
          className="st0"
          d="M120.7,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C122,76.7,120.7,77.9,120.7,79.5z"
        />
        <path
          className="st0"
          d="M120.7,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C122,125.5,120.7,126.7,120.7,128.3z"
        />
        <path
          className="st0"
          d="M120.7,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C122,146.4,120.7,147.7,120.7,149.2z"
        />
        <path
          className="st0"
          d="M120.7,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C122,139.4,120.7,140.7,120.7,142.2z"
        />
        <path
          className="st0"
          d="M120.7,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C122,153.4,120.7,154.6,120.7,156.2z"
        />
        <path
          className="st0"
          d="M120.7,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C122,118.5,120.7,119.8,120.7,121.3z"
        />
        <path
          className="st0"
          d="M120.7,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C122,132.5,120.7,133.7,120.7,135.3z"
        />
        <path
          className="st0"
          d="M120.7,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C122,62.7,120.7,64,120.7,65.5
		z"
        />
        <path
          className="st0"
          d="M114.7,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,156.8,114.7,158.1,114.7,159.7z"
        />
        <path
          className="st0"
          d="M114.7,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,135.9,114.7,137.2,114.7,138.7z"
        />
        <path
          className="st0"
          d="M114.7,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,142.9,114.7,144.2,114.7,145.7z"
        />
        <path
          className="st0"
          d="M114.7,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,149.9,114.7,151.1,114.7,152.7z"
        />
        <path
          className="st0"
          d="M114.7,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,129,114.7,130.2,114.7,131.8z"
        />
        <path
          className="st0"
          d="M114.7,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,122,114.7,123.3,114.7,124.8z"
        />
        <path
          className="st0"
          d="M144.9,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,62.7,144.9,64,144.9,65.5z"
        />
        <path
          className="st0"
          d="M114.7,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,115,114.7,116.3,114.7,117.8z"
        />
        <path
          className="st0"
          d="M120.7,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C122,195.2,120.7,196.4,120.7,198z"
        />
        <path
          className="st0"
          d="M120.7,51.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C122,48.8,120.7,50.1,120.7,51.6z"
        />
        <path
          className="st0"
          d="M120.7,44.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C122,41.8,120.7,43.1,120.7,44.6z"
        />
        <path
          className="st0"
          d="M114.7,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,170.8,114.7,172,114.7,173.6z"
        />
        <path
          className="st0"
          d="M114.7,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,163.8,114.7,165.1,114.7,166.6z"
        />
        <path
          className="st0"
          d="M114.7,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,177.8,114.7,179,114.7,180.6z"
        />
        <path
          className="st0"
          d="M120.7,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C122,160.3,120.7,161.6,120.7,163.1z"
        />
        <path
          className="st0"
          d="M138.8,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,163.8,138.8,165.1,138.8,166.6z"
        />
        <path
          className="st0"
          d="M144.9,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,146.4,144.9,147.7,144.9,149.2z"
        />
        <path
          className="st0"
          d="M144.9,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C146.1,153.4,144.9,154.6,144.9,156.2z"
        />
        <path
          className="st0"
          d="M144.9,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C146.1,160.3,144.9,161.6,144.9,163.1z"
        />
        <path
          className="st0"
          d="M120.7,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C122,167.3,120.7,168.6,120.7,170.1z"
        />
        <path
          className="st0"
          d="M144.9,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,125.5,144.9,126.7,144.9,128.3z"
        />
        <path
          className="st0"
          d="M144.9,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C146.1,139.4,144.9,140.7,144.9,142.2z"
        />
        <path
          className="st0"
          d="M144.9,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,132.5,144.9,133.7,144.9,135.3z"
        />
        <path
          className="st0"
          d="M138.8,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,170.8,138.8,172,138.8,173.6z"
        />
        <path
          className="st0"
          d="M144.9,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C146.1,167.3,144.9,168.6,144.9,170.1z"
        />
        <path
          className="st0"
          d="M144.9,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,118.5,144.9,119.8,144.9,121.3z"
        />
        <path
          className="st0"
          d="M138.8,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,156.8,138.8,158.1,138.8,159.7z"
        />
        <path
          className="st0"
          d="M138.8,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,177.8,138.8,179,138.8,180.6z"
        />
        <path
          className="st0"
          d="M138.8,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C140.1,73.2,138.8,74.5,138.8,76
		z"
        />
        <path
          className="st0"
          d="M138.8,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C140.1,184.7,138.8,186,138.8,187.5z"
        />
        <path
          className="st0"
          d="M144.9,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C146.1,174.3,144.9,175.5,144.9,177.1z"
        />
        <path
          className="st0"
          d="M144.9,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C146.1,181.2,144.9,182.5,144.9,184.1z"
        />
        <path
          className="st0"
          d="M144.9,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,111.5,144.9,112.8,144.9,114.3z"
        />
        <path
          className="st0"
          d="M120.7,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C122,181.2,120.7,182.5,120.7,184.1z"
        />
        <path
          className="st0"
          d="M120.7,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C122,188.2,120.7,189.5,120.7,191z"
        />
        <path
          className="st0"
          d="M120.7,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C122,174.3,120.7,175.5,120.7,177.1z"
        />
        <path
          className="st0"
          d="M150.9,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C152.2,80.2,150.9,81.4,150.9,83
		z"
        />
        <path
          className="st0"
          d="M144.9,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,97.6,144.9,98.9,144.9,100.4z"
        />
        <path
          className="st0"
          d="M144.9,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,90.6,144.9,91.9,144.9,93.4z"
        />
        <path
          className="st0"
          d="M144.9,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,104.6,144.9,105.8,144.9,107.4z"
        />
        <path
          className="st0"
          d="M144.9,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,83.7,144.9,84.9,144.9,86.5z"
        />
        <path
          className="st0"
          d="M144.9,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,69.7,144.9,71,144.9,72.5z"
        />
        <path
          className="st0"
          d="M144.9,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C146.1,76.7,144.9,77.9,144.9,79.5z
		"
        />
        <path
          className="st0"
          d="M181.1,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C182.3,118.5,181.1,119.8,181.1,121.3z"
        />
        <path
          className="st0"
          d="M163,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C164.2,184.7,163,186,163,187.5
		z"
        />
        <path
          className="st0"
          d="M163,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C164.2,177.8,163,179,163,180.6
		z"
        />
        <path
          className="st0"
          d="M163,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C164.2,170.8,163,172,163,173.6
		z"
        />
        <path
          className="st0"
          d="M163,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C164.2,163.8,163,165.1,163,166.6z"
        />
        <path
          className="st0"
          d="M163,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C164.2,149.9,163,151.1,163,152.7z"
        />
        <path
          className="st0"
          d="M163,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C164.2,156.8,163,158.1,163,159.7z"
        />
        <path
          className="st0"
          d="M181.1,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C182.3,195.2,181.1,196.4,181.1,198z"
        />
        <path
          className="st0"
          d="M181.1,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C182.3,167.3,181.1,168.6,181.1,170.1z"
        />
        <path
          className="st0"
          d="M181.1,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C182.3,160.3,181.1,161.6,181.1,163.1z"
        />
        <path
          className="st0"
          d="M181.1,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C182.3,153.4,181.1,154.6,181.1,156.2z"
        />
        <path
          className="st0"
          d="M163,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C164.2,142.9,163,144.2,163,145.7z"
        />
        <path
          className="st0"
          d="M181.1,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C182.3,181.2,181.1,182.5,181.1,184.1z"
        />
        <path
          className="st0"
          d="M181.1,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C182.3,188.2,181.1,189.5,181.1,191z
		"
        />
        <path
          className="st0"
          d="M181.1,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C182.3,174.3,181.1,175.5,181.1,177.1z"
        />
        <path
          className="st0"
          d="M163,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C164.2,87.1,163,88.4,163,89.9z"
        />
        <path
          className="st0"
          d="M163,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C164.2,66.2,163,67.5,163,69z"
        />
        <path
          className="st0"
          d="M156.9,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C158.2,69.7,156.9,71,156.9,72.5z"
        />
        <path
          className="st0"
          d="M163,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C164.2,80.2,163,81.4,163,83z"
        />
        <path
          className="st0"
          d="M169,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C170.3,174.3,169,175.5,169,177.1z"
        />
        <path
          className="st0"
          d="M163,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C164.2,135.9,163,137.2,163,138.7z"
        />
        <path
          className="st0"
          d="M169,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C170.3,181.2,169,182.5,169,184.1z"
        />
        <path
          className="st0"
          d="M181.1,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C182.3,146.4,181.1,147.7,181.1,149.2z"
        />
        <path
          className="st0"
          d="M169,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C170.3,167.3,169,168.6,169,170.1z"
        />
        <path
          className="st0"
          d="M163,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C164.2,122,163,123.3,163,124.8
		z"
        />
        <path
          className="st0"
          d="M163,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C164.2,115,163,116.3,163,117.8
		z"
        />
        <path
          className="st0"
          d="M163,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C164.2,129,163,130.2,163,131.8
		z"
        />
        <path
          className="st0"
          d="M163,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C164.2,101.1,163,102.3,163,103.9z"
        />
        <path
          className="st0"
          d="M163,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C164.2,94.1,163,95.4,163,96.9z"
        />
        <path
          className="st0"
          d="M163,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C164.2,108.1,163,109.3,163,110.9z"
        />
        <path
          className="st0"
          d="M175,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C176.3,184.7,175,186,175,187.5
		z"
        />
        <path
          className="st0"
          d="M175,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C176.3,142.9,175,144.2,175,145.7z"
        />
        <circle className="st0" cx="177.8" cy="138.7" r="2.8" />
        <path
          className="st0"
          d="M181.1,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C182.3,139.4,181.1,140.7,181.1,142.2z"
        />
        <path
          className="st0"
          d="M175,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C176.3,129,175,130.2,175,131.8
		z"
        />
        <path
          className="st0"
          d="M175,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C176.3,149.9,175,151.1,175,152.7z"
        />
        <path
          className="st0"
          d="M175,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C176.3,163.8,175,165.1,175,166.6z"
        />
        <path
          className="st0"
          d="M175,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C176.3,156.8,175,158.1,175,159.7z"
        />
        <path
          className="st0"
          d="M175,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C176.3,122,175,123.3,175,124.8
		z"
        />
        <path
          className="st0"
          d="M175,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C176.3,94.1,175,95.4,175,96.9z"
        />
        <path
          className="st0"
          d="M175,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C176.3,87.1,175,88.4,175,89.9z"
        />
        <path
          className="st0"
          d="M187.1,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,87.1,187.1,88.4,187.1,89.9z"
        />
        <circle className="st0" cx="177.8" cy="110.9" r="2.8" />
        <path
          className="st0"
          d="M175,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C176.3,101.1,175,102.3,175,103.9z"
        />
        <path
          className="st0"
          d="M175,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C176.3,115,175,116.3,175,117.8
		z"
        />
        <path
          className="st0"
          d="M175,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C176.3,170.8,175,172,175,173.6
		z"
        />
        <path
          className="st0"
          d="M181.1,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C182.3,111.5,181.1,112.8,181.1,114.3z"
        />
        <path
          className="st0"
          d="M181.1,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C182.3,104.6,181.1,105.8,181.1,107.4z"
        />
        <path
          className="st0"
          d="M114.7,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,108.1,114.7,109.3,114.7,110.9z"
        />
        <path
          className="st0"
          d="M181.1,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C182.3,125.5,181.1,126.7,181.1,128.3z"
        />
        <path
          className="st0"
          d="M181.1,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C182.3,132.5,181.1,133.7,181.1,135.3z"
        />
        <path
          className="st0"
          d="M175,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C176.3,177.8,175,179,175,180.6
		z"
        />
        <path
          className="st0"
          d="M181.1,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C182.3,97.6,181.1,98.9,181.1,100.4z"
        />
        <path
          className="st0"
          d="M181.1,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C182.3,90.6,181.1,91.9,181.1,93.4z"
        />
        <path
          className="st0"
          d="M169,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C170.3,160.3,169,161.6,169,163.1z"
        />
        <circle className="st0" cx="177.8" cy="83" r="2.8" />
        <path
          className="st0"
          d="M181.1,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C182.3,69.7,181.1,71,181.1,72.5z"
        />
        <path
          className="st0"
          d="M175,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C176.3,191.7,175,193,175,194.5
		z"
        />
        <path
          className="st0"
          d="M181.1,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C182.3,83.7,181.1,84.9,181.1,86.5z"
        />
        <path
          className="st0"
          d="M187.1,83c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S187.1,81.4,187.1,83z"
        />
        <path
          className="st0"
          d="M156.9,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C158.2,97.6,156.9,98.9,156.9,100.4z"
        />
        <path
          className="st0"
          d="M150.9,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,170.8,150.9,172,150.9,173.6z"
        />
        <path
          className="st0"
          d="M150.9,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,156.8,150.9,158.1,150.9,159.7z"
        />
        <path
          className="st0"
          d="M150.9,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,163.8,150.9,165.1,150.9,166.6z"
        />
        <path
          className="st0"
          d="M150.9,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,149.9,150.9,151.1,150.9,152.7z"
        />
        <path
          className="st0"
          d="M150.9,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,142.9,150.9,144.2,150.9,145.7z"
        />
        <path
          className="st0"
          d="M150.9,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,129,150.9,130.2,150.9,131.8z"
        />
        <path
          className="st0"
          d="M150.9,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,122,150.9,123.3,150.9,124.8z"
        />
        <path
          className="st0"
          d="M150.9,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,135.9,150.9,137.2,150.9,138.7z"
        />
        <path
          className="st0"
          d="M126.7,41.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S126.7,39.6,126.7,41.1z"
        />
        <path
          className="st0"
          d="M150.9,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,184.7,150.9,186,150.9,187.5z"
        />
        <path
          className="st0"
          d="M126.7,48.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S126.7,46.6,126.7,48.1z"
        />
        <path
          className="st0"
          d="M156.9,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C158.2,188.2,156.9,189.5,156.9,191z
		"
        />
        <path
          className="st0"
          d="M150.9,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,177.8,150.9,179,150.9,180.6z"
        />
        <path
          className="st0"
          d="M126.7,55.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S126.7,53.5,126.7,55.1z"
        />
        <path
          className="st0"
          d="M144.9,44.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C146.1,41.8,144.9,43.1,144.9,44.6z
		"
        />
        <path
          className="st0"
          d="M150.9,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C152.2,59.3,150.9,60.5,150.9,62.1z
		"
        />
        <path
          className="st0"
          d="M156.9,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C158.2,76.7,156.9,77.9,156.9,79.5z
		"
        />
        <path
          className="st0"
          d="M150.9,34.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C152.2,31.4,150.9,32.6,150.9,34.2z
		"
        />
        <path
          className="st0"
          d="M144.9,37.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C146.1,34.9,144.9,36.1,144.9,37.7z"
        />
        <path
          className="st0"
          d="M144.9,51.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C146.1,48.8,144.9,50.1,144.9,51.6z
		"
        />
        <path
          className="st0"
          d="M150.9,41.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C152.2,38.3,150.9,39.6,150.9,41.1z
		"
        />
        <path
          className="st0"
          d="M150.9,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,115,150.9,116.3,150.9,117.8z"
        />
        <path
          className="st0"
          d="M150.9,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,101.1,150.9,102.3,150.9,103.9z"
        />
        <path
          className="st0"
          d="M150.9,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,94.1,150.9,95.4,150.9,96.9z"
        />
        <path
          className="st0"
          d="M150.9,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,108.1,150.9,109.3,150.9,110.9z"
        />
        <path
          className="st0"
          d="M150.9,48.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C152.2,45.3,150.9,46.6,150.9,48.1z
		"
        />
        <path
          className="st0"
          d="M150.9,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C152.2,87.1,150.9,88.4,150.9,89.9z"
        />
        <path
          className="st0"
          d="M150.9,55.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C152.2,52.3,150.9,53.5,150.9,55.1z
		"
        />
        <path
          className="st0"
          d="M169,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C170.3,153.4,169,154.6,169,156.2z"
        />
        <path
          className="st0"
          d="M169,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C170.3,90.6,169,91.9,169,93.4z"
        />
        <path
          className="st0"
          d="M169,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C170.3,83.7,169,84.9,169,86.5z"
        />
        <path
          className="st0"
          d="M169,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C170.3,104.6,169,105.8,169,107.4z"
        />
        <path
          className="st0"
          d="M169,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C170.3,97.6,169,98.9,169,100.4
		z"
        />
        <path
          className="st0"
          d="M169,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C170.3,188.2,169,189.5,169,191z"
        />
        <path
          className="st0"
          d="M169,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C170.3,76.7,169,77.9,169,79.5z"
        />
        <path
          className="st0"
          d="M169,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C170.3,111.5,169,112.8,169,114.3z"
        />
        <path
          className="st0"
          d="M169,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C170.3,132.5,169,133.7,169,135.3z"
        />
        <path
          className="st0"
          d="M156.9,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C158.2,174.3,156.9,175.5,156.9,177.1z"
        />
        <path
          className="st0"
          d="M169,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C170.3,146.4,169,147.7,169,149.2z"
        />
        <path
          className="st0"
          d="M156.9,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C158.2,83.7,156.9,84.9,156.9,86.5z"
        />
        <path
          className="st0"
          d="M169,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C170.3,118.5,169,119.8,169,121.3z"
        />
        <path
          className="st0"
          d="M169,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C170.3,125.5,169,126.7,169,128.3z"
        />
        <path
          className="st0"
          d="M169,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C170.3,139.4,169,140.7,169,142.2z"
        />
        <path
          className="st0"
          d="M156.9,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C158.2,111.5,156.9,112.8,156.9,114.3z"
        />
        <path
          className="st0"
          d="M156.9,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C158.2,125.5,156.9,126.7,156.9,128.3z"
        />
        <path
          className="st0"
          d="M156.9,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C158.2,104.6,156.9,105.8,156.9,107.4z"
        />
        <path
          className="st0"
          d="M156.9,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C158.2,118.5,156.9,119.8,156.9,121.3z"
        />
        <path
          className="st0"
          d="M144.9,58.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C146.1,55.8,144.9,57,144.9,58.6z"
        />
        <path
          className="st0"
          d="M156.9,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C158.2,90.6,156.9,91.9,156.9,93.4z"
        />
        <path
          className="st0"
          d="M156.9,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C158.2,146.4,156.9,147.7,156.9,149.2z"
        />
        <path
          className="st0"
          d="M156.9,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C158.2,160.3,156.9,161.6,156.9,163.1z"
        />
        <path
          className="st0"
          d="M156.9,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C158.2,132.5,156.9,133.7,156.9,135.3z"
        />
        <path
          className="st0"
          d="M156.9,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C158.2,153.4,156.9,154.6,156.9,156.2z"
        />
        <path
          className="st0"
          d="M156.9,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C158.2,167.3,156.9,168.6,156.9,170.1z"
        />
        <path
          className="st0"
          d="M156.9,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C158.2,181.2,156.9,182.5,156.9,184.1z"
        />
        <path
          className="st0"
          d="M156.9,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C158.2,139.4,156.9,140.7,156.9,142.2z"
        />
        <path
          className="st0"
          d="M120.7,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C122,104.6,120.7,105.8,120.7,107.4z"
        />
        <path
          className="st0"
          d="M60.3,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C61.6,76.7,60.3,77.9,60.3,79.5z"
        />
        <path
          className="st0"
          d="M60.3,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C61.6,97.6,60.3,98.9,60.3,100.4z"
        />
        <path
          className="st0"
          d="M60.3,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C61.6,90.6,60.3,91.9,60.3,93.4
		z"
        />
        <path
          className="st0"
          d="M54.3,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,184.7,54.3,186,54.3,187.5z"
        />
        <path
          className="st0"
          d="M54.3,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,177.8,54.3,179,54.3,180.6z"
        />
        <path
          className="st0"
          d="M60.3,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C61.6,69.7,60.3,71,60.3,72.5z"
        />
        <path
          className="st0"
          d="M60.3,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C61.6,188.2,60.3,189.5,60.3,191z"
        />
        <path
          className="st0"
          d="M60.3,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C61.6,83.7,60.3,84.9,60.3,86.5
		z"
        />
        <path
          className="st0"
          d="M60.3,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C61.6,132.5,60.3,133.7,60.3,135.3z"
        />
        <path
          className="st0"
          d="M60.3,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C61.6,104.6,60.3,105.8,60.3,107.4z"
        />
        <path
          className="st0"
          d="M60.3,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C61.6,139.4,60.3,140.7,60.3,142.2z
		"
        />
        <path
          className="st0"
          d="M60.3,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C61.6,125.5,60.3,126.7,60.3,128.3z"
        />
        <path
          className="st0"
          d="M60.3,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C61.6,111.5,60.3,112.8,60.3,114.3z"
        />
        <path
          className="st0"
          d="M60.3,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C61.6,118.5,60.3,119.8,60.3,121.3z"
        />
        <path
          className="st0"
          d="M36.2,170.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S36.2,168.6,36.2,170.1z"
        />
        <path
          className="st0"
          d="M54.3,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,108.1,54.3,109.3,54.3,110.9z"
        />
        <path
          className="st0"
          d="M54.3,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,115,54.3,116.3,54.3,117.8z"
        />
        <path
          className="st0"
          d="M54.3,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,122,54.3,123.3,54.3,124.8z"
        />
        <path
          className="st0"
          d="M54.3,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,101.1,54.3,102.3,54.3,103.9z"
        />
        <path
          className="st0"
          d="M54.3,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C55.6,94.1,54.3,95.4,54.3,96.9
		z"
        />
        <path
          className="st0"
          d="M60.3,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C61.6,146.4,60.3,147.7,60.3,149.2z"
        />
        <path
          className="st0"
          d="M54.3,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,191.7,54.3,193,54.3,194.5z"
        />
        <path
          className="st0"
          d="M54.3,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,156.8,54.3,158.1,54.3,159.7z"
        />
        <path
          className="st0"
          d="M54.3,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,149.9,54.3,151.1,54.3,152.7z"
        />
        <path
          className="st0"
          d="M54.3,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,163.8,54.3,165.1,54.3,166.6z"
        />
        <path
          className="st0"
          d="M54.3,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,142.9,54.3,144.2,54.3,145.7z"
        />
        <path
          className="st0"
          d="M54.3,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,129,54.3,130.2,54.3,131.8z"
        />
        <path
          className="st0"
          d="M54.3,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,135.9,54.3,137.2,54.3,138.7z"
        />
        <path
          className="st0"
          d="M54.3,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C55.6,170.8,54.3,172,54.3,173.6z"
        />
        <path
          className="st0"
          d="M66.4,124.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,123.3,66.4,124.8z"
        />
        <path
          className="st0"
          d="M66.4,159.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,158.1,66.4,159.7z"
        />
        <path
          className="st0"
          d="M66.4,152.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,151.1,66.4,152.7z"
        />
        <path
          className="st0"
          d="M72.4,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C73.7,160.3,72.4,161.6,72.4,163.1z
		"
        />
        <path
          className="st0"
          d="M66.4,131.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,130.2,66.4,131.8z"
        />
        <path
          className="st0"
          d="M66.4,138.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,137.2,66.4,138.7z"
        />
        <path
          className="st0"
          d="M66.4,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,144.2,66.4,145.7z"
        />
        <path
          className="st0"
          d="M66.4,166.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,165.1,66.4,166.6z"
        />
        <path
          className="st0"
          d="M72.4,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C73.7,90.6,72.4,91.9,72.4,93.4
		z"
        />
        <path
          className="st0"
          d="M60.3,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C61.6,153.4,60.3,154.6,60.3,156.2z
		"
        />
        <path
          className="st0"
          d="M72.4,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C73.7,62.7,72.4,64,72.4,65.5z"
        />
        <path
          className="st0"
          d="M78.4,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C79.7,59.3,78.4,60.5,78.4,62.1z"
        />
        <path
          className="st0"
          d="M72.4,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C73.7,97.6,72.4,98.9,72.4,100.4z"
        />
        <path
          className="st0"
          d="M72.4,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C73.7,76.7,72.4,77.9,72.4,79.5z"
        />
        <path
          className="st0"
          d="M72.4,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C73.7,69.7,72.4,71,72.4,72.5z"
        />
        <path
          className="st0"
          d="M72.4,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C73.7,83.7,72.4,84.9,72.4,86.5
		z"
        />
        <path
          className="st0"
          d="M66.4,117.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,116.3,66.4,117.8z"
        />
        <path
          className="st0"
          d="M60.3,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C61.6,174.3,60.3,175.5,60.3,177.1z
		"
        />
        <path
          className="st0"
          d="M66.4,173.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,172,66.4,173.6z"
        />
        <path
          className="st0"
          d="M60.3,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C61.6,167.3,60.3,168.6,60.3,170.1z
		"
        />
        <path
          className="st0"
          d="M60.3,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C61.6,160.3,60.3,161.6,60.3,163.1z
		"
        />
        <path
          className="st0"
          d="M66.4,69c0,1.5,1.3,2.8,2.8,2.8S72,70.6,72,69c0-1.5-1.3-2.8-2.8-2.8S66.4,67.5,66.4,69z"
        />
        <path
          className="st0"
          d="M60.3,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C61.6,181.2,60.3,182.5,60.3,184.1z
		"
        />
        <path
          className="st0"
          d="M66.4,96.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,95.4,66.4,96.9z"
        />
        <path
          className="st0"
          d="M66.4,103.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,102.3,66.4,103.9z"
        />
        <path
          className="st0"
          d="M66.4,76c0,1.5,1.3,2.8,2.8,2.8S72,77.5,72,76c0-1.5-1.3-2.8-2.8-2.8S66.4,74.5,66.4,76z"
        />
        <path
          className="st0"
          d="M66.4,110.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,109.3,66.4,110.9z"
        />
        <path
          className="st0"
          d="M66.4,89.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S66.4,88.4,66.4,89.9z"
        />
        <path
          className="st0"
          d="M66.4,83c0,1.5,1.3,2.8,2.8,2.8S72,84.5,72,83c0-1.5-1.3-2.8-2.8-2.8S66.4,81.4,66.4,83z"
        />
        <path
          className="st0"
          d="M48.3,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C49.5,153.4,48.3,154.6,48.3,156.2z
		"
        />
        <path
          className="st0"
          d="M42.2,166.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,165.1,42.2,166.6z"
        />
        <path
          className="st0"
          d="M42.2,173.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,172,42.2,173.6z"
        />
        <circle className="st0" cx="39" cy="163.1" r="2.8" />
        <path
          className="st0"
          d="M42.2,180.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,179,42.2,180.6z"
        />
        <path
          className="st0"
          d="M42.2,117.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,116.3,42.2,117.8z"
        />
        <path
          className="st0"
          d="M42.2,152.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,151.1,42.2,152.7z"
        />
        <path
          className="st0"
          d="M42.2,124.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,123.3,42.2,124.8z"
        />
        <path
          className="st0"
          d="M48.3,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C49.5,118.5,48.3,119.8,48.3,121.3z"
        />
        <path
          className="st0"
          d="M48.3,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C49.5,104.6,48.3,105.8,48.3,107.4z"
        />
        <path
          className="st0"
          d="M42.2,187.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,186,42.2,187.5z"
        />
        <path
          className="st0"
          d="M42.2,103.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,102.3,42.2,103.9z"
        />
        <path
          className="st0"
          d="M48.3,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C49.5,125.5,48.3,126.7,48.3,128.3z"
        />
        <path
          className="st0"
          d="M42.2,194.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,193,42.2,194.5z"
        />
        <path
          className="st0"
          d="M42.2,201.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,199.9,42.2,201.5z"
        />
        <path
          className="st0"
          d="M48.3,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C49.5,111.5,48.3,112.8,48.3,114.3z"
        />
        <path
          className="st0"
          d="M18.1,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C19.3,156.8,18.1,158.1,18.1,159.7z"
        />
        <path
          className="st0"
          d="M12,156.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S12,154.6,12,156.2z"
        />
        <path
          className="st0"
          d="M24.1,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C25.4,167.3,24.1,168.6,24.1,170.1z
		"
        />
        <path
          className="st0"
          d="M12,163.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S12,161.6,12,163.1z"
        />
        <path
          className="st0"
          d="M12,170.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S12,168.6,12,170.1z"
        />
        <path
          className="st0"
          d="M18.1,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C19.3,163.8,18.1,165.1,18.1,166.6z"
        />
        <path
          className="st0"
          d="M18.1,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C19.3,177.8,18.1,179,18.1,180.6z"
        />
        <path
          className="st0"
          d="M24.1,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C25.4,174.3,24.1,175.5,24.1,177.1z
		"
        />
        <path
          className="st0"
          d="M24.1,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C25.4,160.3,24.1,161.6,24.1,163.1z
		"
        />
        <path
          className="st0"
          d="M18.1,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C19.3,170.8,18.1,172,18.1,173.6z"
        />
        <path
          className="st0"
          d="M24.1,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C25.4,181.2,24.1,182.5,24.1,184.1z
		"
        />
        <path
          className="st0"
          d="M24.1,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C25.4,153.4,24.1,154.6,24.1,156.2z
		"
        />
        <path
          className="st0"
          d="M24.1,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C25.4,188.2,24.1,189.5,24.1,191z"
        />
        <path
          className="st0"
          d="M42.2,159.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S42.2,158.1,42.2,159.7z"
        />
        <path
          className="st0"
          d="M30.1,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C31.4,198.7,30.1,199.9,30.1,201.5z"
        />
        <path
          className="st0"
          d="M30.1,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C31.4,163.8,30.1,165.1,30.1,166.6z"
        />
        <path
          className="st0"
          d="M36.2,156.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S36.2,154.6,36.2,156.2z"
        />
        <path
          className="st0"
          d="M30.1,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C31.4,170.8,30.1,172,30.1,173.6z"
        />
        <path
          className="st0"
          d="M30.1,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C31.4,191.7,30.1,193,30.1,194.5z"
        />
        <path
          className="st0"
          d="M30.1,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C31.4,184.7,30.1,186,30.1,187.5z"
        />
        <path
          className="st0"
          d="M30.1,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C31.4,177.8,30.1,179,30.1,180.6z"
        />
        <path
          className="st0"
          d="M36.2,184.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S36.2,182.5,36.2,184.1z"
        />
        <path
          className="st0"
          d="M36.2,211.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S36.2,210.4,36.2,211.9z"
        />
        <path
          className="st0"
          d="M36.2,177.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S36.2,175.5,36.2,177.1z"
        />
        <path
          className="st0"
          d="M36.2,191c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S36.2,189.5,36.2,191z"
        />
        <path
          className="st0"
          d="M36.2,205c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S36.2,203.4,36.2,205z"
        />
        <path
          className="st0"
          d="M36.2,198c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S36.2,196.4,36.2,198z"
        />
        <path
          className="st0"
          d="M48.3,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C49.5,188.2,48.3,189.5,48.3,191z"
        />
        <circle className="st0" cx="51.1" cy="163.1" r="2.8" />
        <path
          className="st0"
          d="M72.4,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C73.7,104.6,72.4,105.8,72.4,107.4z"
        />
        <path
          className="st0"
          d="M30.1,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C31.4,205.6,30.1,206.9,30.1,208.4z
		"
        />
        <path
          className="st0"
          d="M48.3,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C49.5,167.3,48.3,168.6,48.3,170.1z
		"
        />
        <path
          className="st0"
          d="M48.3,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C49.5,146.4,48.3,147.7,48.3,149.2z"
        />
        <path
          className="st0"
          d="M114.7,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,101.1,114.7,102.3,114.7,103.9z"
        />
        <path
          className="st0"
          d="M48.3,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C49.5,174.3,48.3,175.5,48.3,177.1z
		"
        />
        <circle className="st0" cx="39" cy="58.6" r="2.8" />
        <path
          className="st0"
          d="M36.2,51.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C37.4,48.8,36.2,50.1,36.2,51.6z"
        />
        <path
          className="st0"
          d="M30.1,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C31.4,156.8,30.1,158.1,30.1,159.7z"
        />
        <path
          className="st0"
          d="M30.1,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C31.4,212.6,30.1,213.9,30.1,215.4z
		"
        />
        <path
          className="st0"
          d="M48.3,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C49.5,132.5,48.3,133.7,48.3,135.3z"
        />
        <path
          className="st0"
          d="M48.3,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C49.5,181.2,48.3,182.5,48.3,184.1z
		"
        />
        <path
          className="st0"
          d="M30.1,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C31.4,149.9,30.1,151.1,30.1,152.7z"
        />
        <path
          className="st0"
          d="M48.3,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C49.5,139.4,48.3,140.7,48.3,142.2z
		"
        />
        <path
          className="st0"
          d="M102.6,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,94.1,102.6,95.4,102.6,96.9z"
        />
        <path
          className="st0"
          d="M102.6,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,101.1,102.6,102.3,102.6,103.9z"
        />
        <path
          className="st0"
          d="M102.6,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,108.1,102.6,109.3,102.6,110.9z"
        />
        <path
          className="st0"
          d="M102.6,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C103.9,80.2,102.6,81.4,102.6,83
		z"
        />
        <path
          className="st0"
          d="M102.6,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,87.1,102.6,88.4,102.6,89.9z"
        />
        <path
          className="st0"
          d="M102.6,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,163.8,102.6,165.1,102.6,166.6z"
        />
        <path
          className="st0"
          d="M102.6,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,115,102.6,116.3,102.6,117.8z"
        />
        <path
          className="st0"
          d="M102.6,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,149.9,102.6,151.1,102.6,152.7z"
        />
        <path
          className="st0"
          d="M102.6,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C103.9,66.2,102.6,67.5,102.6,69
		z"
        />
        <path
          className="st0"
          d="M102.6,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,122,102.6,123.3,102.6,124.8z"
        />
        <path
          className="st0"
          d="M102.6,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,142.9,102.6,144.2,102.6,145.7z"
        />
        <path
          className="st0"
          d="M102.6,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,156.8,102.6,158.1,102.6,159.7z"
        />
        <path
          className="st0"
          d="M102.6,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,129,102.6,130.2,102.6,131.8z"
        />
        <path
          className="st0"
          d="M102.6,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,135.9,102.6,137.2,102.6,138.7z"
        />
        <path
          className="st0"
          d="M102.6,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C103.9,73.2,102.6,74.5,102.6,76
		z"
        />
        <path
          className="st0"
          d="M84.5,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C85.7,104.6,84.5,105.8,84.5,107.4z"
        />
        <path
          className="st0"
          d="M84.5,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C85.7,111.5,84.5,112.8,84.5,114.3z"
        />
        <path
          className="st0"
          d="M84.5,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C85.7,118.5,84.5,119.8,84.5,121.3z"
        />
        <path
          className="st0"
          d="M84.5,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C85.7,90.6,84.5,91.9,84.5,93.4
		z"
        />
        <path
          className="st0"
          d="M84.5,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C85.7,97.6,84.5,98.9,84.5,100.4z"
        />
        <path
          className="st0"
          d="M84.5,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C85.7,125.5,84.5,126.7,84.5,128.3z"
        />
        <path
          className="st0"
          d="M84.5,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C85.7,160.3,84.5,161.6,84.5,163.1z
		"
        />
        <path
          className="st0"
          d="M84.5,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C85.7,153.4,84.5,154.6,84.5,156.2z
		"
        />
        <path
          className="st0"
          d="M84.5,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C85.7,132.5,84.5,133.7,84.5,135.3z"
        />
        <path
          className="st0"
          d="M102.6,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C103.9,59.3,102.6,60.5,102.6,62.1z
		"
        />
        <path
          className="st0"
          d="M108.6,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C109.9,188.2,108.6,189.5,108.6,191z
		"
        />
        <path
          className="st0"
          d="M114.7,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,191.7,114.7,193,114.7,194.5z"
        />
        <path
          className="st0"
          d="M84.5,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C85.7,146.4,84.5,147.7,84.5,149.2z"
        />
        <path
          className="st0"
          d="M84.5,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C85.7,139.4,84.5,140.7,84.5,142.2z
		"
        />
        <path
          className="st0"
          d="M114.7,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,87.1,114.7,88.4,114.7,89.9z"
        />
        <path
          className="st0"
          d="M108.6,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C109.9,174.3,108.6,175.5,108.6,177.1z"
        />
        <path
          className="st0"
          d="M108.6,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C109.9,181.2,108.6,182.5,108.6,184.1z"
        />
        <path
          className="st0"
          d="M114.7,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,184.7,114.7,186,114.7,187.5z"
        />
        <path
          className="st0"
          d="M108.6,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C109.9,167.3,108.6,168.6,108.6,170.1z"
        />
        <path
          className="st0"
          d="M108.6,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C109.9,153.4,108.6,154.6,108.6,156.2z"
        />
        <path
          className="st0"
          d="M114.7,55.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C115.9,52.3,114.7,53.5,114.7,55.1z
		"
        />
        <path
          className="st0"
          d="M108.6,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C109.9,160.3,108.6,161.6,108.6,163.1z"
        />
        <path
          className="st0"
          d="M108.6,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C109.9,146.4,108.6,147.7,108.6,149.2z"
        />
        <path
          className="st0"
          d="M114.7,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C115.9,80.2,114.7,81.4,114.7,83
		z"
        />
        <path
          className="st0"
          d="M84.5,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C85.7,83.7,84.5,84.9,84.5,86.5
		z"
        />
        <path
          className="st0"
          d="M114.7,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C115.9,59.3,114.7,60.5,114.7,62.1z
		"
        />
        <path
          className="st0"
          d="M114.7,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C115.9,94.1,114.7,95.4,114.7,96.9z"
        />
        <path
          className="st0"
          d="M114.7,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C115.9,66.2,114.7,67.5,114.7,69
		z"
        />
        <path
          className="st0"
          d="M102.6,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,177.8,102.6,179,102.6,180.6z"
        />
        <path
          className="st0"
          d="M114.7,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C115.9,73.2,114.7,74.5,114.7,76
		z"
        />
        <path
          className="st0"
          d="M108.6,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C109.9,62.7,108.6,64,108.6,65.5z"
        />
        <path
          className="st0"
          d="M108.6,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C109.9,139.4,108.6,140.7,108.6,142.2z"
        />
        <path
          className="st0"
          d="M108.6,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C109.9,83.7,108.6,84.9,108.6,86.5z"
        />
        <path
          className="st0"
          d="M108.6,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C109.9,90.6,108.6,91.9,108.6,93.4z"
        />
        <path
          className="st0"
          d="M108.6,58.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C109.9,55.8,108.6,57,108.6,58.6z"
        />
        <path
          className="st0"
          d="M102.6,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C103.9,170.8,102.6,172,102.6,173.6z"
        />
        <path
          className="st0"
          d="M108.6,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C109.9,76.7,108.6,77.9,108.6,79.5z
		"
        />
        <path
          className="st0"
          d="M108.6,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C109.9,118.5,108.6,119.8,108.6,121.3z"
        />
        <path
          className="st0"
          d="M108.6,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C109.9,125.5,108.6,126.7,108.6,128.3z"
        />
        <path
          className="st0"
          d="M108.6,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C109.9,97.6,108.6,98.9,108.6,100.4z"
        />
        <path
          className="st0"
          d="M108.6,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C109.9,132.5,108.6,133.7,108.6,135.3z"
        />
        <path
          className="st0"
          d="M108.6,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C109.9,111.5,108.6,112.8,108.6,114.3z"
        />
        <path
          className="st0"
          d="M108.6,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C109.9,104.6,108.6,105.8,108.6,107.4z"
        />
        <path
          className="st0"
          d="M78.4,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C79.7,80.2,78.4,81.4,78.4,83z"
        />
        <path
          className="st0"
          d="M78.4,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C79.7,142.9,78.4,144.2,78.4,145.7z"
        />
        <path
          className="st0"
          d="M78.4,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C79.7,149.9,78.4,151.1,78.4,152.7z"
        />
        <path
          className="st0"
          d="M78.4,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C79.7,135.9,78.4,137.2,78.4,138.7z"
        />
        <path
          className="st0"
          d="M78.4,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C79.7,129,78.4,130.2,78.4,131.8z"
        />
        <path
          className="st0"
          d="M78.4,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C79.7,115,78.4,116.3,78.4,117.8z"
        />
        <path
          className="st0"
          d="M78.4,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C79.7,108.1,78.4,109.3,78.4,110.9z"
        />
        <path
          className="st0"
          d="M78.4,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C79.7,122,78.4,123.3,78.4,124.8z"
        />
        <path
          className="st0"
          d="M78.4,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C79.7,163.8,78.4,165.1,78.4,166.6z"
        />
        <path
          className="st0"
          d="M90.5,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C91.8,87.1,90.5,88.4,90.5,89.9
		z"
        />
        <path
          className="st0"
          d="M90.5,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C91.8,94.1,90.5,95.4,90.5,96.9
		z"
        />
        <path
          className="st0"
          d="M90.5,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C91.8,101.1,90.5,102.3,90.5,103.9z"
        />
        <path
          className="st0"
          d="M90.5,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C91.8,73.2,90.5,74.5,90.5,76z"
        />
        <path
          className="st0"
          d="M78.4,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C79.7,156.8,78.4,158.1,78.4,159.7z"
        />
        <path
          className="st0"
          d="M90.5,62.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C91.8,59.3,90.5,60.5,90.5,62.1z"
        />
        <path
          className="st0"
          d="M96.6,58.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C97.8,55.8,96.6,57,96.6,58.6z"
        />
        <path
          className="st0"
          d="M90.5,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C91.8,80.2,90.5,81.4,90.5,83z"
        />
        <path
          className="st0"
          d="M72.4,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C73.7,132.5,72.4,133.7,72.4,135.3z"
        />
        <path
          className="st0"
          d="M72.4,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C73.7,139.4,72.4,140.7,72.4,142.2z
		"
        />
        <path
          className="st0"
          d="M72.4,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C73.7,153.4,72.4,154.6,72.4,156.2z
		"
        />
        <path
          className="st0"
          d="M72.4,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C73.7,125.5,72.4,126.7,72.4,128.3z"
        />
        <path
          className="st0"
          d="M72.4,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C73.7,146.4,72.4,147.7,72.4,149.2z"
        />
        <path
          className="st0"
          d="M72.4,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C73.7,118.5,72.4,119.8,72.4,121.3z"
        />
        <path
          className="st0"
          d="M78.4,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C79.7,101.1,78.4,102.3,78.4,103.9z"
        />
        <path
          className="st0"
          d="M78.4,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C79.7,87.1,78.4,88.4,78.4,89.9
		z"
        />
        <path
          className="st0"
          d="M78.4,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C79.7,94.1,78.4,95.4,78.4,96.9
		z"
        />
        <path
          className="st0"
          d="M78.4,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C79.7,66.2,78.4,67.5,78.4,69z"
        />
        <path
          className="st0"
          d="M72.4,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C73.7,111.5,72.4,112.8,72.4,114.3z"
        />
        <path
          className="st0"
          d="M78.4,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C79.7,73.2,78.4,74.5,78.4,76z"
        />
        <path
          className="st0"
          d="M78.4,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C79.7,170.8,78.4,172,78.4,173.6z"
        />
        <path
          className="st0"
          d="M90.5,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C91.8,156.8,90.5,158.1,90.5,159.7z"
        />
        <path
          className="st0"
          d="M96.6,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C97.8,132.5,96.6,133.7,96.6,135.3z"
        />
        <path
          className="st0"
          d="M96.6,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C97.8,146.4,96.6,147.7,96.6,149.2z"
        />
        <path
          className="st0"
          d="M96.6,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C97.8,104.6,96.6,105.8,96.6,107.4z"
        />
        <path
          className="st0"
          d="M96.6,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C97.8,139.4,96.6,140.7,96.6,142.2z
		"
        />
        <path
          className="st0"
          d="M96.6,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C97.8,118.5,96.6,119.8,96.6,121.3z"
        />
        <path
          className="st0"
          d="M96.6,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C97.8,111.5,96.6,112.8,96.6,114.3z"
        />
        <path
          className="st0"
          d="M96.6,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C97.8,125.5,96.6,126.7,96.6,128.3z"
        />
        <path
          className="st0"
          d="M84.5,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C85.7,62.7,84.5,64,84.5,65.5z"
        />
        <path
          className="st0"
          d="M84.5,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C85.7,167.3,84.5,168.6,84.5,170.1z
		"
        />
        <path
          className="st0"
          d="M96.6,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C97.8,153.4,96.6,154.6,96.6,156.2z
		"
        />
        <path
          className="st0"
          d="M84.5,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C85.7,69.7,84.5,71,84.5,72.5z"
        />
        <path
          className="st0"
          d="M96.6,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C97.8,167.3,96.6,168.6,96.6,170.1z
		"
        />
        <path
          className="st0"
          d="M96.6,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C97.8,160.3,96.6,161.6,96.6,163.1z
		"
        />
        <path
          className="st0"
          d="M96.6,72.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C97.8,69.7,96.6,71,96.6,72.5z"
        />
        <path
          className="st0"
          d="M90.5,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C91.8,135.9,90.5,137.2,90.5,138.7z"
        />
        <path
          className="st0"
          d="M90.5,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C91.8,129,90.5,130.2,90.5,131.8z"
        />
        <path
          className="st0"
          d="M90.5,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C91.8,142.9,90.5,144.2,90.5,145.7z"
        />
        <path
          className="st0"
          d="M90.5,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C91.8,115,90.5,116.3,90.5,117.8z"
        />
        <path
          className="st0"
          d="M90.5,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C91.8,122,90.5,123.3,90.5,124.8z"
        />
        <path
          className="st0"
          d="M90.5,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C91.8,149.9,90.5,151.1,90.5,152.7z"
        />
        <path
          className="st0"
          d="M90.5,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C91.8,163.8,90.5,165.1,90.5,166.6z"
        />
        <path
          className="st0"
          d="M90.5,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C91.8,108.1,90.5,109.3,90.5,110.9z"
        />
        <path
          className="st0"
          d="M96.6,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C97.8,83.7,96.6,84.9,96.6,86.5
		z"
        />
        <path
          className="st0"
          d="M96.6,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C97.8,76.7,96.6,77.9,96.6,79.5z"
        />
        <path
          className="st0"
          d="M96.6,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C97.8,90.6,96.6,91.9,96.6,93.4
		z"
        />
        <path
          className="st0"
          d="M96.6,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C97.8,97.6,96.6,98.9,96.6,100.4z"
        />
        <path
          className="st0"
          d="M84.5,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C85.7,76.7,84.5,77.9,84.5,79.5z"
        />
        <path
          className="st0"
          d="M205.2,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C206.5,160.3,205.2,161.6,205.2,163.1z"
        />
        <path
          className="st0"
          d="M217.3,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C218.6,188.2,217.3,189.5,217.3,191z
		"
        />
        <path
          className="st0"
          d="M217.3,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C218.6,181.2,217.3,182.5,217.3,184.1z"
        />
        <path
          className="st0"
          d="M217.3,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C218.6,174.3,217.3,175.5,217.3,177.1z"
        />
        <path
          className="st0"
          d="M217.3,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C218.6,209.1,217.3,210.4,217.3,211.9z"
        />
        <path
          className="st0"
          d="M217.3,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C218.6,216.1,217.3,217.4,217.3,218.9z"
        />
        <path
          className="st0"
          d="M217.3,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C218.6,167.3,217.3,168.6,217.3,170.1z"
        />
        <path
          className="st0"
          d="M217.3,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C218.6,202.2,217.3,203.4,217.3,205z
		"
        />
        <path
          className="st0"
          d="M217.3,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C218.6,195.2,217.3,196.4,217.3,198z"
        />
        <path
          className="st0"
          d="M217.3,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C218.6,139.4,217.3,140.7,217.3,142.2z"
        />
        <path
          className="st0"
          d="M271.6,257.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,254.4,271.6,255.7,271.6,257.2z"
        />
        <path
          className="st0"
          d="M217.3,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C218.6,132.5,217.3,133.7,217.3,135.3z"
        />
        <path
          className="st0"
          d="M217.3,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C218.6,153.4,217.3,154.6,217.3,156.2z"
        />
        <path
          className="st0"
          d="M217.3,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C218.6,146.4,217.3,147.7,217.3,149.2z"
        />
        <path
          className="st0"
          d="M217.3,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C218.6,160.3,217.3,161.6,217.3,163.1z"
        />
        <path
          className="st0"
          d="M193.2,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C194.4,188.2,193.2,189.5,193.2,191z
		"
        />
        <path
          className="st0"
          d="M193.2,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C194.4,174.3,193.2,175.5,193.2,177.1z"
        />
        <path
          className="st0"
          d="M193.2,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C194.4,181.2,193.2,182.5,193.2,184.1z"
        />
        <path
          className="st0"
          d="M193.2,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C194.4,167.3,193.2,168.6,193.2,170.1z"
        />
        <path
          className="st0"
          d="M193.2,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C194.4,160.3,193.2,161.6,193.2,163.1z"
        />
        <path
          className="st0"
          d="M217.3,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C218.6,223.1,217.3,224.3,217.3,225.9z"
        />
        <path
          className="st0"
          d="M271.6,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C272.9,80.2,271.6,81.4,271.6,83
		z"
        />
        <path
          className="st0"
          d="M193.2,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C194.4,153.4,193.2,154.6,193.2,156.2z"
        />
        <path
          className="st0"
          d="M193.2,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C194.4,202.2,193.2,203.4,193.2,205z
		"
        />
        <path
          className="st0"
          d="M217.3,246.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C218.6,244,217.3,245.2,217.3,246.8z"
        />
        <path
          className="st0"
          d="M217.3,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C218.6,230,217.3,231.3,217.3,232.8z"
        />
        <path
          className="st0"
          d="M217.3,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C218.6,237,217.3,238.3,217.3,239.8z"
        />
        <path
          className="st0"
          d="M193.2,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C194.4,195.2,193.2,196.4,193.2,198z"
        />
        <path
          className="st0"
          d="M217.3,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C218.6,125.5,217.3,126.7,217.3,128.3z"
        />
        <path
          className="st0"
          d="M271.6,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C272.9,240.5,271.6,241.8,271.6,243.3z"
        />
        <path
          className="st0"
          d="M271.6,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,219.6,271.6,220.8,271.6,222.4z"
        />
        <path
          className="st0"
          d="M271.6,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C272.9,212.6,271.6,213.9,271.6,215.4z"
        />
        <path
          className="st0"
          d="M271.6,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,233.5,271.6,234.8,271.6,236.3z"
        />
        <path
          className="st0"
          d="M271.6,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,226.6,271.6,227.8,271.6,229.4z"
        />
        <path
          className="st0"
          d="M271.6,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,191.7,271.6,193,271.6,194.5z"
        />
        <path
          className="st0"
          d="M271.6,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,198.7,271.6,199.9,271.6,201.5z"
        />
        <path
          className="st0"
          d="M271.6,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C272.9,205.6,271.6,206.9,271.6,208.4z"
        />
        <path
          className="st0"
          d="M271.6,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,184.7,271.6,186,271.6,187.5z"
        />
        <path
          className="st0"
          d="M277.7,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,90.6,277.7,91.9,277.7,93.4z"
        />
        <path
          className="st0"
          d="M277.7,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,83.7,277.7,84.9,277.7,86.5z"
        />
        <path
          className="st0"
          d="M277.7,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,97.6,277.7,98.9,277.7,100.4z"
        />
        <path
          className="st0"
          d="M193.2,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C194.4,146.4,193.2,147.7,193.2,149.2z"
        />
        <path
          className="st0"
          d="M277.7,260.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,257.9,277.7,259.2,277.7,260.7z"
        />
        <path
          className="st0"
          d="M271.6,250.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,247.5,271.6,248.7,271.6,250.3z"
        />
        <path
          className="st0"
          d="M271.6,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,122,271.6,123.3,271.6,124.8z"
        />
        <path
          className="st0"
          d="M271.6,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,129,271.6,130.2,271.6,131.8z"
        />
        <path
          className="st0"
          d="M271.6,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,108.1,271.6,109.3,271.6,110.9z"
        />
        <path
          className="st0"
          d="M271.6,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,177.8,271.6,179,271.6,180.6z"
        />
        <path
          className="st0"
          d="M271.6,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,115,271.6,116.3,271.6,117.8z"
        />
        <path
          className="st0"
          d="M271.6,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,94.1,271.6,95.4,271.6,96.9z"
        />
        <path
          className="st0"
          d="M271.6,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,101.1,271.6,102.3,271.6,103.9z"
        />
        <path
          className="st0"
          d="M271.6,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,87.1,271.6,88.4,271.6,89.9z"
        />
        <path
          className="st0"
          d="M271.6,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,156.8,271.6,158.1,271.6,159.7z"
        />
        <path
          className="st0"
          d="M271.6,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,163.8,271.6,165.1,271.6,166.6z"
        />
        <path
          className="st0"
          d="M271.6,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,135.9,271.6,137.2,271.6,138.7z"
        />
        <path
          className="st0"
          d="M271.6,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,170.8,271.6,172,271.6,173.6z"
        />
        <path
          className="st0"
          d="M271.6,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,149.9,271.6,151.1,271.6,152.7z"
        />
        <path
          className="st0"
          d="M271.6,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C272.9,142.9,271.6,144.2,271.6,145.7z"
        />
        <path
          className="st0"
          d="M265.6,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,118.5,265.6,119.8,265.6,121.3z"
        />
        <path
          className="st0"
          d="M259.6,201.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,199.9,259.6,201.5z"
        />
        <path
          className="st0"
          d="M259.6,222.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,220.8,259.6,222.4z"
        />
        <path
          className="st0"
          d="M259.6,215.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S259.6,213.9,259.6,215.4z"
        />
        <path
          className="st0"
          d="M259.6,173.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,172,259.6,173.6z"
        />
        <path
          className="st0"
          d="M259.6,180.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,179,259.6,180.6z"
        />
        <path
          className="st0"
          d="M259.6,187.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,186,259.6,187.5z"
        />
        <path
          className="st0"
          d="M259.6,194.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,193,259.6,194.5z"
        />
        <path
          className="st0"
          d="M259.6,208.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S259.6,206.9,259.6,208.4z"
        />
        <path
          className="st0"
          d="M259.6,250.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,248.7,259.6,250.3z"
        />
        <path
          className="st0"
          d="M259.6,257.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,255.7,259.6,257.2z"
        />
        <path
          className="st0"
          d="M265.6,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,111.5,265.6,112.8,265.6,114.3z"
        />
        <path
          className="st0"
          d="M277.7,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,104.6,277.7,105.8,277.7,107.4z"
        />
        <path
          className="st0"
          d="M259.6,229.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,227.8,259.6,229.4z"
        />
        <path
          className="st0"
          d="M259.6,243.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S259.6,241.8,259.6,243.3z"
        />
        <path
          className="st0"
          d="M259.6,236.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,234.8,259.6,236.3z"
        />
        <path
          className="st0"
          d="M259.6,103.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,102.3,259.6,103.9z"
        />
        <path
          className="st0"
          d="M259.6,166.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,165.1,259.6,166.6z"
        />
        <path
          className="st0"
          d="M259.6,110.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,109.3,259.6,110.9z"
        />
        <path
          className="st0"
          d="M259.6,13.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S259.6,11.7,259.6,13.3z"
        />
        <path
          className="st0"
          d="M241.5,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8S245.8,0,244.3,0C242.7,0,241.5,1.3,241.5,2.8z"
        />
        <path
          className="st0"
          d="M247.5,13.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C248.7,10.5,247.5,11.7,247.5,13.3z
		"
        />
        <path
          className="st0"
          d="M265.6,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,97.6,265.6,98.9,265.6,100.4z"
        />
        <path
          className="st0"
          d="M259.6,117.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,116.3,259.6,117.8z"
        />
        <path
          className="st0"
          d="M259.6,96.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,95.4,259.6,96.9z"
        />
        <path
          className="st0"
          d="M259.6,124.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,123.3,259.6,124.8z"
        />
        <path
          className="st0"
          d="M259.6,152.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,151.1,259.6,152.7z"
        />
        <path
          className="st0"
          d="M259.6,159.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,158.1,259.6,159.7z"
        />
        <path
          className="st0"
          d="M259.6,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,144.2,259.6,145.7z"
        />
        <path
          className="st0"
          d="M259.6,138.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,137.2,259.6,138.7z"
        />
        <path
          className="st0"
          d="M259.6,131.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S259.6,130.2,259.6,131.8z"
        />
        <path
          className="st0"
          d="M193.2,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C194.4,90.6,193.2,91.9,193.2,93.4z"
        />
        <path
          className="st0"
          d="M199.2,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C200.5,87.1,199.2,88.4,199.2,89.9z"
        />
        <path
          className="st0"
          d="M205.2,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,83.7,205.2,84.9,205.2,86.5z"
        />
        <path
          className="st0"
          d="M265.6,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C266.9,223.1,265.6,224.3,265.6,225.9z"
        />
        <path
          className="st0"
          d="M265.6,246.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,244,265.6,245.2,265.6,246.8z"
        />
        <path
          className="st0"
          d="M193.2,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C194.4,209.1,193.2,210.4,193.2,211.9z"
        />
        <path
          className="st0"
          d="M265.6,253.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,251,265.6,252.2,265.6,253.8z"
        />
        <path
          className="st0"
          d="M193.2,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C194.4,139.4,193.2,140.7,193.2,142.2z"
        />
        <path
          className="st0"
          d="M265.6,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,230,265.6,231.3,265.6,232.8z"
        />
        <path
          className="st0"
          d="M265.6,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,237,265.6,238.3,265.6,239.8z"
        />
        <path
          className="st0"
          d="M235.4,48.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C236.7,45.3,235.4,46.6,235.4,48.1z
		"
        />
        <path
          className="st0"
          d="M193.2,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C194.4,125.5,193.2,126.7,193.2,128.3z"
        />
        <path
          className="st0"
          d="M193.2,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C194.4,132.5,193.2,133.7,193.2,135.3z"
        />
        <path
          className="st0"
          d="M193.2,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C194.4,97.6,193.2,98.9,193.2,100.4z"
        />
        <path
          className="st0"
          d="M193.2,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C194.4,118.5,193.2,119.8,193.2,121.3z"
        />
        <path
          className="st0"
          d="M193.2,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C194.4,104.6,193.2,105.8,193.2,107.4z"
        />
        <path
          className="st0"
          d="M193.2,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C194.4,111.5,193.2,112.8,193.2,114.3z"
        />
        <path
          className="st0"
          d="M265.6,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C266.9,139.4,265.6,140.7,265.6,142.2z"
        />
        <path
          className="st0"
          d="M265.6,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C266.9,167.3,265.6,168.6,265.6,170.1z"
        />
        <path
          className="st0"
          d="M265.6,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,146.4,265.6,147.7,265.6,149.2z"
        />
        <path
          className="st0"
          d="M265.6,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C266.9,160.3,265.6,161.6,265.6,163.1z"
        />
        <path
          className="st0"
          d="M265.6,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C266.9,153.4,265.6,154.6,265.6,156.2z"
        />
        <path
          className="st0"
          d="M265.6,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,132.5,265.6,133.7,265.6,135.3z"
        />
        <path
          className="st0"
          d="M265.6,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,125.5,265.6,126.7,265.6,128.3z"
        />
        <path
          className="st0"
          d="M265.6,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,216.1,265.6,217.4,265.6,218.9z"
        />
        <path
          className="st0"
          d="M265.6,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,195.2,265.6,196.4,265.6,198z"
        />
        <path
          className="st0"
          d="M265.6,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C266.9,174.3,265.6,175.5,265.6,177.1z"
        />
        <path
          className="st0"
          d="M265.6,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,209.1,265.6,210.4,265.6,211.9z"
        />
        <path
          className="st0"
          d="M265.6,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C266.9,202.2,265.6,203.4,265.6,205z
		"
        />
        <path
          className="st0"
          d="M265.6,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C266.9,188.2,265.6,189.5,265.6,191z
		"
        />
        <path
          className="st0"
          d="M265.6,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C266.9,181.2,265.6,182.5,265.6,184.1z"
        />
        <path
          className="st0"
          d="M277.7,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,132.5,277.7,133.7,277.7,135.3z"
        />
        <path
          className="st0"
          d="M289.8,86.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,84.9,289.8,86.5z"
        />
        <path
          className="st0"
          d="M338.1,260.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,257.9,338.1,259.2,338.1,260.7z"
        />
        <path
          className="st0"
          d="M289.8,114.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,112.8,289.8,114.3z"
        />
        <path
          className="st0"
          d="M295.8,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,87.1,295.8,88.4,295.8,89.9z"
        />
        <path
          className="st0"
          d="M289.8,107.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,105.8,289.8,107.4z"
        />
        <path
          className="st0"
          d="M289.8,100.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,98.9,289.8,100.4z"
        />
        <path
          className="st0"
          d="M338.1,253.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C339.3,251,338.1,252.2,338.1,253.8z"
        />
        <path
          className="st0"
          d="M289.8,79.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S289.8,77.9,289.8,79.5z"
        />
        <path
          className="st0"
          d="M295.8,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C297,73.2,295.8,74.5,295.8,76z"
        />
        <path
          className="st0"
          d="M295.8,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C297,80.2,295.8,81.4,295.8,83z"
        />
        <path
          className="st0"
          d="M295.8,69c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C297,66.2,295.8,67.5,295.8,69z"
        />
        <path
          className="st0"
          d="M295.8,34.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C297,31.4,295.8,32.6,295.8,34.2z"
        />
        <path
          className="st0"
          d="M301.8,37.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,36.1,301.8,37.7z"
        />
        <path
          className="st0"
          d="M289.8,93.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,91.9,289.8,93.4z"
        />
        <path
          className="st0"
          d="M289.8,170.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S289.8,168.6,289.8,170.1z"
        />
        <path
          className="st0"
          d="M289.8,184.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S289.8,182.5,289.8,184.1z"
        />
        <path
          className="st0"
          d="M289.8,177.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S289.8,175.5,289.8,177.1z"
        />
        <path
          className="st0"
          d="M289.8,191c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S289.8,189.5,289.8,191z"
        />
        <path
          className="st0"
          d="M289.8,198c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,196.4,289.8,198z"
        />
        <path
          className="st0"
          d="M289.8,205c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S289.8,203.4,289.8,205z"
        />
        <path
          className="st0"
          d="M289.8,142.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S289.8,140.7,289.8,142.2z"
        />
        <path
          className="st0"
          d="M289.8,121.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,119.8,289.8,121.3z"
        />
        <path
          className="st0"
          d="M289.8,135.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,133.7,289.8,135.3z"
        />
        <path
          className="st0"
          d="M289.8,128.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,126.7,289.8,128.3z"
        />
        <path
          className="st0"
          d="M289.8,163.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S289.8,161.6,289.8,163.1z"
        />
        <path
          className="st0"
          d="M289.8,156.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S289.8,154.6,289.8,156.2z"
        />
        <path
          className="st0"
          d="M289.8,149.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,147.7,289.8,149.2z"
        />
        <path
          className="st0"
          d="M295.8,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,198.7,295.8,199.9,295.8,201.5z"
        />
        <path
          className="st0"
          d="M295.8,250.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,247.5,295.8,248.7,295.8,250.3z"
        />
        <path
          className="st0"
          d="M295.8,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,226.6,295.8,227.8,295.8,229.4z"
        />
        <path
          className="st0"
          d="M295.8,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,233.5,295.8,234.8,295.8,236.3z"
        />
        <path
          className="st0"
          d="M295.8,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,219.6,295.8,220.8,295.8,222.4z"
        />
        <path
          className="st0"
          d="M295.8,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C297,212.6,295.8,213.9,295.8,215.4z"
        />
        <path
          className="st0"
          d="M277.7,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,111.5,277.7,112.8,277.7,114.3z"
        />
        <path
          className="st0"
          d="M295.8,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C297,205.6,295.8,206.9,295.8,208.4z"
        />
        <path
          className="st0"
          d="M301.8,79.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S301.8,77.9,301.8,79.5z"
        />
        <path
          className="st0"
          d="M301.8,93.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,91.9,301.8,93.4z"
        />
        <path
          className="st0"
          d="M301.8,86.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,84.9,301.8,86.5z"
        />
        <path
          className="st0"
          d="M301.8,100.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,98.9,301.8,100.4z"
        />
        <path
          className="st0"
          d="M295.8,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,191.7,295.8,193,295.8,194.5z"
        />
        <path
          className="st0"
          d="M295.8,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,94.1,295.8,95.4,295.8,96.9z"
        />
        <path
          className="st0"
          d="M301.8,72.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,71,301.8,72.5z"
        />
        <path
          className="st0"
          d="M295.8,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C297,240.5,295.8,241.8,295.8,243.3z"
        />
        <path
          className="st0"
          d="M295.8,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,115,295.8,116.3,295.8,117.8z"
        />
        <path
          className="st0"
          d="M295.8,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,135.9,295.8,137.2,295.8,138.7z"
        />
        <path
          className="st0"
          d="M295.8,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,129,295.8,130.2,295.8,131.8z"
        />
        <path
          className="st0"
          d="M295.8,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,122,295.8,123.3,295.8,124.8z"
        />
        <path
          className="st0"
          d="M295.8,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,108.1,295.8,109.3,295.8,110.9z"
        />
        <path
          className="st0"
          d="M295.8,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,101.1,295.8,102.3,295.8,103.9z"
        />
        <path
          className="st0"
          d="M295.8,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,149.9,295.8,151.1,295.8,152.7z"
        />
        <path
          className="st0"
          d="M295.8,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,142.9,295.8,144.2,295.8,145.7z"
        />
        <path
          className="st0"
          d="M295.8,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,177.8,295.8,179,295.8,180.6z"
        />
        <path
          className="st0"
          d="M295.8,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,163.8,295.8,165.1,295.8,166.6z"
        />
        <path
          className="st0"
          d="M295.8,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,170.8,295.8,172,295.8,173.6z"
        />
        <path
          className="st0"
          d="M295.8,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,156.8,295.8,158.1,295.8,159.7z"
        />
        <path
          className="st0"
          d="M295.8,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C297,184.7,295.8,186,295.8,187.5z"
        />
        <path
          className="st0"
          d="M289.8,211.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,210.4,289.8,211.9z"
        />
        <path
          className="st0"
          d="M283.7,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C285,73.2,283.7,74.5,283.7,76z"
        />
        <path
          className="st0"
          d="M187.1,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,198.7,187.1,199.9,187.1,201.5z"
        />
        <path
          className="st0"
          d="M283.7,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,219.6,283.7,220.8,283.7,222.4z"
        />
        <path
          className="st0"
          d="M277.7,253.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,251,277.7,252.2,277.7,253.8z"
        />
        <path
          className="st0"
          d="M277.7,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,230,277.7,231.3,277.7,232.8z"
        />
        <path
          className="st0"
          d="M277.7,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,216.1,277.7,217.4,277.7,218.9z"
        />
        <path
          className="st0"
          d="M277.7,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C278.9,223.1,277.7,224.3,277.7,225.9z"
        />
        <path
          className="st0"
          d="M283.7,257.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,254.4,283.7,255.7,283.7,257.2z"
        />
        <path
          className="st0"
          d="M283.7,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C285,240.5,283.7,241.8,283.7,243.3z"
        />
        <path
          className="st0"
          d="M283.7,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,233.5,283.7,234.8,283.7,236.3z"
        />
        <path
          className="st0"
          d="M283.7,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,226.6,283.7,227.8,283.7,229.4z"
        />
        <path
          className="st0"
          d="M283.7,250.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,247.5,283.7,248.7,283.7,250.3z"
        />
        <path
          className="st0"
          d="M277.7,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,209.1,277.7,210.4,277.7,211.9z"
        />
        <path
          className="st0"
          d="M283.7,264.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,261.4,283.7,262.7,283.7,264.2z"
        />
        <path
          className="st0"
          d="M277.7,246.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,244,277.7,245.2,277.7,246.8z"
        />
        <path
          className="st0"
          d="M277.7,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C278.9,153.4,277.7,154.6,277.7,156.2z"
        />
        <path
          className="st0"
          d="M265.6,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,104.6,265.6,105.8,265.6,107.4z"
        />
        <path
          className="st0"
          d="M277.7,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,146.4,277.7,147.7,277.7,149.2z"
        />
        <path
          className="st0"
          d="M277.7,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C278.9,139.4,277.7,140.7,277.7,142.2z"
        />
        <path
          className="st0"
          d="M277.7,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,125.5,277.7,126.7,277.7,128.3z"
        />
        <path
          className="st0"
          d="M277.7,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,118.5,277.7,119.8,277.7,121.3z"
        />
        <path
          className="st0"
          d="M277.7,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C278.9,188.2,277.7,189.5,277.7,191z
		"
        />
        <path
          className="st0"
          d="M277.7,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C278.9,202.2,277.7,203.4,277.7,205z
		"
        />
        <path
          className="st0"
          d="M277.7,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C278.9,160.3,277.7,161.6,277.7,163.1z"
        />
        <path
          className="st0"
          d="M277.7,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C278.9,181.2,277.7,182.5,277.7,184.1z"
        />
        <path
          className="st0"
          d="M277.7,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,195.2,277.7,196.4,277.7,198z"
        />
        <path
          className="st0"
          d="M277.7,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C278.9,174.3,277.7,175.5,277.7,177.1z"
        />
        <path
          className="st0"
          d="M277.7,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C278.9,167.3,277.7,168.6,277.7,170.1z"
        />
        <path
          className="st0"
          d="M289.8,246.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,245.2,289.8,246.8z"
        />
        <path
          className="st0"
          d="M283.7,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C285,80.2,283.7,81.4,283.7,83z"
        />
        <path
          className="st0"
          d="M283.7,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,87.1,283.7,88.4,283.7,89.9z"
        />
        <path
          className="st0"
          d="M283.7,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,94.1,283.7,95.4,283.7,96.9z"
        />
        <path
          className="st0"
          d="M283.7,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,108.1,283.7,109.3,283.7,110.9z"
        />
        <path
          className="st0"
          d="M283.7,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,101.1,283.7,102.3,283.7,103.9z"
        />
        <path
          className="st0"
          d="M289.8,72.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,71,289.8,72.5z"
        />
        <path
          className="st0"
          d="M283.7,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,115,283.7,116.3,283.7,117.8z"
        />
        <path
          className="st0"
          d="M283.7,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C285,212.6,283.7,213.9,283.7,215.4z"
        />
        <path
          className="st0"
          d="M289.8,239.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,238.3,289.8,239.8z"
        />
        <path
          className="st0"
          d="M289.8,225.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S289.8,224.3,289.8,225.9z"
        />
        <path
          className="st0"
          d="M289.8,218.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,217.4,289.8,218.9z"
        />
        <path
          className="st0"
          d="M289.8,260.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,259.2,289.8,260.7z"
        />
        <path
          className="st0"
          d="M289.8,253.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,252.2,289.8,253.8z"
        />
        <path
          className="st0"
          d="M289.8,232.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S289.8,231.3,289.8,232.8z"
        />
        <path
          className="st0"
          d="M283.7,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,191.7,283.7,193,283.7,194.5z"
        />
        <path
          className="st0"
          d="M283.7,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,184.7,283.7,186,283.7,187.5z"
        />
        <path
          className="st0"
          d="M283.7,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,170.8,283.7,172,283.7,173.6z"
        />
        <path
          className="st0"
          d="M283.7,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,177.8,283.7,179,283.7,180.6z"
        />
        <path
          className="st0"
          d="M283.7,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C285,205.6,283.7,206.9,283.7,208.4z"
        />
        <path
          className="st0"
          d="M283.7,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,198.7,283.7,199.9,283.7,201.5z"
        />
        <path
          className="st0"
          d="M283.7,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,122,283.7,123.3,283.7,124.8z"
        />
        <path
          className="st0"
          d="M283.7,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,163.8,283.7,165.1,283.7,166.6z"
        />
        <path
          className="st0"
          d="M283.7,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,135.9,283.7,137.2,283.7,138.7z"
        />
        <path
          className="st0"
          d="M283.7,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,129,283.7,130.2,283.7,131.8z"
        />
        <path
          className="st0"
          d="M283.7,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,142.9,283.7,144.2,283.7,145.7z"
        />
        <path
          className="st0"
          d="M283.7,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,149.9,283.7,151.1,283.7,152.7z"
        />
        <path
          className="st0"
          d="M283.7,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C285,156.8,283.7,158.1,283.7,159.7z"
        />
        <path
          className="st0"
          d="M277.7,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C278.9,237,277.7,238.3,277.7,239.8z"
        />
        <path
          className="st0"
          d="M199.2,124.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,123.3,199.2,124.8z"
        />
        <path
          className="st0"
          d="M199.2,173.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,172,199.2,173.6z"
        />
        <path
          className="st0"
          d="M199.2,166.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,165.1,199.2,166.6z"
        />
        <path
          className="st0"
          d="M199.2,159.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,158.1,199.2,159.7z"
        />
        <path
          className="st0"
          d="M199.2,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,144.2,199.2,145.7z"
        />
        <path
          className="st0"
          d="M199.2,131.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,130.2,199.2,131.8z"
        />
        <circle className="st0" cx="202" cy="138.7" r="2.8" />
        <path
          className="st0"
          d="M199.2,152.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,151.1,199.2,152.7z"
        />
        <path
          className="st0"
          d="M199.2,201.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,199.9,199.2,201.5z"
        />
        <path
          className="st0"
          d="M199.2,208.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S199.2,206.9,199.2,208.4z"
        />
        <path
          className="st0"
          d="M205.2,58.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C206.5,55.8,205.2,57,205.2,58.6z"
        />
        <path
          className="st0"
          d="M205.2,65.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,62.7,205.2,64,205.2,65.5z"
        />
        <path
          className="st0"
          d="M211.3,55.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C212.5,52.3,211.3,53.5,211.3,55.1z
		"
        />
        <path
          className="st0"
          d="M199.2,194.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,193,199.2,194.5z"
        />
        <path
          className="st0"
          d="M199.2,187.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,186,199.2,187.5z"
        />
        <path
          className="st0"
          d="M199.2,180.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,179,199.2,180.6z"
        />
        <path
          className="st0"
          d="M199.2,62.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S199.2,60.5,199.2,62.1z"
        />
        <path
          className="st0"
          d="M211.3,222.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,220.8,211.3,222.4z"
        />
        <path
          className="st0"
          d="M211.3,215.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S211.3,213.9,211.3,215.4z"
        />
        <path
          className="st0"
          d="M211.3,194.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,193,211.3,194.5z"
        />
        <path
          className="st0"
          d="M211.3,208.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S211.3,206.9,211.3,208.4z"
        />
        <path
          className="st0"
          d="M211.3,201.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,199.9,211.3,201.5z"
        />
        <path
          className="st0"
          d="M211.3,229.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,227.8,211.3,229.4z"
        />
        <path
          className="st0"
          d="M211.3,236.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,234.8,211.3,236.3z"
        />
        <path
          className="st0"
          d="M199.2,103.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,102.3,199.2,103.9z"
        />
        <path
          className="st0"
          d="M199.2,96.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,95.4,199.2,96.9z"
        />
        <circle className="st0" cx="202" cy="110.9" r="2.8" />
        <path
          className="st0"
          d="M199.2,69c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,67.5,199.2,69z"
        />
        <path
          className="st0"
          d="M199.2,76c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C200.4,73.2,199.2,74.5,199.2,76z"
        />
        <path
          className="st0"
          d="M205.2,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,90.6,205.2,91.9,205.2,93.4z"
        />
        <path
          className="st0"
          d="M199.2,117.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S199.2,116.3,199.2,117.8z"
        />
        <path
          className="st0"
          d="M217.3,51.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C218.6,48.8,217.3,50.1,217.3,51.6z
		"
        />
        <path
          className="st0"
          d="M223.3,48.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C224.6,45.3,223.3,46.6,223.3,48.1z
		"
        />
        <path
          className="st0"
          d="M217.3,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C218.6,111.5,217.3,112.8,217.3,114.3z"
        />
        <path
          className="st0"
          d="M205.2,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,195.2,205.2,196.4,205.2,198z"
        />
        <path
          className="st0"
          d="M205.2,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C206.5,202.2,205.2,203.4,205.2,205z
		"
        />
        <path
          className="st0"
          d="M205.2,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,216.1,205.2,217.4,205.2,218.9z"
        />
        <path
          className="st0"
          d="M205.2,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,209.1,205.2,210.4,205.2,211.9z"
        />
        <path
          className="st0"
          d="M217.3,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C218.6,104.6,217.3,105.8,217.3,107.4z"
        />
        <path
          className="st0"
          d="M229.4,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,83.7,229.4,84.9,229.4,86.5z"
        />
        <path
          className="st0"
          d="M229.4,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,90.6,229.4,91.9,229.4,93.4z"
        />
        <path
          className="st0"
          d="M205.2,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,97.6,205.2,98.9,205.2,100.4z"
        />
        <path
          className="st0"
          d="M223.3,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,101.1,223.3,102.3,223.3,103.9z"
        />
        <path
          className="st0"
          d="M223.3,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,94.1,223.3,95.4,223.3,96.9z"
        />
        <path
          className="st0"
          d="M223.3,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,115,223.3,116.3,223.3,117.8z"
        />
        <path
          className="st0"
          d="M217.3,121.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S217.3,119.8,217.3,121.3z"
        />
        <path
          className="st0"
          d="M223.3,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,108.1,223.3,109.3,223.3,110.9z"
        />
        <path
          className="st0"
          d="M205.2,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,125.5,205.2,126.7,205.2,128.3z"
        />
        <path
          className="st0"
          d="M205.2,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,132.5,205.2,133.7,205.2,135.3z"
        />
        <path
          className="st0"
          d="M205.2,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C206.5,139.4,205.2,140.7,205.2,142.2z"
        />
        <path
          className="st0"
          d="M205.2,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,118.5,205.2,119.8,205.2,121.3z"
        />
        <path
          className="st0"
          d="M229.4,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,97.6,229.4,98.9,229.4,100.4z"
        />
        <path
          className="st0"
          d="M205.2,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,111.5,205.2,112.8,205.2,114.3z"
        />
        <path
          className="st0"
          d="M205.2,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C206.5,181.2,205.2,182.5,205.2,184.1z"
        />
        <path
          className="st0"
          d="M205.2,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C206.5,167.3,205.2,168.6,205.2,170.1z"
        />
        <path
          className="st0"
          d="M205.2,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C206.5,174.3,205.2,175.5,205.2,177.1z"
        />
        <path
          className="st0"
          d="M205.2,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C206.5,188.2,205.2,189.5,205.2,191z
		"
        />
        <path
          className="st0"
          d="M205.2,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,146.4,205.2,147.7,205.2,149.2z"
        />
        <path
          className="st0"
          d="M301.8,107.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S301.8,105.8,301.8,107.4z"
        />
        <path
          className="st0"
          d="M205.2,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C206.5,153.4,205.2,154.6,205.2,156.2z"
        />
        <path
          className="st0"
          d="M205.2,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C206.5,104.6,205.2,105.8,205.2,107.4z"
        />
        <path
          className="st0"
          d="M253.5,246.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,244,253.5,245.2,253.5,246.8z"
        />
        <path
          className="st0"
          d="M253.5,253.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,251,253.5,252.2,253.5,253.8z"
        />
        <path
          className="st0"
          d="M253.5,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,237,253.5,238.3,253.5,239.8z"
        />
        <path
          className="st0"
          d="M253.5,260.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,257.9,253.5,259.2,253.5,260.7z"
        />
        <path
          className="st0"
          d="M187.1,103.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,101.1,187.1,102.3,187.1,103.9z"
        />
        <path
          className="st0"
          d="M253.5,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,90.6,253.5,91.9,253.5,93.4z"
        />
        <path
          className="st0"
          d="M253.5,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,230,253.5,231.3,253.5,232.8z"
        />
        <path
          className="st0"
          d="M253.5,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C254.8,188.2,253.5,189.5,253.5,191z
		"
        />
        <path
          className="st0"
          d="M253.5,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,195.2,253.5,196.4,253.5,198z"
        />
        <path
          className="st0"
          d="M253.5,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C254.8,202.2,253.5,203.4,253.5,205z
		"
        />
        <path
          className="st0"
          d="M187.1,96.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,94.1,187.1,95.4,187.1,96.9z"
        />
        <path
          className="st0"
          d="M253.5,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,209.1,253.5,210.4,253.5,211.9z"
        />
        <path
          className="st0"
          d="M253.5,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,216.1,253.5,217.4,253.5,218.9z"
        />
        <path
          className="st0"
          d="M253.5,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C254.8,223.1,253.5,224.3,253.5,225.9z"
        />
        <path
          className="st0"
          d="M187.1,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,129,187.1,130.2,187.1,131.8z"
        />
        <path
          className="st0"
          d="M187.1,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,170.8,187.1,172,187.1,173.6z"
        />
        <path
          className="st0"
          d="M187.1,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,163.8,187.1,165.1,187.1,166.6z"
        />
        <path
          className="st0"
          d="M187.1,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,177.8,187.1,179,187.1,180.6z"
        />
        <path
          className="st0"
          d="M187.1,110.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,108.1,187.1,109.3,187.1,110.9z"
        />
        <path
          className="st0"
          d="M187.1,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,156.8,187.1,158.1,187.1,159.7z"
        />
        <path
          className="st0"
          d="M187.1,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,184.7,187.1,186,187.1,187.5z"
        />
        <path
          className="st0"
          d="M187.1,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,191.7,187.1,193,187.1,194.5z"
        />
        <path
          className="st0"
          d="M187.1,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,149.9,187.1,151.1,187.1,152.7z"
        />
        <path
          className="st0"
          d="M187.1,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,122,187.1,123.3,187.1,124.8z"
        />
        <path
          className="st0"
          d="M187.1,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,115,187.1,116.3,187.1,117.8z"
        />
        <path
          className="st0"
          d="M253.5,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C254.8,181.2,253.5,182.5,253.5,184.1z"
        />
        <path
          className="st0"
          d="M187.1,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,142.9,187.1,144.2,187.1,145.7z"
        />
        <path
          className="st0"
          d="M187.1,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C188.4,135.9,187.1,137.2,187.1,138.7z"
        />
        <path
          className="st0"
          d="M253.5,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,132.5,253.5,133.7,253.5,135.3z"
        />
        <path
          className="st0"
          d="M211.3,117.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,116.3,211.3,117.8z"
        />
        <path
          className="st0"
          d="M211.3,124.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,123.3,211.3,124.8z"
        />
        <circle className="st0" cx="214.1" cy="138.7" r="2.8" />
        <path
          className="st0"
          d="M211.3,131.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,130.2,211.3,131.8z"
        />
        <path
          className="st0"
          d="M211.3,103.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,102.3,211.3,103.9z"
        />
        <circle className="st0" cx="214.1" cy="110.9" r="2.8" />
        <path
          className="st0"
          d="M211.3,166.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,165.1,211.3,166.6z"
        />
        <path
          className="st0"
          d="M211.3,173.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,172,211.3,173.6z"
        />
        <path
          className="st0"
          d="M211.3,180.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,179,211.3,180.6z"
        />
        <path
          className="st0"
          d="M211.3,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,144.2,211.3,145.7z"
        />
        <path
          className="st0"
          d="M211.3,96.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,95.4,211.3,96.9z"
        />
        <path
          className="st0"
          d="M211.3,152.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,151.1,211.3,152.7z"
        />
        <path
          className="st0"
          d="M211.3,159.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,158.1,211.3,159.7z"
        />
        <path
          className="st0"
          d="M211.3,187.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S211.3,186,211.3,187.5z"
        />
        <path
          className="st0"
          d="M253.5,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C254.8,174.3,253.5,175.5,253.5,177.1z"
        />
        <path
          className="st0"
          d="M253.5,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C254.8,139.4,253.5,140.7,253.5,142.2z"
        />
        <path
          className="st0"
          d="M253.5,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C254.8,153.4,253.5,154.6,253.5,156.2z"
        />
        <path
          className="st0"
          d="M253.5,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,146.4,253.5,147.7,253.5,149.2z"
        />
        <path
          className="st0"
          d="M253.5,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C254.8,167.3,253.5,168.6,253.5,170.1z"
        />
        <path
          className="st0"
          d="M253.5,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C254.8,160.3,253.5,161.6,253.5,163.1z"
        />
        <path
          className="st0"
          d="M211.3,243.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S211.3,241.8,211.3,243.3z"
        />
        <path
          className="st0"
          d="M253.5,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,97.6,253.5,98.9,253.5,100.4z"
        />
        <path
          className="st0"
          d="M253.5,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,125.5,253.5,126.7,253.5,128.3z"
        />
        <path
          className="st0"
          d="M247.5,96.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,95.4,247.5,96.9z"
        />
        <path
          className="st0"
          d="M253.5,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,104.6,253.5,105.8,253.5,107.4z"
        />
        <path
          className="st0"
          d="M253.5,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,111.5,253.5,112.8,253.5,114.3z"
        />
        <path
          className="st0"
          d="M253.5,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C254.8,118.5,253.5,119.8,253.5,121.3z"
        />
        <path
          className="st0"
          d="M235.4,117.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,115,235.4,116.3,235.4,117.8z"
        />
        <path
          className="st0"
          d="M229.4,121.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S229.4,119.8,229.4,121.3z"
        />
        <path
          className="st0"
          d="M223.3,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,122,223.3,123.3,223.3,124.8z"
        />
        <path
          className="st0"
          d="M241.5,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C242.7,167.3,241.5,168.6,241.5,170.1z"
        />
        <path
          className="st0"
          d="M241.5,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C242.7,139.4,241.5,140.7,241.5,142.2z"
        />
        <path
          className="st0"
          d="M241.5,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C242.7,181.2,241.5,182.5,241.5,184.1z"
        />
        <path
          className="st0"
          d="M241.5,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,237,241.5,238.3,241.5,239.8z"
        />
        <path
          className="st0"
          d="M235.4,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,184.7,235.4,186,235.4,187.5z"
        />
        <path
          className="st0"
          d="M241.5,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,146.4,241.5,147.7,241.5,149.2z"
        />
        <path
          className="st0"
          d="M241.5,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C242.7,153.4,241.5,154.6,241.5,156.2z"
        />
        <path
          className="st0"
          d="M241.5,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C242.7,174.3,241.5,175.5,241.5,177.1z"
        />
        <path
          className="st0"
          d="M241.5,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C242.7,223.1,241.5,224.3,241.5,225.9z"
        />
        <path
          className="st0"
          d="M241.5,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,230,241.5,231.3,241.5,232.8z"
        />
        <path
          className="st0"
          d="M241.5,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,216.1,241.5,217.4,241.5,218.9z"
        />
        <path
          className="st0"
          d="M241.5,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,209.1,241.5,210.4,241.5,211.9z"
        />
        <path
          className="st0"
          d="M241.5,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,195.2,241.5,196.4,241.5,198z"
        />
        <path
          className="st0"
          d="M241.5,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C242.7,202.2,241.5,203.4,241.5,205z
		"
        />
        <path
          className="st0"
          d="M241.5,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C242.7,160.3,241.5,161.6,241.5,163.1z"
        />
        <path
          className="st0"
          d="M235.4,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C236.7,205.6,235.4,206.9,235.4,208.4z"
        />
        <path
          className="st0"
          d="M235.4,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C236.7,212.6,235.4,213.9,235.4,215.4z"
        />
        <path
          className="st0"
          d="M235.4,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,226.6,235.4,227.8,235.4,229.4z"
        />
        <path
          className="st0"
          d="M235.4,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,198.7,235.4,199.9,235.4,201.5z"
        />
        <path
          className="st0"
          d="M235.4,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,191.7,235.4,193,235.4,194.5z"
        />
        <path
          className="st0"
          d="M235.4,257.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,254.4,235.4,255.7,235.4,257.2z"
        />
        <path
          className="st0"
          d="M235.4,250.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,247.5,235.4,248.7,235.4,250.3z"
        />
        <path
          className="st0"
          d="M235.4,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,233.5,235.4,234.8,235.4,236.3z"
        />
        <path
          className="st0"
          d="M241.5,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,125.5,241.5,126.7,241.5,128.3z"
        />
        <path
          className="st0"
          d="M241.5,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,132.5,241.5,133.7,241.5,135.3z"
        />
        <path
          className="st0"
          d="M235.4,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C236.7,240.5,235.4,241.8,235.4,243.3z"
        />
        <path
          className="st0"
          d="M241.5,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C242.7,188.2,241.5,189.5,241.5,191z
		"
        />
        <path
          className="st0"
          d="M247.5,201.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,199.9,247.5,201.5z"
        />
        <path
          className="st0"
          d="M247.5,208.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S247.5,206.9,247.5,208.4z"
        />
        <path
          className="st0"
          d="M247.5,215.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S247.5,213.9,247.5,215.4z"
        />
        <path
          className="st0"
          d="M247.5,194.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,193,247.5,194.5z"
        />
        <path
          className="st0"
          d="M247.5,180.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,179,247.5,180.6z"
        />
        <path
          className="st0"
          d="M247.5,222.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,220.8,247.5,222.4z"
        />
        <path
          className="st0"
          d="M247.5,187.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,186,247.5,187.5z"
        />
        <path
          className="st0"
          d="M241.5,246.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,244,241.5,245.2,241.5,246.8z"
        />
        <path
          className="st0"
          d="M247.5,257.2c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,255.7,247.5,257.2z"
        />
        <path
          className="st0"
          d="M247.5,250.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,248.7,247.5,250.3z"
        />
        <path
          className="st0"
          d="M265.6,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,83.7,265.6,84.9,265.6,86.5z"
        />
        <path
          className="st0"
          d="M247.5,236.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,234.8,247.5,236.3z"
        />
        <path
          className="st0"
          d="M247.5,243.3c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S247.5,241.8,247.5,243.3z"
        />
        <path
          className="st0"
          d="M247.5,173.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,172,247.5,173.6z"
        />
        <path
          className="st0"
          d="M247.5,229.4c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,227.8,247.5,229.4z"
        />
        <path
          className="st0"
          d="M247.5,166.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,165.1,247.5,166.6z"
        />
        <path
          className="st0"
          d="M247.5,110.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,109.3,247.5,110.9z"
        />
        <path
          className="st0"
          d="M247.5,48.1c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8S247.5,46.6,247.5,48.1z"
        />
        <path
          className="st0"
          d="M247.5,117.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,116.3,247.5,117.8z"
        />
        <path
          className="st0"
          d="M241.5,260.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,257.9,241.5,259.2,241.5,260.7z"
        />
        <path
          className="st0"
          d="M241.5,253.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,251,241.5,252.2,241.5,253.8z"
        />
        <path
          className="st0"
          d="M247.5,103.9c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,102.3,247.5,103.9z"
        />
        <path
          className="st0"
          d="M241.5,100.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C242.7,97.6,241.5,98.8,241.5,100.4z"
        />
        <path
          className="st0"
          d="M247.5,152.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,151.1,247.5,152.7z"
        />
        <path
          className="st0"
          d="M247.5,145.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,144.2,247.5,145.7z"
        />
        <path
          className="st0"
          d="M247.5,159.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,158.1,247.5,159.7z"
        />
        <path
          className="st0"
          d="M247.5,131.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,130.2,247.5,131.8z"
        />
        <path
          className="st0"
          d="M247.5,138.7c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,137.2,247.5,138.7z"
        />
        <path
          className="st0"
          d="M247.5,124.8c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8S247.5,123.3,247.5,124.8z"
        />
        <path
          className="st0"
          d="M241.5,121.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,118.5,241.5,119.8,241.5,121.3z"
        />
        <path
          className="st0"
          d="M235.4,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,219.6,235.4,220.8,235.4,222.4z"
        />
        <path
          className="st0"
          d="M223.3,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,177.8,223.3,179,223.3,180.6z"
        />
        <path
          className="st0"
          d="M223.3,187.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,184.7,223.3,186,223.3,187.5z"
        />
        <path
          className="st0"
          d="M223.3,194.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,191.7,223.3,193,223.3,194.5z"
        />
        <path
          className="st0"
          d="M229.4,128.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,125.5,229.4,126.7,229.4,128.3z"
        />
        <path
          className="st0"
          d="M223.3,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,156.8,223.3,158.1,223.3,159.7z"
        />
        <path
          className="st0"
          d="M223.3,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,163.8,223.3,165.1,223.3,166.6z"
        />
        <path
          className="st0"
          d="M223.3,201.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,198.7,223.3,199.9,223.3,201.5z"
        />
        <path
          className="st0"
          d="M223.3,222.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,219.6,223.3,220.8,223.3,222.4z"
        />
        <path
          className="st0"
          d="M223.3,208.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C224.6,205.6,223.3,206.9,223.3,208.4z"
        />
        <path
          className="st0"
          d="M223.3,243.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C224.6,240.5,223.3,241.8,223.3,243.3z"
        />
        <path
          className="st0"
          d="M223.3,236.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,233.5,223.3,234.8,223.3,236.3z"
        />
        <path
          className="st0"
          d="M223.3,229.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,226.6,223.3,227.8,223.3,229.4z"
        />
        <path
          className="st0"
          d="M223.3,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,149.9,223.3,151.1,223.3,152.7z"
        />
        <path
          className="st0"
          d="M223.3,215.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C224.6,212.6,223.3,213.9,223.3,215.4z"
        />
        <path
          className="st0"
          d="M223.3,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,170.8,223.3,172,223.3,173.6z"
        />
        <path
          className="st0"
          d="M235.4,180.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,177.8,235.4,179,235.4,180.6z"
        />
        <path
          className="st0"
          d="M241.5,86.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,83.7,241.5,84.9,241.5,86.5z"
        />
        <path
          className="st0"
          d="M241.5,79.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C242.7,76.7,241.5,77.9,241.5,79.5z
		"
        />
        <path
          className="st0"
          d="M241.5,51.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C242.7,48.8,241.5,50.1,241.5,51.6z
		"
        />
        <path
          className="st0"
          d="M229.4,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,104.6,229.4,105.8,229.4,107.4z"
        />
        <path
          className="st0"
          d="M229.4,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,111.5,229.4,112.8,229.4,114.3z"
        />
        <path
          className="st0"
          d="M223.3,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,142.9,223.3,144.2,223.3,145.7z"
        />
        <path
          className="st0"
          d="M241.5,107.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,104.6,241.5,105.8,241.5,107.4z"
        />
        <path
          className="st0"
          d="M241.5,114.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C242.7,111.5,241.5,112.8,241.5,114.3z"
        />
        <path
          className="st0"
          d="M223.3,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,87.1,223.3,88.4,223.3,89.9z"
        />
        <path
          className="st0"
          d="M223.3,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,129,223.3,130.2,223.3,131.8z"
        />
        <path
          className="st0"
          d="M223.3,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C224.6,135.9,223.3,137.2,223.3,138.7z"
        />
        <path
          className="st0"
          d="M229.4,51.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C230.6,48.8,229.4,50.1,229.4,51.6z
		"
        />
        <path
          className="st0"
          d="M235.4,83c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C236.7,80.2,235.4,81.4,235.4,83
		z"
        />
        <path
          className="st0"
          d="M235.4,89.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,87.1,235.4,88.4,235.4,89.9z"
        />
        <path
          className="st0"
          d="M265.6,93.4c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C266.9,90.6,265.6,91.9,265.6,93.4z"
        />
        <path
          className="st0"
          d="M235.4,124.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,122,235.4,123.3,235.4,124.8z"
        />
        <path
          className="st0"
          d="M235.4,131.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,129,235.4,130.2,235.4,131.8z"
        />
        <path
          className="st0"
          d="M229.4,246.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,244,229.4,245.2,229.4,246.8z"
        />
        <path
          className="st0"
          d="M229.4,239.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,237,229.4,238.3,229.4,239.8z"
        />
        <path
          className="st0"
          d="M229.4,253.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,251,229.4,252.2,229.4,253.8z"
        />
        <path
          className="st0"
          d="M229.4,232.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,230,229.4,231.3,229.4,232.8z"
        />
        <path
          className="st0"
          d="M235.4,166.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,163.8,235.4,165.1,235.4,166.6z"
        />
        <path
          className="st0"
          d="M235.4,138.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,135.9,235.4,137.2,235.4,138.7z"
        />
        <path
          className="st0"
          d="M235.4,173.6c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,170.8,235.4,172,235.4,173.6z"
        />
        <path
          className="st0"
          d="M229.4,135.3c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,132.5,229.4,133.7,229.4,135.3z"
        />
        <path
          className="st0"
          d="M235.4,145.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,142.9,235.4,144.2,235.4,145.7z"
        />
        <path
          className="st0"
          d="M235.4,152.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,149.9,235.4,151.1,235.4,152.7z"
        />
        <path
          className="st0"
          d="M235.4,159.7c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C236.7,156.8,235.4,158.1,235.4,159.7z"
        />
        <path
          className="st0"
          d="M229.4,163.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C230.6,160.3,229.4,161.6,229.4,163.1z"
        />
        <path
          className="st0"
          d="M229.4,156.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C230.6,153.4,229.4,154.6,229.4,156.2z"
        />
        <path
          className="st0"
          d="M229.4,170.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C230.6,167.3,229.4,168.6,229.4,170.1z"
        />
        <path
          className="st0"
          d="M229.4,142.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C230.6,139.4,229.4,140.7,229.4,142.2z"
        />
        <path
          className="st0"
          d="M229.4,149.2c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,146.4,229.4,147.7,229.4,149.2z"
        />
        <path
          className="st0"
          d="M229.4,177.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C230.6,174.3,229.4,175.5,229.4,177.1z"
        />
        <path
          className="st0"
          d="M229.4,205c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C230.6,202.2,229.4,203.4,229.4,205z
		"
        />
        <path
          className="st0"
          d="M229.4,211.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,209.1,229.4,210.4,229.4,211.9z"
        />
        <path
          className="st0"
          d="M229.4,218.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,216.1,229.4,217.4,229.4,218.9z"
        />
        <path
          className="st0"
          d="M229.4,225.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C230.6,223.1,229.4,224.3,229.4,225.9z"
        />
        <path
          className="st0"
          d="M229.4,184.1c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8
		C230.6,181.2,229.4,182.5,229.4,184.1z"
        />
        <path
          className="st0"
          d="M229.4,191c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8s-1.3-2.8-2.8-2.8C230.6,188.2,229.4,189.5,229.4,191z
		"
        />
        <path
          className="st0"
          d="M229.4,198c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8
		C230.6,195.2,229.4,196.4,229.4,198z"
        />
      </g>
    </svg>
  );
};

export default Map;
